export const defaultLocale = {
  "dashboard-bi::edit-report::click_or_drop_dimension": "双击或拖拽维度字段到这里",
  "dashboard-bi::edit-report::area_num_tip": "存在数据区域重叠，请调整数据区域数值",
  "dashboard-bi::edit-report::add_condition": "添加条件",
  "dashboard-bi::edit-report::icon": "图标",
  "dashboard-bi::edit-report::color": "颜色",
  "dashboard-bi::edit-report::if_value": "如果值",
  "dashboard-bi::edit-report::set_condition": "设置条件格式",
  "dashboard-bi::edit-report::drill": "钻取",
  "account_binging_shop_exist_error": "该广告账户已绑定店铺",
  "account_binging_shop_exist_repeat": "广告与店铺重复绑定",
  "ACCOUNT_DISABLE": "账号已被冻结",
  "account_exist_error": "广告账号已存在",
  "account_insert_fail": "账号新增失败",
  "ACCOUNT_IS_EXPIRE": "您的套餐已过期！请前往续期",
  "account_name_is_exist": "paypal账号简称已存在",
  "account_not_exit": "广告账号不存在或已失效",
  "ACCOUNT_NUMBER_ALREADY_EXIST": "账号id已被注册,请更换账号",
  "ACCOUNT_STATUS_DISABLE": "账号被冻结，请联系管理员",
  "account_update_fail": "账号更新失败",
  "accountid_is_disable": "该accountId已被禁用",
  "ACTION_CODE_EXIST": "资源code已存在",
  "ACTION_PERM_NOT_EXIST": "菜单资源不存在",
  "ad_insights_query_error": "广告报表查询失败",
  "ad-analysis::adAccount": "广告账户",
  "ad-analysis::adGroup": "广告组",
  "ad-analysis::adName": "广告",
  "ad-analysis::adSeries": "广告系列",
  "ad-analysis::auth_tooltip": "设置广告账号即可呈现【广告分析】",
  "ad-analysis::cost_title": "广告花费",
  "ad-analysis::cost_tooltip": "广告的总费用",
  "ad-analysis::date": "日期",
  "ad-analysis::placeholder_account": "请选择广告账号",
  "ad-analysis::placeholder_data": "请选择数据指标",
  "ad-analysis::placeholder_shop": "请选择店铺",
  "ad-analysis::placeholder_type": "请选择广告系列",
  "ad-analysis::roi_tooltip": "计算公式：广告销额/广告费用，<br />统计广告类型：",
  "ad-analysis::sales_title": "广告销售额",
  "ad-analysis::sales_tooltip": "广告带来的收入",
  "ad-analysis::tab_all": "全部",
  "ad-analysis::table_addBuy": "加购量",
  "ad-analysis::table_addBuyCost": "加购成本",
  "ad-analysis::table_clickNum": "点击量",
  "ad-analysis::table_clickRate": "点击率",
  "ad-analysis::table_count": "发起结账量",
  "ad-analysis::table_countCost": "发起结账金额",
  "ad-analysis::table_coverNum": "覆盖人数",
  "ad-analysis::table_adcost": "广告花费",
  "ad-analysis::table_order": "订单数",
  "ad-analysis::table_sales": "销售金额",
  "ad-analysis::table_shopName": "店铺名称",
  "ad-analysis::table_transCost": "平均转化费用",
  "ad-analysis::table_transRate": "支付转化率",
  "ADMIN_PARAM_FAIL": "参数错误,请检查参数",
  "ADMIN_USER_DISABLE": "用户已被禁用,无法登录管理系统",
  "ADMIN_USER_NOT_FOUND": "系统未同步当前员工账号信息,请与管理员联系",
  "ADMIN_USER_TOKEN_INVALID": "用户令牌已失效",
  "ADMIN_VERIFY_JWT_ERROR": "用户令牌校验失败,请确认令牌是否正确",
  "after-sales::after-sale-list::add_after_sales_order": "新增售后单",
  "after-sales::after-sale-list::after_sale_reason": "售后原因",
  "after-sales::after-sale-list::after_sale_source": "售后来源",
  "after-sales::after-sale-list::after_sales_number": "售后单号",
  "after-sales::after-sale-list::applicant": "申请人",
  "after-sales::after-sale-list::application_time": "申请时间",
  "after-sales::after-sale-list::batch_application": "批量申请",
  "after-sales::after-sale-list::batch_refund": "批量退款",
  "after-sales::after-sale-list::detail_after_sale_type": "售后类型",
  "after-sales::after-sale-list::detail_applicant": "申请人",
  "after-sales::after-sale-list::detail_application_time": "申请时间",
  "after-sales::after-sale-list::detail_apply_refund": "申请退款",
  "after-sales::after-sale-list::detail_apply_refund_success": "申请退款成功",
  "after-sales::after-sale-list::detail_attachment": "附件",
  "after-sales::after-sale-list::detail_audit_time": "审核时间",
  "after-sales::after-sale-list::detail_auditor": "审核人",
  "after-sales::after-sale-list::detail_auto_refund_warning": "进行退款后系统将连接平台自动退款!",
  "after-sales::after-sale-list::detail_btn_cancel": "取消",
  "after-sales::after-sale-list::detail_btn_confirm": "确 定",
  "after-sales::after-sale-list::detail_download": "下载",
  "after-sales::after-sale-list::detail_email": "Email",
  "after-sales::after-sale-list::detail_fulfillment_status": "发货状态",
  "after-sales::after-sale-list::detail_order_correct": "请输入正确订单号",
  "after-sales::after-sale-list::detail_order_create_success": "生成售后单成功",
  "after-sales::after-sale-list::detail_order_info": "售后订单信息",
  "after-sales::after-sale-list::detail_order_num": "订单号",
  "after-sales::after-sale-list::detail_order_price_tips": "最多只能退款{amount}",
  "after-sales::after-sale-list::detail_order_refund_tips": "退款邮费最高只能退{amount}",
  "after-sales::after-sale-list::detail_order_select": "请选择子订单",
  "after-sales::after-sale-list::detail_order_update_success": "修改售后单成功",
  "after-sales::after-sale-list::detail_please_select": "请选择订单",
  "after-sales::after-sale-list::detail_refund": "退款",
  "after-sales::after-sale-list::detail_refund_apply_tips": "确定为以下售后订单申请退款吗",
  "after-sales::after-sale-list::detail_refund_confirm_tips": "确定提交申请退款吗？",
  "after-sales::after-sale-list::detail_refund_currency": "退款币种",
  "after-sales::after-sale-list::detail_refund_reason": "售后原因",
  "after-sales::after-sale-list::detail_refund_success": "退款成功",
  "after-sales::after-sale-list::detail_refund_time": "退款时间",
  "after-sales::after-sale-list::detail_refund_weather": "确定要进行退款吗",
  "after-sales::after-sale-list::detail_reject": "驳回",
  "after-sales::after-sale-list::detail_reject_success": "驳回成功",
  "after-sales::after-sale-list::detail_remark": "备注",
  "after-sales::after-sale-list::detail_return": "返回",
  "after-sales::after-sale-list::detail_sales_order_num": "售后单号",
  "after-sales::after-sale-list::detail_sales_order_refund_weather": "确定为以下售后订单退款吗",
  "after-sales::after-sale-list::detail_sales_resource": "售后来源",
  "after-sales::after-sale-list::detail_shop": "店铺",
  "after-sales::after-sale-list::detail_shop_order_num": "店铺订单号",
  "after-sales::after-sale-list::detail_table_after_sale_count": "售后数量",
  "after-sales::after-sale-list::detail_table_buy_count": "购买数量",
  "after-sales::after-sale-list::detail_table_discount": "优惠",
  "after-sales::after-sale-list::detail_table_email_price": "邮费",
  "after-sales::after-sale-list::detail_table_fullfill_status": "发货状态",
  "after-sales::after-sale-list::detail_table_has_sales": "有售后",
  "after-sales::after-sale-list::detail_table_no_sales": "无售后",
  "after-sales::after-sale-list::detail_table_price": "单价",
  "after-sales::after-sale-list::detail_table_refund": "退款",
  "after-sales::after-sale-list::detail_table_refund_email": "退款邮费",
  "after-sales::after-sale-list::detail_table_sales_total": "售后总金额",
  "after-sales::after-sale-list::detail_table_shop": "商品",
  "after-sales::after-sale-list::detail_table_status": "状态",
  "after-sales::after-sale-list::detail_table_sub_order": "子订单",
  "after-sales::after-sale-list::detail_table_total": "小计",
  "after-sales::after-sale-list::detail_update": "修改",
  "after-sales::after-sale-list::detail_warning_tips": "提交申请后将无法修改订单消息!",
  "after-sales::after-sale-list::email": "Email",
  "after-sales::after-sale-list::export": "导出",
  "after-sales::after-sale-list::label_payment_channel": "支付渠道",
  "after-sales::after-sale-list::label_platform": "平台",
  "after-sales::after-sale-list::label_shop": "店铺",
  "after-sales::after-sale-list::new_after_sale_amount": "售后总金额",
  "after-sales::after-sale-list::new_after_sale_type": "售后类型",
  "after-sales::after-sale-list::new_after_sale_type_holder": "请选择售后类型",
  "after-sales::after-sale-list::new_back_order": "返回售后订单",
  "after-sales::after-sale-list::new_bill_attachement": "附件",
  "after-sales::after-sale-list::new_bill_num": "账单号",
  "after-sales::after-sale-list::new_bill_num_holder": "请输入账单号",
  "after-sales::after-sale-list::new_order_info": "售后订单信息",
  "after-sales::after-sale-list::new_order_num": "订单号",
  "after-sales::after-sale-list::new_order_num_holder": "请输入订单号",
  "after-sales::after-sale-list::new_placeholder": "请输入内容",
  "after-sales::after-sale-list::new_reason": "售后原因",
  "after-sales::after-sale-list::new_refund": "退款类型",
  "after-sales::after-sale-list::new_refund_holder": "请选择退款类型",
  "after-sales::after-sale-list::new_refund_reason_holder": "请选择售后原因",
  "after-sales::after-sale-list::new_refund_source_holder": "请选择售后来源",
  "after-sales::after-sale-list::new_remark": "备注",
  "after-sales::after-sale-list::new_responsible_party": "责任方",
  "after-sales::after-sale-list::new_return": "返回",
  "after-sales::after-sale-list::new_save": "保存",
  "after-sales::after-sale-list::new_select_amount": "按金额",
  "after-sales::after-sale-list::new_select_proportion": "按比例",
  "after-sales::after-sale-list::new_shop_order_num": "店铺订单号",
  "after-sales::after-sale-list::new_shop_order_num_holder": "请输入店铺订单号",
  "after-sales::after-sale-list::new_source": "售后来源",
  "after-sales::after-sale-list::new_table_amount": "退款",
  "after-sales::after-sale-list::new_table_buy_amount": "购买数量",
  "after-sales::after-sale-list::new_table_discount": "优惠",
  "after-sales::after-sale-list::new_table_fulfillment_status": "发货状态",
  "after-sales::after-sale-list::new_table_pay_amount": "小计",
  "after-sales::after-sale-list::new_table_pay_ship_amount": "邮费",
  "after-sales::after-sale-list::new_table_refund_quantity": "售后数量",
  "after-sales::after-sale-list::new_table_refund_ship_amount": "退款邮费",
  "after-sales::after-sale-list::new_table_shop": "商品",
  "after-sales::after-sale-list::new_table_single_price": "单价",
  "after-sales::after-sale-list::new_table_sub_order": "子订单",
  "after-sales::after-sale-list::new_type_off_internet": "未上网",
  "after-sales::after-sale-list::new_type_part_ship": "部分发货",
  "after-sales::after-sale-list::new_type_part_shiped": "已发货",
  "after-sales::after-sale-list::new_type_part_sign": "部分签收",
  "after-sales::after-sale-list::new_type_refunding": "退货中",
  "after-sales::after-sale-list::new_type_signed": "已签收",
  "after-sales::after-sale-list::new_type_wait_handle": "待处理",
  "after-sales::after-sale-list::new_type_wait_ship": "待发货",
  "after-sales::after-sale-list::order_number": "订单号",
  "after-sales::after-sale-list::pending_refund": "待退款",
  "after-sales::after-sale-list::quick_sort": "快速筛选",
  "after-sales::after-sale-list::refund_type": "退款类型",
  "after-sales::after-sale-list::refunded": "已退款",
  "after-sales::after-sale-list::rejected": "已驳回",
  "after-sales::after-sale-list::responsible_party": "责任方",
  "after-sales::after-sale-list::select_closed": "已关闭",
  "after-sales::after-sale-list::select_has_redunded": "已退款",
  "after-sales::after-sale-list::select_reject": "已驳回",
  "after-sales::after-sale-list::select_unpay": "未支付",
  "after-sales::after-sale-list::select_wait": "待申请",
  "after-sales::after-sale-list::select_wait_refund": "待退款",
  "after-sales::after-sale-list::sku": "SKU",
  "after-sales::after-sale-list::spu": "SPU",
  "after-sales::after-sale-list::tab_has_application": "已申请",
  "after-sales::after-sale-list::tab_has_close": "已关闭",
  "after-sales::after-sale-list::tab_pending_application": "待申请",
  "after-sales::after-sale-list::table_after_sale_order_num": "售后单号",
  "after-sales::after-sale-list::table_application_time": "申请时间",
  "after-sales::after-sale-list::table_apply_refund": "申请退款",
  "after-sales::after-sale-list::table_close_order": "关闭工单",
  "after-sales::after-sale-list::table_commodity": "商品",
  "after-sales::after-sale-list::table_detail": "详情",
  "after-sales::after-sale-list::table_edit": "编辑",
  "after-sales::after-sale-list::table_email": "Email",
  "after-sales::after-sale-list::table_go_bind": "前往绑定",
  "after-sales::after-sale-list::table_go_bind_tips": "未绑定Paypal支付账号，绑定后可一键退款",
  "after-sales::after-sale-list::table_opt": "操作",
  "after-sales::after-sale-list::table_order_num": "订单号",
  "after-sales::after-sale-list::table_pay_channel": "支付渠道",
  "after-sales::after-sale-list::table_re_applicate": "重新申请",
  "after-sales::after-sale-list::table_refund": "退款",
  "after-sales::after-sale-list::table_reject": "驳回",
  "after-sales::after-sale-list::table_remark": "备注",
  "after-sales::after-sale-list::table_sales_price": "售后金额",
  "after-sales::after-sale-list::table_sales_reason": "售后原因",
  "after-sales::after-sale-list::table_shop": "店铺",
  "after-sales::after-sale-list::table_status": "状态",
  "after-sales::after-sale-list::table_type": "类型",
  "after-sales::after-sale-list::transaction_num": "交易流水号",
  "after-sales::after-sales-set::add_cancel": "取消",
  "after-sales::after-sales-set::add_reason": "新增售后原因",
  "after-sales::after-sales-set::add_reason_add_edit": "编辑售后原因",
  "after-sales::after-sales-set::add_reason_add_sub": "添加下级",
  "after-sales::after-sales-set::add_reason_parent_cate": "父级目录",
  "after-sales::after-sales-set::add_reason_type": "售后原因",
  "after-sales::after-sales-set::add_responsible_party": "责任方",
  "after-sales::after-sales-set::add_responsible_party_holder": "请选择责任方",
  "after-sales::after-sales-set::add_save": "保存",
  "after-sales::after-sales-set::after_sales_reason": "售后原因",
  "after-sales::after-sales-set::after_sales_reason_add": "新增售后原因",
  "after-sales::after-sales-set::after_sales_setting": "售后类型",
  "after-sales::after-sales-set::after_sales_source": "售后来源",
  "after-sales::after-sales-set::after_sales_source_add": "添加售后来源",
  "after-sales::after-sales-set::delete": "删除",
  "after-sales::after-sales-set::input_name_holder": "请输入名称",
  "after-sales::after-sales-set::move": "移动",
  "after-sales::after-sales-set::reason": "售后原因",
  "after-sales::after-sales-set::reason_add_sub": "添加下级",
  "after-sales::after-sales-set::reason_cancel": "取消",
  "after-sales::after-sales-set::reason_cate_name": "类目名称",
  "after-sales::after-sales-set::reason_confirm": "确定",
  "after-sales::after-sales-set::reason_delete": "删除",
  "after-sales::after-sales-set::reason_delete_title": "确认删除吗?",
  "after-sales::after-sales-set::reason_delete_warn": "删除后数据将无法恢复",
  "after-sales::after-sales-set::reason_edit": "编辑",
  "after-sales::after-sales-set::reason_opt": "操作",
  "after-sales::after-sales-set::reason_responsible_party": "责任方",
  "after-sales::after-sales-set::refund_type": "退款类型",
  "after-sales::after-sales-set::refund_type_add": "添加退款类型",
  "after-sales::after-sales-set::responsible_party_add": "添加责任方",
  "after-sales::after-sales-set::setting_add": "添加售后类型",
  "after-sales::after-sales-set::setting_default_tips": "系统默认参数不可编辑拖动，自定义参数请自行添加 ",
  "after-sales::after-sales-set::setting_default_tips_red": "添加、编辑或拖动后点击【保存】生效",
  "after-sales::after-sales-set::setting_tag_name": "标签名称",
  "after-sales::email-setting::email_sort": "邮件分类",
  "after-sales::email-setting::email_sort_add": "添加分类",
  "after-sales::email-setting::email_tag": "邮件标签",
  "after-sales::email-setting::email_tag_add": "新增标签",
  "after-sales::email-setting::email_tag_add_add_sub": "添加下级标签",
  "after-sales::email-setting::email_tag_add_cancel": "取消",
  "after-sales::email-setting::email_tag_add_confirm": "确定",
  "after-sales::email-setting::email_tag_add_edit": "编辑标签",
  "after-sales::email-setting::email_tag_add_parent_cate": "父级类目",
  "after-sales::email-setting::email_tag_add_save": "保存",
  "after-sales::email-setting::email_tag_add_sub": "添加下级",
  "after-sales::email-setting::email_tag_color": "标签颜色",
  "after-sales::email-setting::email_tag_delete": "删除",
  "after-sales::email-setting::email_tag_delete_confirm": "确认删除该标签吗?",
  "after-sales::email-setting::email_tag_delete_tip": "删除后数据将无法恢复",
  "after-sales::email-setting::email_tag_edit": "编辑",
  "after-sales::email-setting::email_tag_name": "标签名称",
  "after-sales::email-setting::email_tag_name_holder": "请输入标签名称",
  "after-sales::email-setting::email_tag_opt": "操作",
  "after-sales::email-setting::empty_bind_email": "立即设置",
  "after-sales::email-setting::empty_email_tips": "绑定邮箱后，即可收发顾客邮件，连接售后服务、EDM营销",
  "after-sales::email-setting::empty_email_title": "您尚未设置客服邮箱",
  "after-sales::email-setting::please_inpu_after": "请输入售后原因",
  "after-sales::email-setting::please_input": "请输入",
  "after-sales::email-setting::please_input_cate": "请输入父级类目",
  "after-sales::email-setting::please_input_color": "请输入标签颜色",
  "after-sales::email-setting::please_input_tag_parent": "请选择父级标签",
  "after-sales::email-setting::please_select_duty": "请选择责任方",
  "after-sales::in-box::add_sort": "新增分类",
  "after-sales::in-box::add_sort_new": "添加分类",
  "after-sales::in-box::add_tag": "新增标签",
  "after-sales::in-box::after_sale_status": "售后状态",
  "after-sales::in-box::attachment": "附件",
  "after-sales::in-box::bcc": "密送",
  "after-sales::in-box::bind_in_box": "绑定邮箱",
  "after-sales::in-box::btn_cancel": "取消",
  "after-sales::in-box::btn_send": "发送",
  "after-sales::in-box::can_not_info": "获取不到用户订单信息",
  "after-sales::in-box::content": "正文",
  "after-sales::in-box::content_placeholder": "请输入正文",
  "after-sales::in-box::country": "国家",
  "after-sales::in-box::detail_classify": "归类",
  "after-sales::in-box::detail_copy_content": "复制邮件内容",
  "after-sales::in-box::detail_email_id": "邮件ID",
  "after-sales::in-box::detail_handler": "负责人",
  "after-sales::in-box::detail_mark_as": "标记为",
  "after-sales::in-box::detail_recipient": "收件人",
  "after-sales::in-box::detail_remark": "备注",
  "after-sales::in-box::detail_remark_holder": "请输入备注",
  "after-sales::in-box::detail_remark_placeholder": "请输入备注（可选）",
  "after-sales::in-box::detail_replier": "回复人",
  "after-sales::in-box::detail_reply": "回复",
  "after-sales::in-box::detail_reply_time": "回复时间",
  "after-sales::in-box::detail_send_time": "发送时间",
  "after-sales::in-box::detail_sender": "发件人",
  "after-sales::in-box::detail_sort": "分类",
  "after-sales::in-box::detail_status": "状态",
  "after-sales::in-box::email": "发件邮箱",
  "after-sales::in-box::email_content": "邮件正文",
  "after-sales::in-box::email_detail": "邮件详情",
  "after-sales::in-box::email_id": "邮件ID",
  "after-sales::in-box::email_sort": "邮件分类",
  "after-sales::in-box::email_tag": "邮件标签",
  "after-sales::in-box::email_topic": "邮件主题",
  "after-sales::in-box::empty_tips": "在这您可收发顾客往来邮件，高效进行售后服务",
  "after-sales::in-box::empty_title": "管理您的收件箱",
  "after-sales::in-box::handler": "负责人",
  "after-sales::in-box::history_bind": "绑定客户",
  "after-sales::in-box::history_bind_customer": "绑定客户",
  "after-sales::in-box::history_bind_info": "为该封邮件绑定客户，绑定后将显示该客户的历史订单",
  "after-sales::in-box::history_btn_cancel": "取消",
  "after-sales::in-box::history_btn_confirm": "确定",
  "after-sales::in-box::history_check": "查看",
  "after-sales::in-box::history_correct_holder": "请输入正确邮箱",
  "after-sales::in-box::history_country": "国家",
  "after-sales::in-box::history_email": "邮箱",
  "after-sales::in-box::history_email_usage": "或者使用 邮箱",
  "after-sales::in-box::history_logistics_status": "物流状态",
  "after-sales::in-box::history_opt": "操作",
  "after-sales::in-box::history_order": "历史订单",
  "after-sales::in-box::history_order_email": "下单邮箱",
  "after-sales::in-box::history_order_email_holder": "请输入下单邮箱",
  "after-sales::in-box::history_order_num": "订单号",
  "after-sales::in-box::history_order_num_holder": "请输入订单号",
  "after-sales::in-box::history_order_tips": "提示：支持通过客户已下订单的订单号或者邮箱来把该邮件绑定到系统订单",
  "after-sales::in-box::history_ordernum_usage": "或者使用订单号",
  "after-sales::in-box::history_pay_bill": "支付金额",
  "after-sales::in-box::history_pay_time": "支付时间",
  "after-sales::in-box::history_payment_status": "支付状态",
  "after-sales::in-box::history_sell_status": "售后状态",
  "after-sales::in-box::history_sku": "SKU",
  "after-sales::in-box::in_out_mail": "往来邮件",
  "after-sales::in-box::in_out_mail_customer_send": "客户发出",
  "after-sales::in-box::in_out_mail_delete": "删除成功",
  "after-sales::in-box::in_out_mail_deliver_time": "收发时间",
  "after-sales::in-box::in_out_mail_detail": "详情",
  "after-sales::in-box::in_out_mail_handler": "负责人",
  "after-sales::in-box::in_out_mail_mark": "标记为",
  "after-sales::in-box::in_out_mail_num": "编号",
  "after-sales::in-box::in_out_mail_opt": "操作",
  "after-sales::in-box::in_out_mail_opt_success": "操作成功",
  "after-sales::in-box::in_out_mail_reply": "回复",
  "after-sales::in-box::in_out_mail_reply_letter": "回信",
  "after-sales::in-box::in_out_mail_select_mail": "请选择邮件",
  "after-sales::in-box::in_out_mail_send_email": "发送邮件",
  "after-sales::in-box::in_out_mail_shop": "店铺",
  "after-sales::in-box::in_out_mail_sort": "邮件分类",
  "after-sales::in-box::in_out_mail_subject": "邮件主题",
  "after-sales::in-box::in_out_mail_tag": "邮箱标签",
  "after-sales::in-box::in_out_mail_user_send": "客服发出",
  "after-sales::in-box::include": "包含",
  "after-sales::in-box::input_receiver_input": "请输入收件人",
  "after-sales::in-box::input_subject_input": "请输入主题",
  "after-sales::in-box::logistics_number": "物流号",
  "after-sales::in-box::logistics_online_status": "物流上网状态",
  "after-sales::in-box::mark_as": "标记为",
  "after-sales::in-box::no_reply": "未回复",
  "after-sales::in-box::no_user_info": "没有用户订单信息",
  "after-sales::in-box::not_include": "不包含",
  "after-sales::in-box::order_detail": "订单详情",
  "after-sales::in-box::order_number": "订单号",
  "after-sales::in-box::order_status": "订单状态",
  "after-sales::in-box::payment_date": "支付时间",
  "after-sales::in-box::payment_serial_number": "支付流水号",
  "after-sales::in-box::payment_status": "支付状态",
  "after-sales::in-box::please_select": "请选择发件人",
  "after-sales::in-box::placeholder_请输入收件人": "请输入收件人",
  "after-sales::in-box::placeholder_请输入密送": "请输入密送",
  "after-sales::in-box::placeholder_请输入主题": "请输入主题",
  "after-sales::in-box::reassign": "改派",
  "after-sales::in-box::receive_amount": "收件数",
  "after-sales::in-box::receiving_time": "收件时间",
  "after-sales::in-box::recipient": "收件人",
  "after-sales::in-box::remark": "备注",
  "after-sales::in-box::reply_letter": "回信",
  "after-sales::in-box::responder": "回复人",
  "after-sales::in-box::response_date": "回复时间",
  "after-sales::in-box::select_all": "全部",
  "after-sales::in-box::select_receiver_input": "请选择发件人",
  "after-sales::in-box::send_date": "发送时间",
  "after-sales::in-box::sender": "发件人",
  "after-sales::in-box::shop": "店铺",
  "after-sales::in-box::shop_order_number": "店铺订单号",
  "after-sales::in-box::sort": "归类",
  "after-sales::in-box::sort_name": "分类名称",
  "after-sales::in-box::sort_name_input": "请输入分类名称",
  "after-sales::in-box::subject": "主题",
  "after-sales::in-box::tab_all": "全部",
  "after-sales::in-box::tab_replied": "已回复",
  "after-sales::in-box::tab_unanswered": "未回复",
  "after-sales::in-box::table_detail": "详情",
  "after-sales::in-box::table_email": "发件邮箱",
  "after-sales::in-box::table_email_count": "邮件数量",
  "after-sales::in-box::table_email_sort": "邮件分类",
  "after-sales::in-box::table_email_tag": "邮件标签",
  "after-sales::in-box::table_email_topic": "邮件主题",
  "after-sales::in-box::table_handler": "负责人",
  "after-sales::in-box::table_number": "编号",
  "after-sales::in-box::table_operate": "操作",
  "after-sales::in-box::table_remark": "备注",
  "after-sales::in-box::table_reply": "回复",
  "after-sales::in-box::table_shop": "店铺",
  "after-sales::in-box::write": "写信",
  "after-sales::in-box::write_letter": "写信",
  "amount_is_too_large": "退款金额不能大于可退款金额",
  "AUDIT_STATUS_ERROR": "审核状态异常",
  "AUTHORIZE_SELF_ERROR": "无法给自己授权",
  "AUTHORIZE_USER_EXIT": "授权用户已存在",
  "AUTHORIZE_USER_NOT_EXIT": "授权用户不存在",
  "bind_phone_error": "绑定失败,请关注公众号",
  "bind_phone_error_code": "绑定失败,请重新扫码",
  "board::adcost_title": "广告花费",
  "board::adcost_tooltip": "谷歌和facebook广告的总费用",
  "board::adfee_title": "广告费用TOP5",
  "board::adfee::table_adCost": "广告花费",
  "board::adfee::table_adCostRate": "广告花费占比",
  "board::adfee::table_shop": "店铺",
  "board::adfunnel_title": "广告转化漏斗",
  "board::adfunnel::funnel_addBuy": "加购量",
  "board::adfunnel::funnel_click": "点击量",
  "board::adfunnel::funnel_count": "发起结账量",
  "board::adfunnel::funnel_order": "下单量",
  "board::adfunnel::funnel_show": "展示量",
  "board::adfunnel::funnel_visitor": "落地页浏览量",
  "board::adROI_tooltip": "计算公式：广告销额/广告费用，统计广告类型：谷歌和facebook",
  "board::adsales_title": "广告ROI TOP5店铺",
  "board::adsales::table_sales": "广告销售额",
  "board::adsales::table_shop": "店铺",
  "board::auth_tooltip": "设置广告账号即可呈现【营销概览】",
  "board::channel_title": "渠道分解",
  "board::date": "日期",
  "board::feechannel_title": "付费渠道",
  "board::naturechannel_title": "自然渠道",
  "board::notPaySales_title": "非付费销售额",
  "board::notPaySales_tooltip": "计算公式：销售额-付费销售额-自然销售额",
  "board::paySales_title": "付费销售额",
  "board::paySales_tooltip": "付费渠道带来的销售额，包含谷歌广告，facebook广告和KOL，<br />字段：utm_term=facebook 或 google",
  "board::sales_title": "销售额",
  "board::sales_tooltip": "已支付订单对应的实际支付总额",
  "board::shopName": "店铺名称",
  "board::trend_title": "趋势分析",
  "board::trend::line_addBuy": "加购量",
  "board::trend::line_addBuyRate": "加购率",
  "board::trend::line_click": "点击量",
  "board::trend::line_clickRate": "点击率",
  "board::trend::line_order": "下单量",
  "board::trend::line_payment": "发起结账量",
  "board::trend::line_paymentRate": "发起结算率",
  "board::trend::line_show": "展示量",
  "board::trend::line_transRate": "广告转化率",
  "board::trend::line_visitorRate": "浏览率",
  "board::unfeechannel_title": "非付费渠道",
  "cell_phone_error": "手机端目前禁止申请试用",
  "CS_ACCOUNT_NOT_FOUND": "客服邮箱(id:%s)不存在",
  "CS_ACCOUNT_SHOP_IS_EXIT": "改店铺已经绑定其他邮箱了",
  "CS_ACCOUNT_SHOP_NOT_EXIT": "该店铺没有绑定任何邮箱",
  "CS_BINDING_IS_EXIT": "该绑定已存在，绑定失败",
  "CS_BINDING_ORDER_IS_NOT_EXIT": "根据orderId找不到对应的邮箱",
  "CS_Contacts_NOT_FOUND": "该邮件不存在",
  "CS_INBOX_HAS_NOT_EMAIL": "该收件箱没有对应的发件人",
  "CS_INBOX_NOT_FOUND": "收件箱(id:%s)不存在",
  "CS_MERCHANT_IS_NOT": "不是该商家的件",
  "CS_ORDER_HAS_NOT_EMAIL": "该订单没有对应的邮箱",
  "CS_SENDMAIL_AUTHENTICATION_FAIL": "发送邮件失败，身份验证失败，请检查发件服务器地址或账号密码",
  "CUSTOM_FAIL": "系统错误",
  "CUSTOMER_EXIT": "顾客已存在",
  "customer_is_not_exit_or_not_this_merchant": "客户不存在或不是该商家的",
  "customer_is_not_this_merchant": "该客户不是该商家的",
  "CUSTOMER_SERVICE_EMAIL_ID_NO_FIND": "该id找不到对应的客服邮箱",
  "CUSTOMER_SERVICE_EMAIL_IS_NOT_MERCHANT": "该邮箱不是该商家的",
  "CUSTOMER_SERVICE_EMAIL_MERCHANT_ID_ISNULL": "商家id为空",
  "customer_tag_is_not_exit": "该绑定关系不存在",
  "customer::customer-list::add_customer": "新建顾客",
  "customer::customer-list::add_success": "新增成功",
  "customer::customer-list::add_tag": "添加标签",
  "customer::customer-list::address": "地址",
  "customer::customer-list::after_sale_refund": "售后退款",
  "customer::customer-list::after_sales_order": "售后订单数",
  "customer::customer-list::at_least_one": "请勾选至少1名顾客",
  "customer::customer-list::base_info": "基本信息",
  "customer::customer-list::basic_info": "基础信息",
  "customer::customer-list::batch_tag": "批量打标",
  "customer::customer-list::belong_platform": "所属平台",
  "customer::customer-list::belong_shop": "所属店铺",
  "customer::customer-list::buy_count": "购买次数",
  "customer::customer-list::buy_history": "购物历史",
  "customer::customer-list::cancel": "取消",
  "customer::customer-list::cancel_subscribe_success": "取消订阅成功",
  "customer::customer-list::commonly_used": "常用",
  "customer::customer-list::confirm": "确定",
  "customer::customer-list::consume": "消费金额",
  "customer::customer-list::create_begin_time": "创建开始时间",
  "customer::customer-list::create_end_time": "创建结束时间",
  "customer::customer-list::create_time": "创建时间",
  "customer::customer-list::customer_level": "顾客等级",
  "customer::customer-list::customer_level_select": "请选择顾客等级",
  "customer::customer-list::customer_name": "顾客名称",
  "customer::customer-list::customer_no_consume": "该顾客未在任意店铺下单消费",
  "customer::customer-list::customer_tag": "顾客标签",
  "customer::customer-list::deal_amount": "成交金额",
  "customer::customer-list::deal_amount_max": "成交最高金额",
  "customer::customer-list::deal_amount_min": "成交最低金额",
  "customer::customer-list::delete_tag_success": "删除标签成功",
  "customer::customer-list::deliver_wait": "待发货",
  "customer::customer-list::delivered": "已发货",
  "customer::customer-list::detail": "详情",
  "customer::customer-list::detail_info": "详细信息",
  "customer::customer-list::edit": "编辑",
  "customer::customer-list::edit_customer": "编辑顾客",
  "customer::customer-list::edit_success": "编辑成功",
  "customer::customer-list::edit_tag_success": "编辑标签成功",
  "customer::customer-list::email": "邮箱",
  "customer::customer-list::email_input": "请输入邮箱",
  "customer::customer-list::email_input_correct": "请输入正确邮箱",
  "customer::customer-list::end_time": "结束时间",
  "customer::customer-list::first_name": "名",
  "customer::customer-list::first_name_input": "请输入姓",
  "customer::customer-list::first_order_time": "首次下单时间",
  "customer::customer-list::fullfillment_status": "物流状态",
  "customer::customer-list::grand_total": "累计消费",
  "customer::customer-list::has_subscribe": "已订阅",
  "customer::customer-list::join_time": "加入时间",
  "customer::customer-list::last_name": "姓",
  "customer::customer-list::last_name_input": "请输入名",
  "customer::customer-list::list": "顾客列表",
  "customer::customer-list::max_consume": "消费最高金额",
  "customer::customer-list::min_consume": "消费最低金额",
  "customer::customer-list::no_deliver_addr": "暂无收货地址",
  "customer::customer-list::no_subscribe": "未订阅",
  "customer::customer-list::often": "常",
  "customer::customer-list::one_time": "1次",
  "customer::customer-list::one_time_more": "1次及以上",
  "customer::customer-list::opt": "操作",
  "customer::customer-list::order_quantity": "下单数",
  "customer::customer-list::order_quantity_max": "最大订单数",
  "customer::customer-list::order_quantity_min": "最小订单数",
  "customer::customer-list::order_status": "订单状态",
  "customer::customer-list::order_total": "订单总价",
  "customer::customer-list::pay_end_time": "支付结束时间",
  "customer::customer-list::pay_start_time": "支付开始时间",
  "customer::customer-list::pay_status": "支付状态",
  "customer::customer-list::pay_time": "支付时间",
  "customer::customer-list::pay_type": "支付方式",
  "customer::customer-list::phone": "手机号",
  "customer::customer-list::phone_number": "手机号码",
  "customer::customer-list::prod_num": "商品数量",
  "customer::customer-list::recipient": "收件人",
  "customer::customer-list::registered_status": "注册概况",
  "customer::customer-list::select_tag": "请选择标签",
  "customer::customer-list::select_tag_btn": "选择标签",
  "customer::customer-list::select_tag_one": "请选择至少1个标签",
  "customer::customer-list::select_tag_success": "批量打标成功",
  "customer::customer-list::set_commonly_used_addr": "设为常用地址",
  "customer::customer-list::setting_success": "设置成功",
  "customer::customer-list::shipping_address": "收货地址",
  "customer::customer-list::shop_name": "店铺名称",
  "customer::customer-list::shop_order_num": "店铺订单编号",
  "customer::customer-list::subscribe_success": "订阅成功",
  "customer::customer-list::subscribe_time": "订阅状态",
  "customer::customer-list::tag": "标签",
  "customer::customer-list::tag_batch_add": "批量打标签",
  "customer::customer-list::ten_limit": "可选10个",
  "customer::customer-list::ten_limit_max": "最多可选10个",
  "customer::customer-list::times": "次",
  "customer::customer-list::total_spending": "消费总额（USD）",
  "customer::customer-list::two_time_more": "2次及以上",
  "customer::customer-list::use": "用",
  "customer::customer-list::zero_time": "0次",
  "customer::customer-manager::cancel": "取消",
  "customer::customer-manager::confirm": "确定",
  "customer::customer-manager::delete": "删除",
  "customer::customer-manager::delete_confirm": "确认删除该顾客等级吗?",
  "customer::customer-manager::edit": "编辑",
  "customer::customer-manager::edit_level": "编辑顾客等级",
  "customer::customer-manager::level": "顾客等级",
  "customer::customer-manager::level_add": "新增顾客等级",
  "customer::customer-manager::level_delete_not": "顾客等级不能为空",
  "customer::customer-manager::opt": "操作",
  "customer::customer-manager::setting": "顾客设置",
  "customer::customer-manager::sort_code": "序号",
  "customer::customer-manager::tag": "顾客标签",
  "customer::customer-manager::tag_add": "新增顾客标签",
  "customer::customer-manager::tag_delete_not": "顾客标签不能为空",
  "customer::customer-manager::tag_delete_tips": "确认删除该顾客标签吗?",
  "customer::customer-manager::tag_edit": "编辑顾客标签",
  "customer::customer-manager::tips": "提示",
  "customer::customers-notice::activity_info": "活动信息",
  "customer::customers-notice::activity_name": "活动名称",
  "customer::customers-notice::add": "新增活动",
  "customer::customers-notice::after_click_info": "在点击“发送”后生效延迟发送，存草稿\r\n    不发送；",
  "customer::customers-notice::all": "所有",
  "customer::customers-notice::all_user": "所有订阅者",
  "customer::customers-notice::arrange_send": "已安排发送",
  "customer::customers-notice::avtivity_name": "活动名称",
  "customer::customers-notice::cancel": "取消",
  "customer::customers-notice::check": "查看",
  "customer::customers-notice::confirm": "确定",
  "customer::customers-notice::content": "内容",
  "customer::customers-notice::count": "下单次数",
  "customer::customers-notice::de": "的",
  "customer::customers-notice::delay_send": "延时发送",
  "customer::customers-notice::delete": "删除",
  "customer::customers-notice::delete_confirm": "确认删除此营销邮件么？",
  "customer::customers-notice::delete_tips": "删除后将无法找回，谨慎操作",
  "customer::customers-notice::draft": "草稿",
  "customer::customers-notice::edit": "编辑",
  "customer::customers-notice::email": "发件邮箱",
  "customer::customers-notice::email_obj": "邮件对象",
  "customer::customers-notice::email_send_to": "电子邮件将发送至",
  "customer::customers-notice::email_setting": "邮箱设置",
  "customer::customers-notice::emial_content": "邮件内容",
  "customer::customers-notice::in_draft": "存草稿",
  "customer::customers-notice::level": "顾客等级",
  "customer::customers-notice::one_time": "1次",
  "customer::customers-notice::opt": "操作",
  "customer::customers-notice::over_one_time": "1次及以上",
  "customer::customers-notice::over_time": "已过时，请重新选择发送时间",
  "customer::customers-notice::placeholder_content": "请输入邮件内容",
  "customer::customers-notice::placeholder_date": "请选择日期",
  "customer::customers-notice::placeholder_email": "请选择发件邮箱",
  "customer::customers-notice::placeholder_name": "请输入活动名称",
  "customer::customers-notice::placeholder_time": "请选择时间",
  "customer::customers-notice::please_select": "请选择",
  "customer::customers-notice::recipient": "收件人",
  "customer::customers-notice::second_time": "2次及以上",
  "customer::customers-notice::select_date": "请选择时间",
  "customer::customers-notice::select_long_date": "选择日期",
  "customer::customers-notice::select_time": "选择时间",
  "customer::customers-notice::sell_strategy": "营销策略",
  "customer::customers-notice::send": "发送",
  "customer::customers-notice::send_email": "发送电子邮件",
  "customer::customers-notice::send_success": "发送成功",
  "customer::customers-notice::send_time": "发送时间",
  "customer::customers-notice::sending": "发送中",
  "customer::customers-notice::sending_now": "正在发送",
  "customer::customers-notice::setting_right": "你的客服邮箱为空，请点击右侧设置",
  "customer::customers-notice::setting_tips": "将客情维护低本高效触达到每一位顾客，促进顾客二次消费，提高店铺销量",
  "customer::customers-notice::single": "位",
  "customer::customers-notice::status": "状态",
  "customer::customers-notice::tag": "顾客标签",
  "customer::customers-notice::tips": "提示",
  "customer::customers-notice::total": "共",
  "customer::customers-notice::update_time": "更新时间",
  "customer::customers-notice::user": "订阅者",
  "customer::customers-notice::wait_send": "待发送",
  "customer::customers-notice::warning_message": "您尚未设置邮箱",
  "customer::customers-notice::x_count": "共X位",
  "customer::customers-notice::zero_time": "0次",
  "dashboard-bi::admin-config::add_module": "添加模型",
  "dashboard-bi::admin-config::copy": "复制",
  "dashboard-bi::admin-config::delete": "删除",
  "dashboard-bi::admin-config::edit": "编辑",
  "dashboard-bi::admin-config::select_module": "选择数据库引擎",
  "dashboard-bi::admin-config::tab_module": "模型配置",
  "dashboard-bi::admin-config::tip_delete": "是否删除该条数据?",
  "dashboard-bi::default-board::cancel": "取消",
  "dashboard-bi::default-board::confrim": "确定",
  "dashboard-bi::default-board::copy_default": "复制默认看板",
  "dashboard-bi::default-board::no_screen": "退出全屏",
  "dashboard-bi::default-board::screen": "全屏浏览",
  "dashboard-bi::default-board::select": "请选择看板",
  "dashboard-bi::default-board::loading": "加载中...",
  "dashboard-bi::edit-report::advance_tip": "往前推第",
  "dashboard-bi::edit-report::black_option": "黑色",
  "dashboard-bi::edit-report::chart_all": "图表汇总",
  "dashboard-bi::edit-report::chart_area": "面积图",
  "dashboard-bi::edit-report::chart_bar": "条形图",
  "dashboard-bi::edit-report::chart_design": "图表设计",
  "dashboard-bi::edit-report::chart_line": "线型图",
  "dashboard-bi::edit-report::chart_pie": "扇形图",
  "dashboard-bi::edit-report::chart_pile": "堆积图",
  "dashboard-bi::edit-report::chart_type": "图表类型",
  "dashboard-bi::edit-report::click_or_drop_number": "双击或拖拽数值字段到这里",
  "dashboard-bi::edit-report::data_filter": "数据筛选",
  "dashboard-bi::edit-report::data_filter_holder": "请选择",
  "dashboard-bi::edit-report::default": "默认",
  "dashboard-bi::edit-report::dialog::batch_choice_cancel_select": "取消选择 ",
  "dashboard-bi::edit-report::dialog::batch_choice_data_module": "数据模型",
  "dashboard-bi::edit-report::dialog::batch_choice_data_module_hodler": "请选择模型",
  "dashboard-bi::edit-report::dialog::batch_choice_number_list": "数值列表：",
  "dashboard-bi::edit-report::dialog::batch_choice_search_keyword_holder": "搜索关键词",
  "dashboard-bi::edit-report::dialog::batch_choice_select_all": "选择全部",
  "dashboard-bi::edit-report::dialog::batch_choice_select_btn": "批量选择",
  "dashboard-bi::edit-report::dialog::batch_choice_title": "批量选择",
  "dashboard-bi::edit-report::dialog::btn::delete_tip": " 删除tips",
  "dashboard-bi::edit-report::dialog::custom_number": "自定义数字",
  "dashboard-bi::edit-report::dialog::decimal_info": "小数点位数",
  "dashboard-bi::edit-report::dialog::delete_higher_string": "删除高级字段",
  "dashboard-bi::edit-report::dialog::dimension": "维度",
  "dashboard-bi::edit-report::dialog::dimension_list": "维度列表：",
  "dashboard-bi::edit-report::dialog::higher_title": "高级字段配置",
  "dashboard-bi::edit-report::dialog::number": "数值 ",
  "dashboard-bi::edit-report::dialog::number_info": "数值单位",
  "dashboard-bi::edit-report::dialog::select_board_title": "请选择看板",
  "dashboard-bi::edit-report::dialog::select_holder": "请选择看板",
  "dashboard-bi::edit-report::dialog::selected_dimension": "已选维度：",
  "dashboard-bi::edit-report::dialog::selected_number": "已选数值：",
  "dashboard-bi::edit-report::dialog::set_condition_style_title": "条件格式",
  "dashboard-bi::edit-report::dialog::set_higher_string": "配置高级字段",
  "dashboard-bi::edit-report::dialog::set_number_style_title": "设置数值显示格式",
  "dashboard-bi::edit-report::dialog::show_number": "显示为数值",
  "dashboard-bi::edit-report::dialog::show_percentage": "显示为百分数",
  "dashboard-bi::edit-report::dialog::string_name": "请输入字段的名称：",
  "dashboard-bi::edit-report::dialog::string_name_holder": "请输入高级字段名称",
  "dashboard-bi::edit-report::dialog::tip_input_holder": "请设置tips",
  "dashboard-bi::edit-report::dialog::tip_title": "设置tips",
  "dashboard-bi::edit-report::dimension": "维度",
  "dashboard-bi::edit-report::double_shaft": "双轴",
  "dashboard-bi::edit-report::down_option": "下箭头",
  "dashboard-bi::edit-report::edit_custom_report": "编辑自定义报表",
  "dashboard-bi::edit-report::export_excel": "导出excel",
  "dashboard-bi::edit-report::filter": "数据筛选",
  "dashboard-bi::edit-report::freeze_column": "表格冻结列数配置（不含\"序号\"列）",
  "dashboard-bi::edit-report::green_option": "绿色",
  "dashboard-bi::edit-report::in_tag": "标签显示在内部",
  "dashboard-bi::edit-report::input_content_holder": "请输入内容",
  "dashboard-bi::edit-report::line_option": "横线",
  "dashboard-bi::edit-report::new_custom_report": "新建自定义报表",
  "dashboard-bi::edit-report::no_data_filter": "无筛选条件：",
  "dashboard-bi::edit-report::no_option": "无",
  "dashboard-bi::edit-report::no_pile": "不堆叠",
  "dashboard-bi::edit-report::number": "数值",
  "dashboard-bi::edit-report::out_tag": "标签显示在外部",
  "dashboard-bi::edit-report::pageSize": "每页条数配置",
  "dashboard-bi::edit-report::pick_up": "收起",
  "dashboard-bi::edit-report::pile": "堆叠",
  "dashboard-bi::edit-report::please_condition_tip": "该维度为必选项",
  "dashboard-bi::edit-report::please_data_filter_tip": "请点击上方下拉框选择筛选类型",
  "dashboard-bi::edit-report::please_number_tip": "请输入完整数字",
  "dashboard-bi::edit-report::red_option": "红色",
  "dashboard-bi::edit-report::report_info": "报表信息",
  "dashboard-bi::edit-report::report_info_holder": "请输入报表信息",
  "dashboard-bi::edit-report::report_info_name": "请输入报表名称",
  "dashboard-bi::edit-report::section": "区间",
  "dashboard-bi::edit-report::select_chart": "选择图表",
  "dashboard-bi::edit-report::select_string": "已选中字段：",
  "dashboard-bi::edit-report::shaft": "单轴",
  "dashboard-bi::edit-report::tip": "提示",
  "dashboard-bi::edit-report::tip_day": "天",
  "dashboard-bi::edit-report::tip_info": "是否删除该报表？",
  "dashboard-bi::edit-report::top_option": "上箭头",
  "dashboard-bi::edit-report::unfold": "展开",
  "dashboard-bi::person-board::add": "添加看版",
  "dashboard-bi::person-board::board_name": "看板名称",
  "dashboard-bi::person-board::board_name_holder": "请选择看版",
  "dashboard-bi::person-board::create": "新建自定义报表",
  "dashboard-bi::person-board::delete": "删除看版",
  "dashboard-bi::person-board::delete_tip": "确定删除看板吗？",
  "dashboard-bi::person-board::dimension_holder": "请选择联动的维度",
  "dashboard-bi::person-board::edit": "编辑看版",
  "dashboard-bi::person-board::edit_board": "编辑看板名称",
  "dashboard-bi::person-board::input_board_name": "请输入看板名称",
  "dashboard-bi::person-board::new_board": "新增看板",
  "dashboard-bi::person-board::no_screen": "退出全屏",
  "dashboard-bi::person-board::option_condition_gear": "条件联动",
  "dashboard-bi::person-board::option_result_gear": "结果联动",
  "dashboard-bi::person-board::screen": "全屏浏览",
  "dashboard-bi::person-board::select_all": "全选",
  "dashboard-bi::person-board::select_dimension": "选择联动的维度：",
  "dashboard-bi::person-board::select_holder": "请选择看板",
  "dashboard-bi::person-board::select_table": "选择联动表：",
  "dashboard-bi::person-board::select_type": "选择联动类型:",
  "dashboard-bi::person-board::table_holder": "请选择联动表",
  "dashboard-bi::person-board::title": "联动表选择",
  "dashboard-bi::person-board::type_holder": "请选择联动类型",
  "dashboard-bi::person-board:screen": "全屏浏览",
  "dashboard-bi::default-board::copy_to_person": "复制看板到个人文件夹",
  "DATA_DUPLICATE_ERROR": "数据已存在",
  "DATA_ERROR": "数据异常",
  "DATA_EXIST": "数据已存在！",
  "DATA_NOT_EXIST": "数据不存在！",
  "direction_param_error": "direction字段不合法",
  "EMAIL_ALREADY_EXIST": "当前邮箱已被注册,请更换邮箱",
  "email_data_is_null": "暂无可发送对象,请重新选择收件人",
  "EMAIL_TYPE_IS_EXIT": "邮件类型相同，请重命名！",
  "ENTERPRISE_WECHAT_ERROR": "微信接口调用异常:%s",
  "etl_data_error": "etl数据异常:%s",
  "ETL_QUERY_CHECK_ERROR": "非法etl请求",
  "etl_query_error": "非法etl请求",
  "EXPIRE_TIME_FAIL": "到期时间不能早于注册时间",
  "facebook_account_name_is_exist": "账号名称相同",
  "failed_save_data": "保存EDM营销数据失败",
  "failed_update_data": "更新EDM营销数据失败",
  "FILE_UPLOAD_CONFIG_ERROR": "文件上传,配置错误.",
  "FLOW_CONTROL_EXCEPTION": "前方系统拥堵,请稍后重试",
  "GET_SHOP_ERROR": "店铺获取异常：%s",
  "GET_SHOP_RATE": "汇率获取异常",
  "GET_SKU_COUNT_ERROR": "店铺订单可用库存异常：%s",
  "GET_USER_DATA_ERROR": "获取用户店铺数据异常",
  "GIVE_USER_TOKEN_INVALID": "token失效",
  "I18N_CACHE_QUERY_NON_PARAMS": "词汇缓存查询参数为空",
  "inoutstock_export_data_is_empty": "导出数据为空",
  "inoutstock_export_data_is_too_big": "导出数据量过大",
  "INOUTSTOCK_EXPORT_FAILED": "导出失败",
  "inoutstock_impost_file_price_less_than_0": "导入文件存在金额小于0的商品",
  "inoutstock_impost_file_quantity_less_than_0": "导入文件存在数量小于0的商品",
  "inoutstock_impost_file_to_big": "导入文件大于5000条，导入失败",
  "inoutstock_impost_is_failed": "导入sku失败",
  "inoutstock_impost_sku_has_repeat": "导入sku有重复，导入失败",
  "inoutstock_impost_sku_is_not_this_supplier": "导入sku%s不属于选定供应商的，导入失败",
  "inoutstock_is_not_found": "出入库单查询不到",
  "inoutstock_is_not_this_merchant": "改出入库单不是改商家的",
  "inoutstock_statu_is_not_pending_review": "出入库单状态不是待审核状态",
  "input_logistics_id_error": "请输入正确的物流商信息",
  "INSERT_VOCABULARY_ERROR": "新增词汇同步商家失败",
  "instock_stocktype_is_exit": "入库类型相同，请重命名！",
  "IP_LIMIT": "抱歉，由于您登录错误次数大多，已经被限制访问，请稍后再试！",
  "LANGUAGE_EXIST": "已存在%s(%s)语言翻译数据，新增失败！",
  "list_too_long": "导入的商品数量不能超过1000条",
  "login::accept": "我接受",
  "login::account::text": "通过你的账号密码登录，或",
  "login::agreement::secret": "《隐私协议》",
  "login::agreement::usage": "《使用协议》",
  "login::agreement::user": "《用户协议》",
  "login::btn::confirm": "确认",
  "login::code::send::fail": "发送短信验证码失败",
  "login::code::send::success": "验证码发送成功",
  "login::customer::service": "咨询客服",
  "login::customer::service::ask": "咨询客服答疑",
  "login::customer::service::hide": "隐藏客服",
  "login::customer::service::scan": "扫一扫",
  "login::desc::first": "0门槛建站迁站",
  "login::desc::fourth": "多对一专业指导服务",
  "login::desc::second": "国际化店铺模板",
  "login::desc::third": "支持多种支付渠道",
  "login::desc::title": "通过Shoplus 您可以体验到",
  "login::dialog::content": "为更好的展现“品牌出海整体解决方案”的定位，提升在跨境电商服务领域的辨识度和影响力。我们决定即日起将“Algobuy       超级店商”的中英文名称更名为“超店Shoplus”，并使用最新的品牌形象标识，具体更新如下：",
  "login::dialog::OK": "好的",
  "login::dialog::text": "感谢您一直以来的关注与支持，也希望您和我们一样喜欢我们的新品牌“超店Shoplus”，至真科技将继续坚持为您提供优质的全案服务与数字化产品，为您带来更多高价值的品牌出海新体验。",
  "login::dialog::thanks": "感谢您一直以来对Algobuy 的关心与支持！",
  "login::dialog::title": "尊敬的朋友们：",
  "login::edit::password": "修改密码",
  "login::email::tips": "该手机号仅用于注册验证，不能用于登录！",
  "login::forget::password": "忘记密码",
  "login::help::center": "帮助中心",
  "login::holder::confirm::password": "请输入确认密码",
  "login::message::edit::password": "修改密码成功",
  "login::message::exam::fail": "审核失败",
  "login::message::exam::warning": "审核中",
  "login::message::register::success": "注册成功",
  "login::message::sign::fail": "登录失败",
  "login::message::sign::success": "登录成功",
  "login::message::system::error": "网络异常,请稍候重试",
  "login::message::time::error": "账号已过期",
  "login::phone::google_sign": "建议使用谷歌浏览器",
  "login::phone::open": "开启您的出海之旅",
  "login::phone::PC_sign": "请使用电脑访问",
  "login::phone::text": "通过你的手机验证码登录，或",
  "login::phone::user": "恭喜您已经是注册用户",
  "login::register": "注册",
  "login::register::email": "邮箱注册",
  "login::register::free": "免费注册",
  "login::register::phone": "手机号注册",
  "login::return": "返回登录",
  "login::rule::agreement": "请勾选使用协议",
  "login::rule::code": "请输入验证码",
  "login::rule::email": "请输入邮箱",
  "login::rule::password": "请输入密码（需要8-16位数字+字母组合）",
  "login::rule::password_equal": "密码输入不一致",
  "login::rule::phone": "请输入手机号码(仅支持中国大陆手机号+86)",
  "login::rule::phone_email": "请输入邮箱/手机号码",
  "login::rule::right_email": "请输入正确格式的邮箱（50个字符以内）",
  "login::rule::right_password": "为了账号安全，密码必须由8-16位数字+字母组合",
  "login::rule::right_phone": "手机号码格式不正确",
  "login::rule::system": "请勾选您要注册的系统",
  "login::send_code": "发送验证码",
  "login::sign::seven_day": "7天内免登录",
  "login::submit::account": "账号密码",
  "login::submit::phone": "手机验证码",
  "login::title": "登录",
  "logistics_is_exist": "该物流已存在于该商户下",
  "menu::after-sales": "售后管理",
  "menu::after-sales::after-sale-list": "售后订单",
  "menu::after-sales::after-sales-set": "售后设置",
  "menu::after-sales::email-setting": "邮件设置",
  "menu::after-sales::in-box": "收件箱",
  "menu::customer": "顾客管理",
  "menu::customer::customer-list": "顾客列表",
  "menu::customer::customer-manager": "顾客设置",
  "menu::customer::customers-notice": "顾客通知",
  "menu::dashboard-bi": "报表中心",
  "menu::dashboard-bi::admin-config": "后台管理",
  "menu::dashboard-bi::default-board": "默认数据看板",
  "menu::dashboard-bi::edit-report": "编辑报表",
  "menu::dashboard-bi::person-board-customer": "个人文件夹",
  "menu::data-board-customer::person-board": "个人文件夹",
  "menu::dashboard-bi::data-board": "数据看板",
  "menu::data-analysis": "营销分析",
  "menu::data-analysis::ad-analysis": "广告分析",
  "menu::data-analysis::board": "销售概览",
  "menu::operation": "运营分析",
  "menu::operation::month-profits": "利润月报",
  "menu::operation::performance-board": "行为分析",
  "menu::operation::sale-analysis": "销售分析",
  "menu::performance": "履约分析",
  "menu::performance::performance-analysis": "履约概览",
  "menu::purchase": "采购管理",
  "menu::purchase::purchase-list": "采购订单",
  "menu::sales-analysis": "售后分析",
  "menu::sales-analysis::sale-order": "退款概览",
  "menu::sales-analysis::work-order": "工单概览",
  "menu::storage": "库存管理",
  "menu::storage::commodity-stocks": "商品库存",
  "menu::storage::in-stock": "入库单",
  "menu::storage::out-stock": "出库单",
  "menu::stores": "店铺管理",
  "menu::stores::order": "订单列表",
  "menu::stores::product-manager": "商品设置",
  "menu::stores::products-info": "商品列表",
  "menu::stores::shop-site": "店铺设置",
  "menu::stores::store": "店铺列表",
  "menu::stores::supplier": "供应商列表",
  "menu::system": "系统设置",
  "menu::system::exchange-manager": "汇率设置",
  "menu::system::rbac-manager": "角色权限管理",
  "menu::user-guidance": "后台首页",
  "MESSAGE_SEND_CLIENT_ERROR": "阿里云短信客户端异常",
  "MESSAGE_SEND_ERROR": "验证码发送错误,错误码:%s",
  "MESSAGE_SEND_SERVER_ERROR": "阿里云短信服务异常",
  "message-center::notice_button": "标记全部已读",
  "message-center::tab_message": "系统消息",
  "message-center::tab_notice": "官方公告",
  "month-profits::date": "日期",
  "month-profits::site-pofits::name": "站点名称",
  "month-profits::site-pofits::tab_title": "站点利润月报",
  "month-profits::site-pofits::table_adcost": "广告费用",
  "month-profits::site-pofits::table_grossMargin": "毛利率",
  "month-profits::site-pofits::table_grossProfit": "毛利润",
  "month-profits::site-pofits::table_logisticsCost": "物流成本",
  "month-profits::site-pofits::table_proCost": "商品成本",
  "month-profits::site-pofits::table_refundAmount": "退款金额",
  "month-profits::site-pofits::table_salesMoney": "销售总额",
  "month-profits::site-pofits::table_salesNum": "销量",
  "month-profits::site-pofits::table_shopName": "站点名称",
  "month-profits::site-pofits::tip_pay": "总支出成本",
  "month-profits::site-pofits::tip_profit": "总利润",
  "month-profits::site-pofits::tip_sales": "商品销售额",
  "month-profits::staff-pofits::name": "优化师名称",
  "month-profits::staff-pofits::tab_title": "运营人员利润月报",
  "month-profits::staff-pofits::table_grossMargin": "绩效毛利率",
  "month-profits::staff-pofits::table_grossProfit": "绩效毛利润",
  "month-profits::staff-pofits::table_name": "优化师名称",
  "month-profits::staff-pofits::table_roi": "广告ROI",
  "month-profits::staff-pofits::tip_pay": "总支出成本",
  "month-profits::staff-pofits::tip_profit": "总绩效毛利润",
  "month-profits::staff-pofits::tip_sales": "优化师销售总额",
  "NO_AUTHORIZE_USER": "未授权用户",
  "no_data_error": "账号为空",
  "no_data_found": "未查到对应数据",
  "NO_SYSTEM_AUTH": "您已注册开通试用帐号，请联系客服开通商家账户。",
  "NOT_PROVIDE_FILE": "不支持的文件类型: %s",
  "NOTIFICATION_SEND_ERROR": "日志消息推送异常",
  "NULL_TOKEN_ERROR": "token不能为空",
  "ocean-bi:0-5天发货率": "0-5天发货率",
  "ocean-bi:0-5天发货订单数": "0-5天发货订单数",
  "ocean-bi:10-15天发货率": "10-15天发货率",
  "ocean-bi:10-15天发货订单数": "10-15天发货订单数",
  "ocean-bi:12-24小时回复数": "12-24小时回复数",
  "ocean-bi:12小时内回复数": "12小时内回复数",
  "ocean-bi:15天以上发货率": "15天以上发货率",
  "ocean-bi:15天以上发货订单数": "15天以上发货订单数",
  "ocean-bi:24-48小时回复数": "24-48小时回复数",
  "ocean-bi:上网子订单数": "上网子订单数",
  "ocean-bi:上网率": "上网率",
  "ocean-bi:主动退款金额": "主动退款金额",
  "ocean-bi:主动退款金额占比": "主动退款金额占比",
  "ocean-bi:付费销售额": "付费销售额",
  "ocean-bi:付费销售额占比": "付费销售额占比",
  "ocean-bi:加购率": "加购率",
  "ocean-bi:发件人名称": "发件人名称",
  "ocean-bi:发货-妥投20天子订单数": "发货-妥投20天子订单数",
  "ocean-bi:发货-妥投20天子订单数占比": "发货-妥投20天子订单数占比",
  "ocean-bi:发货-妥投30天子订单数": "发货-妥投30天子订单数",
  "ocean-bi:发货-妥投30天子订单数占比": "发货-妥投30天子订单数占比",
  "ocean-bi:发货率": "发货率",
  "ocean-bi:发起结账量": "发起结账量",
  "ocean-bi:售后单创建日期": "售后单创建日期",
  "ocean-bi:售后单创建月份": "售后单创建月份",
  "ocean-bi:售后单号": "售后单号",
  "ocean-bi:售后单数": "售后单数",
  "ocean-bi:售后商品数量": "售后商品数量",
  "ocean-bi:售后总金额": "售后总金额",
  "ocean-bi:售后状态": "售后状态",
  "ocean-bi:商品名称": "商品名称",
  "ocean-bi:商品图片": "商品图片",
  "ocean-bi:商品销售数量": "商品销售数量",
  "ocean-bi:商户id": "商户id",
  "ocean-bi:回复人名称": "回复人名称",
  "ocean-bi:回复数": "回复数",
  "ocean-bi:回复日期": "回复日期",
  "ocean-bi:国家": "国家",
  "ocean-bi:妥投率": "妥投率",
  "ocean-bi:妥投订单数": "妥投订单数",
  "ocean-bi:妥投金额": "妥投金额",
  "ocean-bi:子订单号": "子订单号",
  "ocean-bi:实际支付运费": "实际支付运费",
  "ocean-bi:客单价": "客单价",
  "ocean-bi:客诉用户数": "客诉用户数",
  "ocean-bi:已发货子订单数": "已发货子订单数",
  "ocean-bi:已发货订单数": "已发货订单数",
  "ocean-bi:已支付子订单数": "已支付子订单数",
  "ocean-bi:已支付订单数": "已支付订单数",
  "ocean-bi:广告下单量": "广告下单量",
  "ocean-bi:广告加购率": "广告加购率",
  "ocean-bi:广告发起结算率": "广告发起结算率",
  "ocean-bi:广告名称": "广告名称",
  "ocean-bi:广告展示量": "广告展示量",
  "ocean-bi:广告投放日期": "广告投放日期",
  "ocean-bi:广告投放月份": "广告投放月份",
  "ocean-bi:广告支付转化率": "广告支付转化率",
  "ocean-bi:广告浏览率": "广告浏览率",
  "ocean-bi:广告点击率": "广告点击率",
  "ocean-bi:广告点击量": "广告点击量",
  "ocean-bi:广告系列名称": "广告系列名称",
  "ocean-bi:广告组名称": "广告组名称",
  "ocean-bi:广告花费占比": "广告花费占比",
  "ocean-bi:广告账户账号": "广告账户账号",
  "ocean-bi:广告费用": "广告费用",
  "ocean-bi:广告销额": "广告销额",
  "ocean-bi:店铺id": "店铺id",
  "ocean-bi:总子订单数": "总子订单数",
  "ocean-bi:总订单数": "总订单数",
  "ocean-bi:拒付金额": "拒付金额",
  "ocean-bi:拒付金额占比": "拒付金额占比",
  "ocean-bi:支付-妥投20天子订单数": "支付-妥投20天子订单数",
  "ocean-bi:支付-妥投20天子订单数占比": "支付-妥投20天子订单数占比",
  "ocean-bi:支付-妥投30天子订单数": "支付-妥投30天子订单数",
  "ocean-bi:支付-妥投30天子订单数占比": "支付-妥投30天子订单数占比",
  "ocean-bi:支付日期": "支付日期",
  "ocean-bi:支付月份": "支付月份",
  "ocean-bi:支付状态": "支付状态",
  "ocean-bi:支付用户数": "支付用户数",
  "ocean-bi:收到邮件日期": "收到邮件日期",
  "ocean-bi:未回复数": "未回复数",
  "ocean-bi:物流公司": "物流公司",
  "ocean-bi:物流状态": "物流状态",
  "ocean-bi:站点名称": "站点名称",
  "ocean-bi:站点平台": "站点平台",
  "ocean-bi:自然销售额": "自然销售额",
  "ocean-bi:自然销售额占比": "自然销售额占比",
  "ocean-bi:落地页浏览量": "落地页浏览量",
  "ocean-bi:订单号": "订单号",
  "ocean-bi:订单支付日期": "订单支付日期",
  "ocean-bi:订单支付月份": "订单支付月份",
  "ocean-bi:访问客户数": "访问客户数",
  "ocean-bi:超48小时回复数": "超48小时回复数",
  "ocean-bi:转化率": "转化率",
  "ocean-bi:运费退款金额": "运费退款金额",
  "ocean-bi:连带率": "连带率",
  "ocean-bi:退款原因": "退款原因",
  "ocean-bi:退款日期": "退款日期",
  "ocean-bi:退款月份": "退款月份",
  "ocean-bi:退款率": "退款率",
  "ocean-bi:退款类型": "退款类型",
  "ocean-bi:退款金额": "退款金额",
  "ocean-bi:邮件id": "邮件id",
  "ocean-bi:邮件类型": "邮件类型",
  "ocean-bi:销售金额": "销售金额",
  "ocean-bi:错误信息": "错误信息",
  "ocean-bi:非付费销售额": "非付费销售额",
  "ocean-bi:非付费销售额占比": "非付费销售额占比",
  "OPERATE_GUIDE_TITLE_CANT_BE_SAME": "同级下已存在相同的标题",
  "OPERATE_TIMEOUT": "操作超时，请稍后再试",
  "ORDER_C_CANCEL_FAIL": "c端订单取消失败",
  "ORDER_C_DELIVERY_FAIL": "c端物流妥投完成失败",
  "ORDER_CREATE_FULFILLMENT_FAIL": "创建c端物流发货失败",
  "order_export_data_is_empty": "导出数据为空",
  "order_export_data_is_too_big": "导出数据量过大",
  "ORDER_EXPORT_FAILED": "导出失败",
  "ORDER_ITEM_NOT_FOUND": "子订单不存在",
  "order_item_update_status_fail": "更新子订单状态失败",
  "ORDER_NOT_CANCEL": "只有待支付订单才允许取消",
  "ORDER_NOT_FOUND": "订单不存在 %s",
  "ORDER_NOT_HAS": "订单号不存在",
  "ORDER_NOT_ORDER_NO": "c端来源订单号为空，无法取消c端订单",
  "ORDER_NOT_SUBORDER_ID_EMPTY": "发货子订单id不能为空",
  "order_param_all_exist": "全部更新和部分更新不能同时选择",
  "order_product_sku_qty_is_short": "SKU (%s) 库存不足，发货失败",
  "outstock_stocktype_is_exit": "出库类型相同，请重命名！",
  "PARAM_ERROR": "参数错误",
  "PARAM_FAIL": "参数错误,请检查参数:%s",
  "PARAM_INVALID": "参数无效",
  "PASSWORD_ERROR": "密码错误！",
  "performance-analysis::barCharts_receiveRate": "妥投率",
  "performance-analysis::barCharts_sendRate": "发货率",
  "performance-analysis::barCharts_title": "履约分月统计",
  "performance-analysis::cost_title": "总成本占比",
  "performance-analysis::cost_tooltip": "计算公式：物流成本/销售金额",
  "performance-analysis::fiveSend_title": "5天发货率",
  "performance-analysis::fiveSend_tooltip": "计算公式：发货订单数/总订单数",
  "performance-analysis::internet_title": "上网率",
  "performance-analysis::internet_tooltip": "计算公式：上网订单数/总订单数",
  "performance-analysis::orderDate": "订单创建日期",
  "performance-analysis::receive::table_pay20order": "支付-妥投20天子订单数",
  "performance-analysis::receive::table_pay20orderRate": "支付-妥投20天占比",
  "performance-analysis::receive::table_pay30order": "支付-妥投30天子订单数",
  "performance-analysis::receive::table_pay30orderRate": "支付-妥投30天占比",
  "performance-analysis::receive::table_send20order": "发货-妥投20天子订单数",
  "performance-analysis::receive::table_send20orderRate": "发货-妥投20天占比",
  "performance-analysis::receive::table_send30order": "发货-妥投30天子订单数",
  "performance-analysis::receive::table_send30orderRate": "发货-妥投30天占比",
  "performance-analysis::receive::table_shopName": "店铺名称",
  "performance-analysis::receive::table_title": "各店铺妥投情况",
  "performance-analysis::send::table_fifteenSendOrder": "15天以上发货订单数",
  "performance-analysis::send::table_fifteenSendRate": "15天以上发货率",
  "performance-analysis::send::table_fiveSendOrder": "0-5天发货订单数",
  "performance-analysis::send::table_fiveSendRate": "0-5天发货率",
  "performance-analysis::send::table_notSend": "未发货订单数",
  "performance-analysis::send::table_order": "订单数量",
  "performance-analysis::send::table_shopName": "店铺名称",
  "performance-analysis::send::table_tenSendOrder": "10-15天发货订单数",
  "performance-analysis::send::table_tenSendRate": "10-15天发货率",
  "performance-analysis::send::table_title": "各店铺发货情况",
  "performance-analysis::shopName": "店铺名称",
  "performance-analysis::thirtyReceive_title": "30天妥投率",
  "performance-analysis::thirtyReceive_tooltip": "计算公式：妥投订单数/总订单数",
  "performance-board::addBuy::table_both": "同时加购",
  "performance-board::addBuy::table_bothRate": "同时加购占比",
  "performance-board::addBuy::table_goodsOne": "商品1加购用户数",
  "performance-board::addBuy::table_goodsTwo": "商品2加购用户数",
  "performance-board::addBuy::tip": "行为分析模块仅有平台为shoplus的站点数据，加购行为分析为其拓展功能，如需使用请联系客服。<br />\r\n    统计所选时间内用户在购物车中加购商品情况，可用于营销策略和推荐搭配参考。",
  "performance-board::addBuy::title": "加购行为分析",
  "performance-board::data::areaSoure_title": "访客地区来源",
  "performance-board::data::changeRate_title": "转化率",
  "performance-board::data::changeRate_tooltip": "计算公式：支付用户数/独立访客数",
  "performance-board::data::funnel_clientCnt": "独立访客数",
  "performance-board::data::funnel_pageUV": "上级页面UV",
  "performance-board::data::funnel_stationUV": "全站UV",
  "performance-board::data::funnel_title": "转化漏斗",
  "performance-board::data::funnel_transRate": "转化率",
  "performance-board::data::funnel_transRateRatio": "环比",
  "performance-board::data::outRate_title": "跳出率",
  "performance-board::data::outRate_tooltip": "浏览单页即退出的会话数/总会话数",
  "performance-board::data::pageVisitor_clientCnt": "独立访客数",
  "performance-board::data::pageVisitor_outRate": "跳出率",
  "performance-board::data::pageVisitor_pageName": "页面名称",
  "performance-board::data::pageVisitor_pageType": "页面类型",
  "performance-board::data::pageVisitor_title": "页面访问概览",
  "performance-board::data::pageVisitor_visitorNum": "访问量",
  "performance-board::data::pageVisitor_visitorTime": "人均浏览时长（分钟）",
  "performance-board::data::tip": "行为分析模块仅有平台为shoplus的站点数据",
  "performance-board::data::title": "数据概览",
  "performance-board::data::utm_sign": "UTM标识",
  "performance-board::data::utmSource_title": "访客UTM来源",
  "performance-board::data::visitor_title": "独立访客数",
  "performance-board::data::visitor_tooltip": "所选时间内访问站点的去重用户数",
  "performance-board::data::visitorTime_title": "人均浏览时长（分钟）",
  "performance-board::data::visitorTime_tooltip": "独立访客浏览网站的总时长/独立访客数",
  "performance-board::goods_detail": "商品详情",
  "performance-board::orderDate": "订单创建日期",
  "performance-board::search::table_clickOne": "商品1点击次数",
  "performance-board::search::table_clickThree": "商品3点击次数",
  "performance-board::search::table_clickTwo": "商品2点击次数",
  "performance-board::search::table_keyWord": "关键词",
  "performance-board::search::table_searchResult": "搜索结果数",
  "performance-board::search::table_searchTime": "搜索次数",
  "performance-board::search::tip": "行为分析模块仅有平台为shoplus的站点数据，搜索行为分析为其拓展功能，如需使用请联系客服。 <br />\r\n    统计所选时间内用户搜索频次最高的前50个关键词，以及搜索该关键词后点击最多的前三个商品和点击次数。",
  "performance-board::search::title": "搜索行为分析",
  "performance-board::shopName": "店铺名称",
  "permission_error": "权限异常",
  "PHONE_ALREADY_EXIST": "当前手机号已被注册",
  "PHONE_EMAIL_ALREADY_BIND_WECHAT": "该手机号已经绑定微信",
  "placeholder_errorPhone": "手机号格式不正确",
  "PLATFORM_SITE_PARAM_ERROR": "platformSite字段不合法",
  "please_binding_logistics": "请绑定物流商",
  "PORTAL_EMAIL_EXIT": "该邮箱已存在,请更换邮箱",
  "PORTAL_USER_AUDIT_STATUS_ERROR": "用户审核状态异常",
  "PORTAL_USER_EXTEND_NOT_FOUND": "用户没有对应的套餐",
  "PORTAL_USER_NOT_FOUND": "审核状态异常",
  "product_category_has_child_delete": "该类目下存在子类目，无法删除!",
  "product_category_has_child_edit": "该类目存在子类目，不允许修改父级类目",
  "product_category_no_change": "类目没有发生改变，无需修改！",
  "product_category_rename": "类目名称相同，请重命名！",
  "PRODUCT_NOT_FOUND": "商品不存在",
  "product_option_exist": "不存在该属性",
  "product_option_rename": "该属性名称已经存在，请重命名！",
  "product_option_value_exist": "不存在该属性值",
  "product_option_value_rename": "该属性值名称已经存在，请重命名！",
  "PRODUCT_PUBLISH_ERROR": "推送店铺端失败,原因：%s",
  "product_supplier_rename": "该供应商名称已经存在，请重命名！",
  "product_tag_rename": "该标签名称已经存在，请重命名！",
  "product-manager::category::add_button": "新增类目",
  "product-manager::category::add_child_dialog": "添加下级类目",
  "product-manager::category::add_dialog": "新增类目",
  "product-manager::category::delete_tip": "删除后数据将无法恢复",
  "product-manager::category::delete_title": "确认删除该类目吗?",
  "product-manager::category::edit_dialog": "编辑类目",
  "product-manager::category::form_father": "父级类目",
  "product-manager::category::form_name": "类目名称",
  "product-manager::category::placeholder_father": "请输入父级类目",
  "product-manager::category::placeholder_name": "请输入类目名称",
  "product-manager::category::placeholder_search": "请输入类目名称",
  "product-manager::category::search": "类目名称",
  "product-manager::category::table_add": "添加下级",
  "product-manager::category::table_delete": "删除",
  "product-manager::category::table_edit": "编辑",
  "product-manager::category::table_handle": "操作",
  "product-manager::category::table_name": "类目名称",
  "product-manager::prop_value::add_button": "新增属性值",
  "product-manager::prop_value::placeholder_name": "请输入属性值",
  "product-manager::prop_value::table_creatTime": "创建时间",
  "product-manager::prop_value::table_name": "属性值名称",
  "product-manager::prop_value::table_no": "序号",
  "product-manager::prop::add_button": "新增属性",
  "product-manager::prop::add_title": "新增属性",
  "product-manager::prop::custom_prop": "自定义属性",
  "product-manager::prop::delete_tip": "此操作将会删除该项，是否继续？",
  "product-manager::prop::edit_button": "编辑属性",
  "product-manager::prop::edit_title": "编辑属性",
  "product-manager::prop::placeholder_prop_name": "请输入属性名称",
  "product-manager::prop::placeholder_search": "请输入属性名称",
  "product-manager::prop::prop_name": "属性名称",
  "product-manager::prop::search": "属性名称",
  "product-manager::prop::table_creatTime": "创建时间",
  "product-manager::prop::table_delete": "删除",
  "product-manager::prop::table_edit": "编辑",
  "product-manager::prop::table_handle": "操作",
  "product-manager::prop::table_name": "属性名称",
  "product-manager::prop::table_no": "序号",
  "product-manager::prop::table_prop": "属性值",
  "product-manager::prop::table_type": "属性类型",
  "product-manager::prop::tooltip_prop": "自定义属性不限制属性值",
  "product-manager::prop::trigger_prop": "非自定义属性",
  "product-manager::tabs_category": "商品类目",
  "product-manager::tabs_prop": "商品属性",
  "product-manager::tabs_tag": "商品标签",
  "product-manager::tag::add_button": "新增标签",
  "product-manager::tag::edit_button": "编辑标签",
  "product-manager::tag::form_name": "标签名称",
  "product-manager::tag::placeholder_name": "请输入标签名称",
  "product-manager::tag::placeholder_search": "请输入标签名称",
  "product-manager::tag::search": "标签名称",
  "product-manager::tag::table_createTime": "创建时间",
  "product-manager::tag::table_delete": "删除",
  "product-manager::tag::table_edit": "编辑",
  "product-manager::tag::table_handle": "操作",
  "product-manager::tag::table_name": "标签名称",
  "product-manager::tag::table_no": "序号",
  "purchase_item_is_not_exit": "采购单项不存在，审核失败",
  "purchase::purchase-list::add_sku": "添加SKU",
  "purchase::purchase-list::add_success": "添加成功",
  "purchase::purchase-list::add_supplier": "新增采购单",
  "purchase::purchase-list::all_arrival": "全部到货",
  "purchase::purchase-list::amount": "数量",
  "purchase::purchase-list::arrival_amount": "到货数量",
  "purchase::purchase-list::audit": "审核",
  "purchase::purchase-list::audit_confirm": "确认审核该采购单吗？",
  "purchase::purchase-list::audit_time": "审核时间",
  "purchase::purchase-list::auditor": "审核人",
  "purchase::purchase-list::autit_info": "审核信息",
  "purchase::purchase-list::begin_time": "开始时间",
  "purchase::purchase-list::cancel": "取消",
  "purchase::purchase-list::check_all": "全部选中",
  "purchase::purchase-list::close": "关闭",
  "purchase::purchase-list::close_confirm": "关闭后将无法恢复！！",
  "purchase::purchase-list::close_purchase_order": "确认关闭该采购单吗？",
  "purchase::purchase-list::closed": "已关闭",
  "purchase::purchase-list::confirm": "确定",
  "purchase::purchase-list::create_info": "创建信息",
  "purchase::purchase-list::create_time": "创建时间",
  "purchase::purchase-list::creator": "创建人",
  "purchase::purchase-list::date_input": "请输入计划到货日期",
  "purchase::purchase-list::date_select": "选择日期",
  "purchase::purchase-list::delete": "删除",
  "purchase::purchase-list::delete_confirm": "删除后将无法恢复 ！！",
  "purchase::purchase-list::detail": "详情",
  "purchase::purchase-list::edit": "编辑",
  "purchase::purchase-list::end_time": "结束时间",
  "purchase::purchase-list::finished": "已完成",
  "purchase::purchase-list::has_audit": "已审核",
  "purchase::purchase-list::has_re_audit": "已复核",
  "purchase::purchase-list::in_stock": "入库",
  "purchase::purchase-list::in_stock_this_time": "本次入库",
  "purchase::purchase-list::in_stock_this_time_num": "请输入本次入库数量",
  "purchase::purchase-list::input_holder": "请输入内容",
  "purchase::purchase-list::no_data": "暂无数据",
  "purchase::purchase-list::opt": "操作",
  "purchase::purchase-list::order": "采购订单",
  "purchase::purchase-list::order_num": "单号",
  "purchase::purchase-list::partial_arrival": "部分到货",
  "purchase::purchase-list::plan_arrival_date": "计划到货日期",
  "purchase::purchase-list::please_add_sku": "请先添加采购sku",
  "purchase::purchase-list::please_select": "请选择",
  "purchase::purchase-list::price_equal": "默认单价=商品成本价",
  "purchase::purchase-list::price_input": "请输入单价",
  "purchase::purchase-list::product_info": "商品信息",
  "purchase::purchase-list::product_name": "商品信息",
  "purchase::purchase-list::progress": "进度",
  "purchase::purchase-list::puechase_order_num": "采购单号",
  "purchase::purchase-list::purchase_amount": "采购数量",
  "purchase::purchase-list::purchase_delete": "确认删除该采购单吗？",
  "purchase::purchase-list::purchase_detail": "采购明细",
  "purchase::purchase-list::purchase_finished": "确认该采购单已完成吗？",
  "purchase::purchase-list::purchase_in_stock": "采购入库",
  "purchase::purchase-list::purchase_price": "采购金额（￥）",
  "purchase::purchase-list::purchase_price_input": "请输入采购运费",
  "purchase::purchase-list::purchase_shipping": "采购运费",
  "purchase::purchase-list::purchse_total_amount": "采购总金额",
  "purchase::purchase-list::quick_sort": "快速筛选",
  "purchase::purchase-list::re_audit": "复审",
  "purchase::purchase-list::re_audit_confirm": "确认复审该采购单吗？",
  "purchase::purchase-list::re_audit_info": "复核信息",
  "purchase::purchase-list::re_audit_time": "复核时间",
  "purchase::purchase-list::re_auditor": "复核人",
  "purchase::purchase-list::remark": "备注",
  "purchase::purchase-list::return_order": "返回采购单",
  "purchase::purchase-list::return_order_edit": "返回采购单",
  "purchase::purchase-list::return_purchase_order": "返回采购单",
  "purchase::purchase-list::save": "保存",
  "purchase::purchase-list::save_audit": "保存并审核",
  "purchase::purchase-list::setting_confirm": "设置成已完成后将无法入库",
  "purchase::purchase-list::single_price": "单价（￥）",
  "purchase::purchase-list::sku": "SKU",
  "purchase::purchase-list::sku_delete_confirm": "SKU删除后将无法回复，是否删除？",
  "purchase::purchase-list::status": "状态",
  "purchase::purchase-list::supplier": "供应商",
  "purchase::purchase-list::supplier_input": "请输入供应商",
  "purchase::purchase-list::total": "小计",
  "purchase::purchase-list::total_amount": "总金额（￥）",
  "purchase::purchase-list::total_input": "输入总金额",
  "purchase::purchase-list::wait_audit": "待审核",
  "refund_custom_tag_rename": "该售后属性名称已经存在，请重命名！",
  "refund_order_is_exist": "该订单号对应售后单已存在",
  "refund_order_no_not_null": "订单号不能为空",
  "refund_reason_delete_has_children": "当前删除售后原因有下级，无法删除！",
  "refund_reason_has_children": "当前编辑售后原因有下级，无法编辑！",
  "refund_reason_merchant_id_different": "当前操作对象和创建对象不一致！",
  "refund_reason_rename": "售后原因相同，请重命名！",
  "refund_remain_amount_error": "申请退款金额大于可退款金额",
  "refund_same_level": "二级原因不能挂到二级原因下",
  "refund_transaction_fail": "退款失败",
  "refund_update_status_fail": "更新订单状态失败",
  "RPC_TRANSFER_EXCEPTION": "远程服务调用失败",
  "sale-analysis::changeRatio_title": "转化率",
  "sale-analysis::changeRatio_tooltip": "仅为店铺平台是shoplus对应的转化率，<br/>计算公式：支付用户数/独立访客数",
  "sale-analysis::orderDate": "订单创建日期",
  "sale-analysis::orderPrice_title": "客单价",
  "sale-analysis::orderPrice_tooltip": "计算公式：销售额/已支付订单数",
  "sale-analysis::sales_title": "销售额",
  "sale-analysis::sales_tooltip": "已支付订单对应的实际支付金额",
  "sale-analysis::sales::table_associateRate": "连带率",
  "sale-analysis::sales::table_customerPricePer": "客单价",
  "sale-analysis::sales::table_img": "商品图片",
  "sale-analysis::sales::table_name": "商品销售概况",
  "sale-analysis::sales::table_receiveOkMoney": "妥投金额",
  "sale-analysis::sales::table_refundMoney": "退款金额",
  "sale-analysis::sales::table_refundRatio": "退款率",
  "sale-analysis::sales::table_salesMoney": "销售金额",
  "sale-analysis::sales::table_salesNum": "销量",
  "sale-analysis::shopName": "店铺名称",
  "sale-analysis::station::table_associateRate": "连带率",
  "sale-analysis::station::table_changeRatio": "转化率",
  "sale-analysis::station::table_customerPricePer": "客单价",
  "sale-analysis::station::table_name": "各站点经营概况",
  "sale-analysis::station::table_sales": "销售额",
  "sale-analysis::station::table_salesRatio": "销售额占比",
  "sale-analysis::station::table_shopName": "店铺名称",
  "sale-analysis::station::table_shopType": "站点类型",
  "sale-analysis::station::table_visitor": "访问客户数",
  "sale-analysis::trend::charts_bar": "成交额",
  "sale-analysis::trend::charts_line": "客单价",
  "sale-analysis::trend::charts_title": "总体成交趋势",
  "sale-analysis::visitorNum_title": "独立访客数",
  "sale-analysis::visitorNum_tooltip": "仅为店铺平台是shoplus对应的独立访客数，<br/>即所选时间内访问站点的去重用户数",
  "sale-order::intervalTime_tip": "所选时间范围截至当前共有{money}{currency}退款，间隔天数占比分别为",
  "sale-order::intervalTime_title": "支付订单到退款间隔时间统计",
  "sale-order::line::money": "金额",
  "sale-order::orderDate": "订单创建日期",
  "sale-order::protestMoney_title": "拒付金额",
  "sale-order::refund::table_country": "国家",
  "sale-order::refund::table_img": "商品图片",
  "sale-order::refund::table_protest": "拒付金额",
  "sale-order::refund::table_protestRate": "拒付金额占比",
  "sale-order::refund::table_recieve": "妥投金额",
  "sale-order::refund::table_refund": "退款金额",
  "sale-order::refund::table_refundRate": "退款率",
  "sale-order::refund::table_sales": "销售金额",
  "sale-order::refund::table_selfRefund": "主动退款金额",
  "sale-order::refund::table_selfRefundRate": "主动退款金额占比",
  "sale-order::refundcountry_title": "退款国家统计",
  "sale-order::refundDate": "退款时间",
  "sale-order::refundGoods_title": "退款商品统计",
  "sale-order::refundMoney_title": "退款金额",
  "sale-order::refundRate_title": "退款率",
  "sale-order::refundRate_tooltip": "计算公式：退款金额/销售金额",
  "sale-order::refundReason_title": "退货原因占比",
  "sale-order::returnGoods_title": "退货商品数",
  "sale-order::returnGoods_tooltip": "已支付订单截至当前的退款商品数量",
  "sale-order::returnMoney_title": "退款金额",
  "sale-order::returnMoney_tooltip": "已支付订单截至当前产生的退款金额主动退款金额+拒付金额",
  "sale-order::sales_title": "销售金额",
  "sale-order::sales_tooltip": "已支付订单对应的实际支付总额",
  "sale-order::selfRefundMoney_title": "主动退款金额",
  "sale-order::shopName": "店铺名称",
  "SEND_EMAIL_ERROR": "邮件验证码发送异常:%s",
  "SERVICE_INVOKE_FAIL": "（%s）服务调用失败",
  "SHOP_CHECK_ERROR": "认证信息或域名验证失败，请核对信息准确性",
  "SHOP_CSHOP_HAS_BEEN_BOUND": "该c端店铺已被绑定,请找对应商家授权",
  "SHOP_DOMAIN_REPEAT": "该C端店铺已绑定，请联系该商家进行授权",
  "SHOP_NAME_REPEAT": "店铺名称已经存在(%s)！",
  "SHOP_NOT_FOUND": "店铺（%s）不存在",
  "SHOP_OFFLINE": "未找到启用状态的店铺",
  "SHOP_SPU_NO_PRODUCT_ID": "spu未关联c端店铺，请检查是否发布成功",
  "SHOP_SPU_NOT_FOUND": "该店铺未发布此商品",
  "SHOP_TASK_RUNNING": "店铺任务执行中！",
  "SHOP_WEBHOOK_CREATE_ERROR": "创建店铺webhook失败,原因:%s",
  "SHOP_WEBHOOK_DELETE_ERROR": "删除店铺webhook失败,原因:%s",
  "shop-site::campaign_rules::example": "示例：ad_test2nd5c01_none_0000_0415_10002_{优化师名称}",
  "shop-site::campaign_rules::key_title": "支持键值",
  "shop-site::campaign_rules::placeholder": "请输入规则，用_分隔",
  "shop-site::campaign_rules::staff_button": " {优化师名称}",
  "shop-site::campaign_rules::tip": "请使用下划线分割",
  "shop-site::campaign_rules::title": "campaign规则",
  "shop-site::email::add_button": "新增邮箱",
  "shop-site::email::addEmail_title": "新增邮箱",
  "shop-site::email::auth_tip": "获取授权码",
  "shop-site::email::confirm_agian": "重新连接",
  "shop-site::email::confirm_return": "返回修改",
  "shop-site::email::confirm_title": "连接失败",
  "shop-site::email::editEmail_title": "编辑邮箱",
  "shop-site::email::form_account": "邮箱账号",
  "shop-site::email::form_password": "邮箱密码",
  "shop-site::email::form_platform": "平台",
  "shop-site::email::form_staff": "负责人",
  "shop-site::email::moreSetting": "高级设置",
  "shop-site::email::placeholder_account": "请输入邮箱账号",
  "shop-site::email::placeholder_emailAddress": "请输入服务器地址",
  "shop-site::email::placeholder_emailPort": "请输入服务器端口号",
  "shop-site::email::placeholder_emailType": "请选择服务器类型",
  "shop-site::email::placeholder_password": "请输入邮箱密码",
  "shop-site::email::placeholder_platform": "请选择平台",
  "shop-site::email::placeholder_protocol": "请选择传输加密协议",
  "shop-site::email::placeholder_rightAccount": "请输入正确邮箱",
  "shop-site::email::placeholder_shop": "请选择店铺",
  "shop-site::email::placeholder_staff": "请选择负责人",
  "shop-site::email::qq_tip": "QQ邮箱请进入以下链接",
  "shop-site::email::recieveSetting": "收件配置",
  "shop-site::email::search_placeholder": "搜索邮箱地址",
  "shop-site::email::sendSetting": "发件配置",
  "shop-site::email::table_createTime": "创建时间",
  "shop-site::email::table_edit": "编辑",
  "shop-site::email::table_emailSign": "邮件签名",
  "shop-site::email::table_handle": "操作",
  "shop-site::email::table_no": "序号",
  "shop-site::email::table_off": "禁用",
  "shop-site::email::table_on": "启用",
  "shop-site::email::table_protocol": "传输加密协议",
  "shop-site::email::table_recieve": "收件信息",
  "shop-site::email::table_recieveAddress": "收件服务器地址",
  "shop-site::email::table_recievePort": "收件服务器端口",
  "shop-site::email::table_reciever": "收件人",
  "shop-site::email::table_recieveType": "收件服务器类型",
  "shop-site::email::table_send": "发件信息",
  "shop-site::email::table_sendAddress": "发件服务器地址",
  "shop-site::email::table_sender": "发件人",
  "shop-site::email::table_sendPort": "发件服务器端口",
  "shop-site::email::table_sendType": "发件服务器类型",
  "shop-site::email::table_shop": "店铺",
  "shop-site::email::table_status": "状态",
  "shop-site::email::table_time": "时间",
  "shop-site::email::table_updateTime": "更新时间",
  "shop-site::emailSign::form_content": "签名内容",
  "shop-site::emailSign::form_email": "邮箱账户",
  "shop-site::emailSign::form_turn": "是否启用",
  "shop-site::emailSign::placeholder_content": "富文本框内：内容",
  "shop-site::emailSign::title": "邮件签名",
  "shop-site::empty::ad_bind_facebook": "绑定Facebook账号",
  "shop-site::empty::ad_tips": "绑定后您可实时了解Facebook广告效益",
  "shop-site::empty::ad_title": "您尚未绑定广告营销账号",
  "shop-site::empty::bind_logi": "立即设置",
  "shop-site::empty::logi_tips": "设置物流商即可实现快速发货、获取智能运输方案推荐",
  "shop-site::empty::logi_title": "您尚未设置物流商",
  "shop-site::facebook_campaign::add_staff": "添加优化师",
  "shop-site::facebook_campaign::bind_title": "配置优化师",
  "shop-site::facebook_campaign::campaign_name": "campaign标识",
  "shop-site::facebook_campaign::placeholder_campaign_name": "请输入campaign标识",
  "shop-site::facebook_campaign::placeholder_staff_name": "请输入优化师名称",
  "shop-site::facebook_campaign::staff_name": "优化师名称",
  "shop-site::facebook_campaign::tooltip_campaign_name": "删除campaign标识会影<br/>响已投放的广告进行所<br/>属优化师、所属团队追<br/>踪，谨慎删除！",
  "shop-site::facebook_campaign::upload_avatar": "上传头像",
  "shop-site::facebook_campaign::upload_avatar_tip": "注：如不上传头像则使用默认头像",
  "shop-site::facebook_campaign::upload_title": "上传图片",
  "shop-site::facebook_token::add_button": "新增配置",
  "shop-site::facebook_token::placeholder_name": "请输入名称",
  "shop-site::facebook_token::placeholder_token": "请输入Token",
  "shop-site::facebook_token::table_cancel": "取消",
  "shop-site::facebook_token::table_edit": "编辑",
  "shop-site::facebook_token::table_handle": "操作",
  "shop-site::facebook_token::table_name": "名称",
  "shop-site::facebook_token::table_save": "保存",
  "shop-site::facebook_token::table_time": "时间",
  "shop-site::facebook_token::table_token": "Token",
  "shop-site::facebook_token::tip": "对您的Facebook广告帐号进行管理，支持广告数据和营销费用的拉取，便于您对广告成效进行分析。 在以下配置中添加您的广告帐号相关的token信息，即可完成广告数据的拉取并在广告数据看板中进行成效 分析。",
  "shop-site::facebook_token::title": "Token配置",
  "shop-site::facebook::add_title": "新增账号",
  "shop-site::facebook::button_new": "新增Facebook账号",
  "shop-site::facebook::button_staff": "配置优化师",
  "shop-site::facebook::button_token": "Token配置",
  "shop-site::facebook::dialog_bind": "去绑定",
  "shop-site::facebook::dialog_noData": "查无数据",
  "shop-site::facebook::edit_title": "编辑账号",
  "shop-site::facebook::placeholder_account": "请输入账号名称",
  "shop-site::facebook::placeholder_accountId": "请输入账号ID",
  "shop-site::facebook::placeholder_number": "请输入数字",
  "shop-site::facebook::placeholder_search": "搜索Facebook名称或ID",
  "shop-site::facebook::placeholder_searchShop": "搜索店铺",
  "shop-site::facebook::placeholder_shop": "请选择店铺",
  "shop-site::facebook::placeholder_token": "请选择Token配置",
  "shop-site::facebook::table_account": "账号名称",
  "shop-site::facebook::table_accountId": "账号ID",
  "shop-site::facebook::table_compaign": "Campaign规则",
  "shop-site::facebook::table_creatTime": "创建时间",
  "shop-site::facebook::table_edit": "编辑",
  "shop-site::facebook::table_handle": "操作",
  "shop-site::facebook::table_no": "序号",
  "shop-site::facebook::table_off": "停用",
  "shop-site::facebook::table_on": "启用",
  "shop-site::facebook::table_shop": "店铺",
  "shop-site::facebook::table_status": "状态",
  "shop-site::facebook::table_time": "时间",
  "shop-site::facebook::table_updateTime": "更新时间",
  "shop-site::facebook::tip": "如何获取Facebook账号ID和名称？",
  "shop-site::facebook::tooltip_compaign": "把campaign与优化师进行绑定，可用与分析优化师投放情况",
  "shop-site::google_manager::add_button": "新增经理账号",
  "shop-site::google_manager::add_title": "新增账号",
  "shop-site::google_manager::dialog_bind": "去绑定",
  "shop-site::google_manager::dialog_noData": "查无数据",
  "shop-site::google_manager::edit_title": "编辑账号",
  "shop-site::google_manager::placeholder_accountId": "请选择谷歌经理账号ID",
  "shop-site::google_manager::placeholder_customerId": "请输入子账号ID",
  "shop-site::google_manager::table_account": "经理账号ID",
  "shop-site::google_manager::table_edit": "编辑",
  "shop-site::google_manager::table_hanlde": "操作",
  "shop-site::google_manager::table_token": "开发者令牌",
  "shop-site::google_manager::title": "谷歌经理账号",
  "shop-site::google::add_button": "新增谷歌账号",
  "shop-site::google::addManager_button": "谷歌经理账号",
  "shop-site::google::edit_button": "编辑谷歌账号",
  "shop-site::google::form_managerId": "谷歌经理ID",
  "shop-site::google::form_official": "正式",
  "shop-site::google::form_serverId": "客户端ID",
  "shop-site::google::form_serverSecret": "客户端Secret",
  "shop-site::google::form_token": "开发者令牌",
  "shop-site::google::form_unofficial": "非正式",
  "shop-site::google::placeholder_managerId": "请输入谷歌经理账号ID",
  "shop-site::google::placeholder_refreshToken": "请输入RefreshToken",
  "shop-site::google::placeholder_releaseStatus": "请输入ReleaseStatus",
  "shop-site::google::placeholder_search": "请输入经理账号ID或子账号ID",
  "shop-site::google::placeholder_searchShop": "请选择店铺",
  "shop-site::google::placeholder_serverId": "请输入客户端ID",
  "shop-site::google::placeholder_serverSecret": "请输入客户端Secret",
  "shop-site::google::placeholder_token": "请输入开发者令牌",
  "shop-site::google::table_child": "谷歌子账号ID",
  "shop-site::google::table_creatTime": "创建时间",
  "shop-site::google::table_edit": "编辑",
  "shop-site::google::table_handle": "操作",
  "shop-site::google::table_manager": "谷歌经理账号ID",
  "shop-site::google::table_no": "序号",
  "shop-site::google::table_off": "停用",
  "shop-site::google::table_on": "启用",
  "shop-site::google::table_shop": "店铺",
  "shop-site::google::table_status": "状态",
  "shop-site::logistics::add_button": "新增物流商",
  "shop-site::logistics::add_title": "新增物流商",
  "shop-site::logistics::delete_tip": "删除后将无法为您推荐该物流商的最优物流方式及查询价格",
  "shop-site::logistics::delete_title": "是否删除该物流商",
  "shop-site::logistics::placeholder_apiKey": "请输入Api Key",
  "shop-site::logistics::placeholder_apiSecret": "请输入Api Secret",
  "shop-site::logistics::placeholder_name": "请选择物流商",
  "shop-site::logistics::placeholder_search": "搜索物流商名称",
  "shop-site::logistics::placeholder_tip": "验证失败，请核对密钥准确性",
  "shop-site::logistics::table_apiKey": "API Key",
  "shop-site::logistics::table_apiSecret": "API Secret",
  "shop-site::logistics::table_handle": "操作",
  "shop-site::logistics::table_name": "物流商",
  "shop-site::logistics::tip": "如何获取物流商的API Key与密钥？",
  "shop-site::paySetting::add_button": "新增账户",
  "shop-site::paySetting::edit_button": "编辑账户",
  "shop-site::paySetting::placeholder_account": "请输入收款账号",
  "shop-site::paySetting::placeholder_accountId": "请输入收款账号ID",
  "shop-site::paySetting::placeholder_accountName": "请输入账户简称",
  "shop-site::paySetting::placeholder_apiName": "请输入API用户名",
  "shop-site::paySetting::placeholder_apiSecret": "请输入API密码",
  "shop-site::paySetting::placeholder_apiSign": "请输入API签名",
  "shop-site::paySetting::placeholder_paypalAccount": "请输入paypalAccount",
  "shop-site::paySetting::placeholder_paypalSecret": "请输入paypalSecret",
  "shop-site::paySetting::placeholder_search": "搜索账户简称",
  "shop-site::paySetting::placeholder_shop": "请选择店铺",
  "shop-site::paySetting::table_account": "收款账号",
  "shop-site::paySetting::table_accountId": "收款账号id",
  "shop-site::paySetting::table_accountName": "账户简称",
  "shop-site::paySetting::table_apiName": "API用户名",
  "shop-site::paySetting::table_apiSecret": "API密码",
  "shop-site::paySetting::table_apiSign": "API签名",
  "shop-site::paySetting::table_edit": "编辑",
  "shop-site::paySetting::table_handle": "操作",
  "shop-site::paySetting::table_shop": "店铺",
  "shop-site::paySetting::tip": "如何获取paypal相关密钥？",
  "shop-site::tab_email": "客服邮箱",
  "shop-site::tab_facebook": "Facebook广告",
  "shop-site::tab_google": "Google广告",
  "shop-site::tab_logistics": "物流设置",
  "shop-site::tab_paySetting": "支付设置",
  "SHOPIFY_SITE_CRAWLER_RUN_ERROR": "触发爬虫失败",
  "SKU_CODE_EXIST": "商品skuCode( %s )已存在",
  "sku_image_is_null": "sku图片不能为空",
  "sku_inventory_short": "对应sku库存不足，审核失败",
  "SKU_NOT_FOUND": "SKU不存在，skuId:%s",
  "SKU_OPTION_INVALID": "无销售属性时不能添加多个SKU",
  "sku_option_not_match": "SKU的销售属性（%s）和SPU的不匹配",
  "SKU_OPTION_REPEAT": "SKU的销售属性重复(%s)",
  "sku_option_value_not_match": "SKU的销售属性值（%s）和SPU的（%s]]）不匹配",
  "SMS_EVENT_ERROR": "短信事件入参错误",
  "SMS_EVENT_SEND_DAY_LIMIT_": "当日短信发送条数已达到上限",
  "SMS_EVENT_SEND_HOUR_LIMIT": "短信发送太频繁,请一小时后重试",
  "SMS_EVENT_SEND_MINUTE_LIMIT": "短信发送太频繁,请一分钟后重试",
  "SMS_LOGIN_USER_EXIT_ERROR": "该账号已注册",
  "SMS_LOGIN_USER_NOT_EXIT_ERROR": "该账号未注册！",
  "SORTBY_PARAM_ERROR": "sortBy字段不合法",
  "SPU_CODE_EXIST": "商品spuCode( %s]] )已存在，对应id和名称为%s]] , %s]]",
  "SPU_ID_NOT_EXIST": "skuId( %s )商品不存在",
  "SPU_ID_UP_SHELVES": "spuId( %s )对应商品已下架,不允许发布",
  "spu_image_is_null": "spu图片不能为空",
  "SPU_NO_SHOP_BIND": "SPU未发布到任何店铺",
  "SPU_NOT_INVENTORY": "skuId:( %s )产品没有库存",
  "SPU_NOT_PRICE": "skuId:( %s )产品没有定价",
  "storage::commodity-stocks::item": "项",
  "storage::commodity-stocks::platform_sku": "平台SKU",
  "storage::commodity-stocks::platform_table_commodity": "商品",
  "storage::commodity-stocks::platform_table_commodity_stock": "商品库存",
  "storage::commodity-stocks::platform_table_pat_cost": "供货成本（￥）",
  "storage::commodity-stocks::platform_table_pat_cost_tips1": "该供货成本为入库单加权平均后的成本",
  "storage::commodity-stocks::platform_table_pat_cost_tips2": "可能与商品信息供货成本存在差异",
  "storage::commodity-stocks::platform_table_pic": "图片",
  "storage::commodity-stocks::platform_table_safe_stock": "安全库存",
  "storage::commodity-stocks::platform_table_sku": "SKU",
  "storage::commodity-stocks::platform_table_spu": "SPU",
  "storage::commodity-stocks::platform_table_stock": "库存",
  "storage::commodity-stocks::platform_table_stock_amount": "库存估值（￥）",
  "storage::commodity-stocks::platform_table_stock_equal": "库存估值=商品库存 * 供货成本",
  "storage::commodity-stocks::platform_table_supplier": "供应商",
  "storage::commodity-stocks::platform_table_use_stock": "可用库存",
  "storage::commodity-stocks::platform_total_stock": "总估值",
  "storage::commodity-stocks::selected": "已选择",
  "storage::commodity-stocks::stock_flow": "库存流水",
  "storage::commodity-stocks::stock_flow_after_stock": "变后库存",
  "storage::commodity-stocks::stock_flow_audited": "已审核",
  "storage::commodity-stocks::stock_flow_before_stock": "变前库存",
  "storage::commodity-stocks::stock_flow_bill_code": "单号",
  "storage::commodity-stocks::stock_flow_change": "变化值",
  "storage::commodity-stocks::stock_flow_change_time": "变化时间",
  "storage::commodity-stocks::stock_flow_close": "关闭",
  "storage::commodity-stocks::stock_flow_closed": "已关闭",
  "storage::commodity-stocks::stock_flow_product_name": "商品名称",
  "storage::commodity-stocks::stock_flow_wait_audit": "待审核",
  "storage::commodity-stocks:false": "否",
  "storage::commodity-stocks:no_stock": "库存不足",
  "storage::commodity-stocks:platform_spu": "平台SPU",
  "storage::commodity-stocks:shop_name": "商品名称",
  "storage::commodity-stocks:supplier": "供应商",
  "storage::commodity-stocks:total_stock": "总库存数",
  "storage::commodity-stocks:total_stock_amount": "总库存估值",
  "storage::commodity-stocks:true": "是",
  "storage::in-stock::add_instock": "新增入库单",
  "storage::in-stock::add_sku": "添加SKU",
  "storage::in-stock::audit_time": "审核时间",
  "storage::in-stock::auditor": "审核人",
  "storage::in-stock::auditor_select": "请选择审核人",
  "storage::in-stock::bill": "入库单",
  "storage::in-stock::bill_num": "单号",
  "storage::in-stock::bill_num_input": "请输入单号",
  "storage::in-stock::cancel": "取消",
  "storage::in-stock::change_supplier_tips": "确认要更换供应商",
  "storage::in-stock::close_instock": "关闭入库单",
  "storage::in-stock::closed": "已关闭",
  "storage::in-stock::confirm": "确定",
  "storage::in-stock::create_time": "创建时间",
  "storage::in-stock::creator": "创建人",
  "storage::in-stock::creator_select": "请选择创建人",
  "storage::in-stock::detail": "详情",
  "storage::in-stock::end_time": "结束时间",
  "storage::in-stock::export": "导出",
  "storage::in-stock::fullfillment_num": "物流单号",
  "storage::in-stock::has_audit": "已审核",
  "storage::in-stock::import": "导入",
  "storage::in-stock::import_instock": "导入入库单",
  "storage::in-stock::in_type": "入库类型",
  "storage::in-stock::in_type_select": "请选择入库类型",
  "storage::in-stock::input_holder": "请输入内容",
  "storage::in-stock::instock_amount": "入库数量",
  "storage::in-stock::instock_close_reason": "关闭原因",
  "storage::in-stock::instock_date": "入库日期",
  "storage::in-stock::instock_date_select": "请选择入库日期",
  "storage::in-stock::instock_detail": "入库明细",
  "storage::in-stock::instock_num": "入库数量",
  "storage::in-stock::instock_order_num": "入库单号",
  "storage::in-stock::instock_type": "入库类型",
  "storage::in-stock::instock_type_add": "添加入库类型",
  "storage::in-stock::order": "订单",
  "storage::in-stock::order_sku": "SKU",
  "storage::in-stock::please_select": "请选择",
  "storage::in-stock::prod_name": "商品名称",
  "storage::in-stock::purchase_order": "采购单",
  "storage::in-stock::relate_num": "关联单号",
  "storage::in-stock::remark": "备注",
  "storage::in-stock::save": "保存",
  "storage::in-stock::save_audit": "保存并审核",
  "storage::in-stock::select_all": "全部选中",
  "storage::in-stock::select_date": "选择日期",
  "storage::in-stock::sku_clear_tips": "切换供应商后将清空SKU列表",
  "storage::in-stock::sku_select": "请添加SKU后继续操作",
  "storage::in-stock::start_time": "开始时间",
  "storage::in-stock::status": "状态",
  "storage::in-stock::status_select": "请选择状态",
  "storage::in-stock::stock_decrease": "审核后库存将相应增加或减少！！",
  "storage::in-stock::stock_decrease_warn": "确认要执行审核操作？",
  "storage::in-stock::supplier": "供应商",
  "storage::in-stock::supplier_select": "请选择供应商后继续操作",
  "storage::in-stock::supplier_select_holder": "请选择供应商",
  "storage::in-stock::table_audit": "审核",
  "storage::in-stock::table_audit_time": "审核时间",
  "storage::in-stock::table_auditor": "审核人",
  "storage::in-stock::table_bill_num": "单号",
  "storage::in-stock::table_close": "关闭",
  "storage::in-stock::table_create_time": "创建时间",
  "storage::in-stock::table_creator": "创建人",
  "storage::in-stock::table_detail": "详情",
  "storage::in-stock::table_edit": "编辑",
  "storage::in-stock::table_instock_time": "入库日期",
  "storage::in-stock::table_opt": "操作",
  "storage::in-stock::table_releate_num": "关联单号",
  "storage::in-stock::table_status": "状态",
  "storage::in-stock::table_supplier": "供应商",
  "storage::in-stock::table_type": "业务类型",
  "storage::in-stock::third_bill_num": "第三方单号",
  "storage::in-stock::total_amount": "总金额（￥）",
  "storage::in-stock::un_audit": "未审核",
  "storage::in-stock::请添加SKU": "请添加SKU",
  "storage::in-stock::请输入数量": "请输入数量",
  "storage::in-stock::请输入正确数量": "请输入正确数量",
  "storage::in-stock::请输入正确金额": "请输入正确金额",
  "storage::in-stock::请输入金额": "请输入金额",
  "storage::out-stock::add_add": "确定",
  "storage::out-stock::add_cancel": "取消",
  "storage::out-stock::add_create_time": "创建日期",
  "storage::out-stock::add_download": "点击下载",
  "storage::out-stock::add_export": "导入",
  "storage::out-stock::add_fullfillment_num": "物流单号",
  "storage::out-stock::add_in_bill": "入库单",
  "storage::out-stock::add_in_type": "添加入库类型",
  "storage::out-stock::add_input": "请输入内容",
  "storage::out-stock::add_order": "订单",
  "storage::out-stock::add_out_count": "出库数量",
  "storage::out-stock::add_out_date": "出库日期",
  "storage::out-stock::add_out_type": "添加出库类型",
  "storage::out-stock::add_prod_name": "商品名称",
  "storage::out-stock::add_purchase_bill": "采购单",
  "storage::out-stock::add_relate_num": "关联单号",
  "storage::out-stock::add_remark": "备注",
  "storage::out-stock::add_save": "保存",
  "storage::out-stock::add_save_audit": "保存并审核",
  "storage::out-stock::add_select": "请选择",
  "storage::out-stock::add_select_all": "全部选中",
  "storage::out-stock::add_sku_add": "添加SKU",
  "storage::out-stock::add_stock": "新增出库单",
  "storage::out-stock::add_stock_supllier": "供应商",
  "storage::out-stock::add_stock_type": "出库类型",
  "storage::out-stock::add_supplier_select_tip": "请选择供应商",
  "storage::out-stock::add_third_num": "第三方单号",
  "storage::out-stock::add_total_amount": "总金额（￥）",
  "storage::out-stock::add_upload_click": "点击上传",
  "storage::out-stock::add_upload_drag": "将文件拖到此处，或",
  "storage::out-stock::add_upload_template": "请使用导入模板 ",
  "storage::out-stock::aduit_time": "审核时间",
  "storage::out-stock::audited": "已审核",
  "storage::out-stock::auditor": "审核人",
  "storage::out-stock::auditor_select": "请选择审核人",
  "storage::out-stock::bill": "出库单",
  "storage::out-stock::bill_number": "单号",
  "storage::out-stock::bill_number_input": "请输入单号",
  "storage::out-stock::close_out_bill": "关闭出库单",
  "storage::out-stock::close_reason": "关闭原因",
  "storage::out-stock::closed": "已关闭",
  "storage::out-stock::create_time": "创建时间",
  "storage::out-stock::creator": "创建人",
  "storage::out-stock::creator_select": "请选择创建人",
  "storage::out-stock::delete": "删除",
  "storage::out-stock::detail_audit_decrease": "审核后库存将相应增加或减少！！",
  "storage::out-stock::detail_audit_decrease_tip": "确认要执行审核操作？",
  "storage::out-stock::detail_audit_time": "审核时间",
  "storage::out-stock::detail_auditor": "审核人",
  "storage::out-stock::detail_creae_time": "创建时间",
  "storage::out-stock::detail_creator": "创建人",
  "storage::out-stock::detail_out_count": "出库数量",
  "storage::out-stock::detail_out_num": "出库数量",
  "storage::out-stock::detail_out_type": "出库类型",
  "storage::out-stock::detail_prod_name": "商品名称",
  "storage::out-stock::detail_table_bill_num": "单号",
  "storage::out-stock::detail_table_prod_name": "商品名称",
  "storage::out-stock::detail_table_sku": "SKU",
  "storage::out-stock::end_time": "结束时间",
  "storage::out-stock::export": "导出",
  "storage::out-stock::input_holder": "请输入",
  "storage::out-stock::input_name": "请输入名称",
  "storage::out-stock::move": "移动",
  "storage::out-stock::no_audit": "未审核",
  "storage::out-stock::out_bill_num": "出库单号",
  "storage::out-stock::out_detail": "出库明细",
  "storage::out-stock::out_type": "出库类型",
  "storage::out-stock::out_type_select": "请选择出库类型",
  "storage::out-stock::save": "保存",
  "storage::out-stock::sku_select": "请添加SKU后继续操作",
  "storage::out-stock::start_time": "开始时间",
  "storage::out-stock::status": "状态",
  "storage::out-stock::supplier": "供应商",
  "storage::out-stock::supplier_select": "请选择供应商后继续操作",
  "storage::out-stock::supplier_select_holder": "请选择供应商",
  "storage::out-stock::table_audit_time": "审核时间",
  "storage::out-stock::table_auditor": "审核人",
  "storage::out-stock::table_bill_number": "单号",
  "storage::out-stock::table_btn_audit": "审核",
  "storage::out-stock::table_business_type": "业务类型",
  "storage::out-stock::table_close": "关闭",
  "storage::out-stock::table_create_time": "创建时间",
  "storage::out-stock::table_creator": "创建人",
  "storage::out-stock::table_detail": "详情",
  "storage::out-stock::table_edit": "编辑",
  "storage::out-stock::table_opt": "操作",
  "storage::out-stock::table_out_time": "出库日期",
  "storage::out-stock::table_relate_bill_number": "关联单号",
  "storage::out-stock::table_status": "状态",
  "storage::out-stock::table_supplier": "供应商",
  "storage::out-stock::请添加SKU": "请添加SKU",
  "storage::out-stock::请输入数量": "请输入数量",
  "storage::out-stock::请输入正确数量": "请输入正确数量",
  "storage::out-stock::请选择出库日期": "请选择出库日期",
  "storage::out-stock::退货数量不能大于可用数量": "退货数量不能大于可用数量",
  "stores::order::address": "地址",
  "stores::order::address1": "地址1",
  "stores::order::address2": "地址2",
  "stores::order::after_cancel": "售后取消",
  "stores::order::after_complete": "售后已完成",
  "stores::order::after_error": "售后异常",
  "stores::order::after_none": "无售后",
  "stores::order::after_ongoing": "售后处理中",
  "stores::order::all": "全部订单",
  "stores::order::all_fee": "预估总费用",
  "stores::order::all_sign": "已签收",
  "stores::order::all_time": "预估时效",
  "stores::order::belong_platform": "所属平台",
  "stores::order::belong_store": "所属店铺",
  "stores::order::billing_info": "账单信息",
  "stores::order::bind_fulfilment": "绑定物流商",
  "stores::order::cancel": "已取消",
  "stores::order::cancel_order": "取消订单",
  "stores::order::cancel_success": "取消成功",
  "stores::order::cant_Identify": "无法识别",
  "stores::order::city": "城市",
  "stores::order::complete": "已完成",
  "stores::order::confirm_delivery": "确认发货",
  "stores::order::copy_order": "复制订单编号",
  "stores::order::country": "国家/地区",
  "stores::order::create_time": "创建时间",
  "stores::order::customer": "客户",
  "stores::order::customer_info": "客户信息",
  "stores::order::customer_name": "客户姓名",
  "stores::order::deliver": "发货",
  "stores::order::deliver_destination": "发货目的地",
  "stores::order::deliver_fee_plan": "运费方案",
  "stores::order::deliver_plan": "运费方案",
  "stores::order::deliver_solutions": "物流方案智能推荐",
  "stores::order::deliver_success": "发货成功",
  "stores::order::deliver_time": "发货日期",
  "stores::order::detail": "详情",
  "stores::order::discount": "优惠",
  "stores::order::domain": "域名",
  "stores::order::edit": "编辑",
  "stores::order::edit_address": "修改收货地址",
  "stores::order::edit_fulfilment_success": "修改物流商成功",
  "stores::order::email": "邮箱",
  "stores::order::empty_button": "绑定店铺",
  "stores::order::empty_text": "您所有站点店铺的订单都可通过这里进行统一管理",
  "stores::order::empty_title": "管理您的订单",
  "stores::order::end_date": "结束日期",
  "stores::order::error": "异常订单",
  "stores::order::export": "导出",
  "stores::order::freight": "运费",
  "stores::order::fulfilment_goods": "共 {goodsNum} 件商品",
  "stores::order::fulfilment_number": "物流单号",
  "stores::order::fulfilment_status": "物流状态",
  "stores::order::fulfilment_type": "物流商",
  "stores::order::fulfilments": "物流商",
  "stores::order::goods": "商品",
  "stores::order::goods_name": "商品名称",
  "stores::order::goods_total": "商品总价",
  "stores::order::had_select_goods": "包裹商品",
  "stores::order::input_customer_name": "请输入客户姓名查找",
  "stores::order::input_domain": "请输入XXX.com域名查找",
  "stores::order::input_fulfilment_number": "请输入物流单号查找",
  "stores::order::input_goods_name": "请输入商品名称查找",
  "stores::order::input_order_number": "请输入订单号查找",
  "stores::order::input_pay_number": "请输入支付流水号查找",
  "stores::order::input_promo_code": "请输入优惠码查找",
  "stores::order::input_sku": "请输入SKU编码查找",
  "stores::order::input_spu": "请输入SPU编码",
  "stores::order::item": "件",
  "stores::order::mark": "标注妥投",
  "stores::order::mark_success": "妥投成功",
  "stores::order::mask_to_place": "标记已妥投",
  "stores::order::max_price": "最大金额",
  "stores::order::message_cancel": "确定取消该订单吗？",
  "stores::order::message_cancel_tips": "取消后该订单将作废且无法恢复",
  "stores::order::message_deliver": "商品处于售后中，无法发货",
  "stores::order::message_fulfilment": "请选择物流商",
  "stores::order::min_price": "最小金额",
  "stores::order::not_deliver_tips": "订单未发货，暂无物流信息",
  "stores::order::not_fulfilment": "哎呀..您还没绑定物流商，无法为您推荐运输方案",
  "stores::order::not_online_not_sign": "未上网未签收",
  "stores::order::ongoing": "进行中",
  "stores::order::online_not_sign": "已上网未签收",
  "stores::order::online_sign": "已上网已签收",
  "stores::order::operate": "操作",
  "stores::order::order_fee": "订单金额",
  "stores::order::order_info": "订单信息",
  "stores::order::order_number": "订单号",
  "stores::order::order_time": "下单时间",
  "stores::order::other_fee": "其他关税杂费",
  "stores::order::other_info": "支付信息",
  "stores::order::package_info": "包裹信息",
  "stores::order::pay_all": "已支付",
  "stores::order::pay_fail": "支付失败",
  "stores::order::pay_number": "支付流水号",
  "stores::order::pay_some": "部分支付",
  "stores::order::pay_status": "支付状态",
  "stores::order::pay_time": "支付时间",
  "stores::order::pay_type": "支付方式",
  "stores::order::phone": "电话",
  "stores::order::platform_order": "平台订单号",
  "stores::order::prev_step": "上一步",
  "stores::order::next_step": "下一步",
  "stores::order::price": "金额",
  "stores::order::promo_code": "优惠码",
  "stores::order::province": "州/省",
  "stores::order::receiver": "收货人",
  "stores::order::receiving_info": "收货信息",
  "stores::order::recommend": "推荐",
  "stores::order::refund_all": "已退款",
  "stores::order::refund_fail": "退款失败",
  "stores::order::refund_some": "部分退款",
  "stores::order::refund_wait": "待退款",
  "stores::order::risk_order": "风险订单",
  "stores::order::rule_address1": "请输入地址1",
  "stores::order::rule_city": "请输入城市",
  "stores::order::rule_country": "请输入国家/地区",
  "stores::order::rule_email": "请输入邮箱",
  "stores::order::rule_first_name": "请输入firstName",
  "stores::order::rule_last_name": "请输入lastName",
  "stores::order::rule_phone": "手机号格式不正确",
  "stores::order::rule_phone_empty": "请输入手机号",
  "stores::order::rule_right_email": "请输入正确邮箱",
  "stores::order::rule_zip": "请输入邮政编码",
  "stores::order::sales_status": "售后状态",
  "stores::order::same_address": "与收货地址一致",
  "stores::order::select_all": "全选",
  "stores::order::select_date": "选择日期",
  "stores::order::select_fulfilment": "请选择已妥投的物流单",
  "stores::order::select_fulfilment_nomber": "请先选择物流单",
  "stores::order::select_goods": "请选择包裹商品",
  "stores::order::select_goods_total": "已选 {x} 件 商品 ，重量合计",
  "stores::order::ship_goods_img": "商品图片",
  "stores::order::ship_input_fulfilment": "请输入物流单号",
  "stores::order::ship_inside": "当前物流商不支持国内运输，无法为您推荐",
  "stores::order::ship_quantity": "数量",
  "stores::order::ship_select_deliver_time": "请选择物流发货时间",
  "stores::order::ship_select_fulfilment": "请选择物流商",
  "stores::order::shipping": "已发货",
  "stores::order::shipping_fee": "基础运费",
  "stores::order::shipping_info": "物流信息",
  "stores::order::shipping_time": "发货时间",
  "stores::order::shipping_way": "运输方式",
  "stores::order::show_more": "展开更多",
  "stores::order::some_deliver": "部分发货",
  "stores::order::some_sign": "部分签收",
  "stores::order::start_date": "开始日期",
  "stores::order::status": "状态",
  "stores::order::store": "店铺",
  "stores::order::store_order": "店铺订单号",
  "stores::order::to_after_sales": "发起售后",
  "stores::order::to_deliver": "去发货",
  "stores::order::utmSource": "渠道来源",
  "stores::order::wait": "待发货",
  "stores::order::wait_pay": "待支付",
  "stores::order::weigth_zero": "商品合计重量为0，无法为您推荐物流方案",
  "stores::order::yuntu": "云途物流",
  "stores::order::zip": "邮政编码",
  "stores::products-info::add": "新建商品",
  "stores::products-info::add_sku": "新增SKU",
  "stores::products-info::add_supplier": "新增供应商",
  "stores::products-info::address": "省市区",
  "stores::products-info::base_attr": "基本属性",
  "stores::products-info::base_info": "基础信息",
  "stores::products-info::batch_edit": "批量编辑",
  "stores::products-info::batch_had_release": "批量发布",
  "stores::products-info::batch_operate": "批量操作",
  "stores::products-info::batch_tag": "批量打标",
  "stores::products-info::batch_tags": "批量打标签",
  "stores::products-info::category": "商品类目",
  "stores::products-info::choose_file": "已选择文件",
  "stores::products-info::compare_at_price": "原价",
  "stores::products-info::copy": "复制",
  "stores::products-info::creatr_time": "创建时间",
  "stores::products-info::currency": "结算货币",
  "stores::products-info::detail": "详情",
  "stores::products-info::detail_address": "详细地址",
  "stores::products-info::dialog_copy_tips": "复制商品名称将为：【{title}】（复制）",
  "stores::products-info::dialog_copy_title": "确认要复制该商品？",
  "stores::products-info::dialog_manager_attr": "管理属性",
  "stores::products-info::dialog_put_down_tips": "下架后所有的店铺都将停售该SPU！",
  "stores::products-info::dialog_put_down_title": "确认要下架该商品？",
  "stores::products-info::dialog_put_on_tips": "上架后可以把商品发布到店铺",
  "stores::products-info::dialog_put_on_title": "确认要上架该商品？",
  "stores::products-info::dialog_release_again_tips": "发布后将把商品信息同步到 【{name}】 站中",
  "stores::products-info::dialog_release_again_title": "确定需要重新发布吗？",
  "stores::products-info::dialog_release_tips": "发布后可进行售卖管理",
  "stores::products-info::dialog_release_title": "确认要发布该商品？",
  "stores::products-info::dialog_start_sale_tips": "开售后商品将在站点店铺【{name}】销售",
  "stores::products-info::dialog_start_sale_title": "确定开售吗？",
  "stores::products-info::dialog_stop_sale_tips": "停售后商品将不在站点店铺【{name}】销售",
  "stores::products-info::dialog_stop_sale_title": "确定停售吗？",
  "stores::products-info::edit": "编辑",
  "stores::products-info::edit_sku": "编辑SKU",
  "stores::products-info::edit_supplier": "设置供应商",
  "stores::products-info::email": "电子邮箱",
  "stores::products-info::empty_add_goods": "新增商品",
  "stores::products-info::empty_bind_store": "绑定店铺",
  "stores::products-info::empty_goods": "管理您的商品",
  "stores::products-info::empty_goods_tips": "您所有站点店铺的商品都可通过这里进行统一管理",
  "stores::products-info::end_time": "结束时间",
  "stores::products-info::export": "导出",
  "stores::products-info::fail_number": "失败数量",
  "stores::products-info::first_stock": "商品期初库存",
  "stores::products-info::goods_cate": "商品类目",
  "stores::products-info::goods_chart": "商品尺码表",
  "stores::products-info::goods_detail": "商品详情",
  "stores::products-info::goods_info": "商品信息",
  "stores::products-info::goods_sku": "商品SKU",
  "stores::products-info::goods_spu": "商品SPU",
  "stores::products-info::goods_stock": "商品库存",
  "stores::products-info::goods_tag": "商品标签",
  "stores::products-info::had_complete": "已完成",
  "stores::products-info::had_release": "已发布",
  "stores::products-info::import": "导入",
  "stores::products-info::import_btn": "点击上传",
  "stores::products-info::import_example": "请使用导入模版 ",
  "stores::products-info::import_example_btn": "点击下载",
  "stores::products-info::import_fail_log": "导出失败日志",
  "stores::products-info::import_goods": "导入商品",
  "stores::products-info::import_log": "导入日志",
  "stores::products-info::import_number": "导入数量",
  "stores::products-info::import_time": "导入时间",
  "stores::products-info::import_tips": "将文件拖拽到此处或 ",
  "stores::products-info::include_deliver_fee": "含物流费",
  "stores::products-info::input_at_price": "请输入原价",
  "stores::products-info::input_attr": "请输入属性",
  "stores::products-info::input_category": "请输入商品类目",
  "stores::products-info::input_currency": "请选择结算币种",
  "stores::products-info::input_detail_address": "请输入详细地址",
  "stores::products-info::input_email": "请输入电子邮箱",
  "stores::products-info::input_first_stock": "请输入商品期初库存",
  "stores::products-info::input_goods_chart": "请输入商品尺码",
  "stores::products-info::input_goods_detail": "请输入商品详情",
  "stores::products-info::input_goods_name": "请输入商品名称",
  "stores::products-info::input_person": "请输入联系人",
  "stores::products-info::input_phone": "请输入联系电话",
  "stores::products-info::input_purchase_price": "请输入成本价",
  "stores::products-info::input_safe_stock": "请输入安全库存",
  "stores::products-info::input_sale_price": "请输入售价",
  "stores::products-info::input_sku": "请输入平台SKU查找",
  "stores::products-info::input_spu": "请输入平台SPU查找",
  "stores::products-info::input_supplier": "请输入供应商名称查找",
  "stores::products-info::input_supplier_name": "请输入供应商名称",
  "stores::products-info::input_weight": "请输入重量",
  "stores::products-info::is_sale": "在售",
  "stores::products-info::list": "商品列表",
  "stores::products-info::message_choose_file": "请先选择文件",
  "stores::products-info::message_choose_tag": "请先选择标签",
  "stores::products-info::message_down_fail": "下架失败",
  "stores::products-info::message_goods_text": "个商品",
  "stores::products-info::message_had_down": "已下架",
  "stores::products-info::message_had_on": "已上架",
  "stores::products-info::message_input_number": "请输入数字",
  "stores::products-info::message_input_sku": "请完整填写sku属性值",
  "stores::products-info::message_not_same": "新增的属性的值不可重复",
  "stores::products-info::message_on_fail": "上架失败",
  "stores::products-info::message_one_sku": "未添加属性只允许添加一个SKU",
  "stores::products-info::message_start_sale": "已开售",
  "stores::products-info::message_stop_fail": "失败",
  "stores::products-info::message_stop_sale": "已停售",
  "stores::products-info::message_store_text": "个店铺",
  "stores::products-info::message_three_attr": "最多只能添加3个属性",
  "stores::products-info::more": "更多",
  "stores::products-info::name": "商品名称",
  "stores::products-info::no": "否",
  "stores::products-info::none_data": "暂无数据",
  "stores::products-info::not_pricing": "未定价",
  "stores::products-info::not_release": "未发布",
  "stores::products-info::ongoing": "进行中",
  "stores::products-info::operate": "操作",
  "stores::products-info::origin_price_shipping": "原价 | 包邮",
  "stores::products-info::person": "联系人",
  "stores::products-info::phone": "联系电话",
  "stores::products-info::photos": "图片墙",
  "stores::products-info::price": "定价",
  "stores::products-info::pricing": "定价",
  "stores::products-info::purchase_price": "成本价",
  "stores::products-info::put_down": "下架",
  "stores::products-info::put_on": "上架",
  "stores::products-info::release": "发布",
  "stores::products-info::release_again": "确定需要重新发布吗？",
  "stores::products-info::release_fail": "发布失败",
  "stores::products-info::release_ing": "发布中",
  "stores::products-info::release_status": "发布状态",
  "stores::products-info::release_to_release": "发布后将把商品信息同步到 {name} 站中",
  "stores::products-info::release_wait": "待发布",
  "stores::products-info::return": "返回",
  "stores::products-info::safe_stock": "安全库存",
  "stores::products-info::sale_manager": "售卖管理",
  "stores::products-info::sale_price": "售价",
  "stores::products-info::sale_price_shipping": "售价 | 包邮",
  "stores::products-info::sale_status": "售卖状态",
  "stores::products-info::save": "保存",
  "stores::products-info::select_category": "请选择商品类目",
  "stores::products-info::select_num": "已选择 【{x}】 项 | ",
  "stores::products-info::select_photos": "请选择图片",
  "stores::products-info::select_spu_price": "请选择SPU已定价",
  "stores::products-info::select_store": "请选择店铺",
  "stores::products-info::select_supplier": "请选择供应商",
  "stores::products-info::select_tag": "请选择商品标签",
  "stores::products-info::sku": "平台SKU",
  "stores::products-info::spu": "平台SPU",
  "stores::products-info::spu_price": "SPU已定价",
  "stores::products-info::start_time": "开始时间",
  "stores::products-info::status": "状态",
  "stores::products-info::stock": "库存",
  "stores::products-info::stop_sale": "停售",
  "stores::products-info::stop_sale_tips": "确定停售吗？",
  "stores::products-info::stop_sale_to": "停售后商品将不在站点店铺 {name} 销售",
  "stores::products-info::store": "店铺",
  "stores::products-info::store_spu": "店铺SPU",
  "stores::products-info::success_number": "成功数量",
  "stores::products-info::supplier": "供应商",
  "stores::products-info::supplier_name": "供应商名称",
  "stores::products-info::supply_cost": "供货成本",
  "stores::products-info::use_stock": "可用库存",
  "stores::products-info::weight": "重量",
  "stores::products-info::yes": "是",
  "stores::products-info::attr_info": "属性信息",
  "stores::store::add_bind_confirn": "好的",
  "stores::store::add_bind_shop": "我们已收到您的申请，敬请期待",
  "stores::store::add_time": "加入时间",
  "stores::store::address": "地址",
  "stores::store::api_password": "Api密码",
  "stores::store::apply_open": "申请开放",
  "stores::store::auth": "授权店铺",
  "stores::store::authentication": "认证信息",
  "stores::store::authentication_info": "认证信息是您授权店铺数据以及订阅\r\n    店铺变更，进行站群统一管理的重要\r\n    凭证，请确保无误！其中Api Key及其\r\n    密码用于授权同步店铺数据，\r\n    webhook用于订阅店铺变更；",
  "stores::store::base_detail": "基本信息",
  "stores::store::bind_benefit": "绑定店铺后即可一站式管理您所有的站点店铺",
  "stores::store::bind_info": "系统默认授权Shoplus店铺至店铺创建人的账号，若您是该店铺员工，请联系店铺创建人进行店铺授权",
  "stores::store::bind_now": "立即绑定",
  "stores::store::bind_shop": "绑定店铺",
  "stores::store::business": "经营行业",
  "stores::store::category": "经营品类",
  "stores::store::choose_auth": "请选择需要授权该店铺的用户",
  "stores::store::choose_user": "请选择用户",
  "stores::store::city": "城市",
  "stores::store::country": "国家",
  "stores::store::create_time": "创建时间",
  "stores::store::currency": "货币",
  "stores::store::customer": "顾客",
  "stores::store::detail": "详情",
  "stores::store::edit": "编辑",
  "stores::store::edit_shop": "编辑店铺",
  "stores::store::end_time": "结束时间",
  "stores::store::fail": "失败",
  "stores::store::goods": "商品",
  "stores::store::goods_manager": "商品管理",
  "stores::store::goods::category": "商品类目",
  "stores::store::goods::compare_at_price": "原价",
  "stores::store::goods::detail": "商品详情",
  "stores::store::goods::export": "导出",
  "stores::store::goods::goods_status": "商品状态",
  "stores::store::goods::goods_stock": "商品库存",
  "stores::store::goods::input_end_time": "结束时间",
  "stores::store::goods::input_start_time": "开始时间",
  "stores::store::goods::is_sale": "开售",
  "stores::store::goods::name": "商品名称",
  "stores::store::goods::not_price": "未定价",
  "stores::store::goods::now": "当前店铺",
  "stores::store::goods::platform_sku": "平台SKU",
  "stores::store::goods::platform_spu": "平台SPU",
  "stores::store::goods::purchase_price": "成本价",
  "stores::store::goods::put_off": "下架",
  "stores::store::goods::put_on": "上架",
  "stores::store::goods::release": "发布",
  "stores::store::goods::release_again_tips": "发布后将把商品信息同步到该店铺中",
  "stores::store::goods::release_again_title": "确定需要重新发布吗？",
  "stores::store::goods::release_fail": "发布失败",
  "stores::store::goods::release_had": "已发布",
  "stores::store::goods::release_ing": "发布中",
  "stores::store::goods::release_status": "发布状态",
  "stores::store::goods::release_tips": "发布后可进行售卖管理",
  "stores::store::goods::release_title": "确认要发布该商品？",
  "stores::store::goods::release_wait": "待发布",
  "stores::store::goods::safe_stock": "安全库存",
  "stores::store::goods::sale_price": "售价",
  "stores::store::goods::sale_status": "售卖状态",
  "stores::store::goods::select_category": "请选择商品类目",
  "stores::store::goods::select_supplier": "请选择供应商",
  "stores::store::goods::spu": "商品SPU",
  "stores::store::goods::start_sale_fail": "开售失败",
  "stores::store::goods::start_sale_success": "开售成功",
  "stores::store::goods::start_sale_tips": "开售后商品将在该店铺销售",
  "stores::store::goods::start_sale_title": "确定开售吗？",
  "stores::store::goods::stop_sale": "停售",
  "stores::store::goods::stop_sale_fail": "停售失败",
  "stores::store::goods::stop_sale_success": "停售成功",
  "stores::store::goods::stop_sale_tips": "停售后商品将不在该店铺销售",
  "stores::store::goods::stop_sale_title": "确定停售吗？",
  "stores::store::goods::use_stock": "可用库存",
  "stores::store::guide": "授权指引",
  "stores::store::holder::api_secret": "请输入API Secret",
  "stores::store::holder::api_token": "请输入API Token",
  "stores::store::holder::api_uid": "请输入API UID",
  "stores::store::holder::shopify_api_key": "Shopify 店铺密钥键值 API Key",
  "stores::store::holder::shopify_api_password": "Shopify 店铺 API 密码",
  "stores::store::holder::shopify_webhook": "Shopify 店铺 Webhook 密钥",
  "stores::store::holder::shopline_token": "请输入Shopline Token",
  "stores::store::holder::shoplus_api_key": "Shoplus 店铺密钥键值 API Key",
  "stores::store::holder::shoplus_api_password": "Shoplus 店铺 API 密码",
  "stores::store::how_bind": "如何绑定Shoplus店铺",
  "stores::store::ind_domail": "独立域名",
  "stores::store::message_edit_success": "编辑成功",
  "stores::store::message_edit_success_webhook": "编辑成功，正在为您同步数据并订阅webhook",
  "stores::store::message_success": "授权店铺成功",
  "stores::store::message_success_webhook": "授权店铺成功，正在为您同步数据并订阅webhook",
  "stores::store::more": "更多",
  "stores::store::no_sync": "不同步",
  "stores::store::none_shop": "您尚未绑定店铺",
  "stores::store::open_close": "店铺启用状态，系统将为您同步数据；若为停用状态，将不同步数据；",
  "stores::store::operate": "操作",
  "stores::store::order": "订单",
  "stores::store::other_platform": "其他平台",
  "stores::store::other_platform_tips": "请选择您需要绑定的平台，若干平台尚未开放，点击「申请开放」来告诉我们吧~",
  "stores::store::phone": "联系方式",
  "stores::store::platform": "所属平台",
  "stores::store::platform::shop_name": "平台店铺名称",
  "stores::store::prev_step": "上一步",
  "stores::store::province": "省份",
  "stores::store::recommend": "推荐",
  "stores::store::recommend_paltform": "推荐平台",
  "stores::store::retry": "点击重试",
  "stores::store::rule_domain": "请输入店铺域名",
  "stores::store::rule_empty": "请输入内容",
  "stores::store::rule_error": "格式错误",
  "stores::store::rule_input_name": "请输入店铺名称",
  "stores::store::rule_input_platform": "请选择所属平台",
  "stores::store::rule_input_something": "请输入内容",
  "stores::store::rule_select_category": "请选择经营品类",
  "stores::store::rule_select_status": "请选择店铺状态",
  "stores::store::rule_shop_name": "店铺名称不得超过20字符或含有空格",
  "stores::store::rule_space": "不得含有空格",
  "stores::store::save_sync": "保存并同步",
  "stores::store::shop_close": "禁用",
  "stores::store::shop_detail": "店铺详情",
  "stores::store::shop_domail": "店铺域名",
  "stores::store::shop_guide": "{mallType} 店铺授权指引",
  "stores::store::shop_info": "店铺信息",
  "stores::store::shop_name": "店铺名称",
  "stores::store::shop_open": "启用",
  "stores::store::shop_status": "店铺状态",
  "stores::store::shopify_four": "创建成功后，将应用API key 等信息填写在右侧窗口；",
  "stores::store::shopify_one": "登录您的shopify账户",
  "stores::store::shopify_one_text": "链接：https://accounts.shopify.com/store-login",
  "stores::store::shopify_three": "点击创建新的专有应用，将所有权限设置为“读取与写入”",
  "stores::store::shopify_two": "点击菜单【应用】,进入【管理专有应用】",
  "stores::store::shopify_three_2": "若您为第一次进入此页面，请勾选以下3个复选框，并点击开启私有应用；若您已经设置过此页面，请看第四步；",
  "stores::store::shopline_one": "登录您的shopline账户",
  "stores::store::shopline_one_text": "链接：https://admin.myshopline.cn",
  "stores::store::shopline_three": "进入后，拉到页面最底部，获取Shopline Token，并将Token复制黏贴至右侧输入框中",
  "stores::store::shopline_two": "点击菜单【设置】,进入【基础设置】",
  "stores::store::shoplus_bind": "立即创建shoplus店铺",
  "stores::store::shoplus_tips": "如需绑定其他shoplus，请联系店铺管理员进行店铺授权",
  "stores::store::shoplus_title": "支持shoplus店铺自动绑定，轻松管理独立站",
  "stores::store::shopplazza_four": "将应用API key 等信息填写在右侧窗口；",
  "stores::store::shopplazza_one": "登录您的shoplazza",
  "stores::store::shopplazza_one_text": "账户链接：https://accounts.shoplazza.com/login",
  "stores::store::shopplazza_three": "创建新的专有应用，将所有权限设置为“读取与写入”",
  "stores::store::shopplazza_two": "点击菜单【应用市场】,进入【Private App】",
  "stores::store::status": "状态",
  "stores::store::success": "成功",
  "stores::store::sync": "同步",
  "stores::store::sync_again": "是否再次同步店铺数据？",
  "stores::store::sync_data_now": "店铺数据同步中!",
  "stores::store::sync_data_success": "店铺数据同步成功",
  "stores::store::sync_end": "结束同步",
  "stores::store::sync_fail": "同步失败",
  "stores::store::sync_result": "同步结果",
  "stores::store::sync_success": "同步成功",
  "stores::store::sync_time": "同步时间",
  "stores::store::sync_tips": "同步提示",
  "stores::store::syncing": "正在同步中...",
  "stores::store::task_cancel": "任务取消",
  "stores::store::task_end": "结束任务",
  "stores::store::transfer_platform": "迁移平台",
  "stores::store::transfer_result": "迁移结果",
  "stores::store::wait": "请稍候",
  "stores::store::webhook_fail": "订阅webhook失败，请重新订阅",
  "stores::store::webhook_subscribe_success": "订阅成功",
  "stores::store::webhook_tips": "提示",
  "stores::store::webhook_tips_desc": "请务必确认店铺webhook secret 填写正确",
  "stores::store::zip": "邮编",
  "STRING_TO_NUMBER_FAIL": "字符串转数字失败",
  "SUPPLIER_NOT_FOUND": "供应商(Id:%s)不存在",
  "supplier::add_button": "新增供应商",
  "supplier::edit_button": "编辑供应商",
  "supplier::form_address": "详细地址",
  "supplier::form_area": "地区",
  "supplier::form_email": "电子邮箱",
  "supplier::input_phone_num": "请输入手机号",
  "supplier::name": "供应商名称",
  "supplier::placeholder_address": "请输入详细地址",
  "supplier::placeholder_email": "请输入电子邮箱",
  "supplier::placeholder_email_wrong": "电子邮箱格式不正确",
  "supplier::placeholder_name": "按内容搜索",
  "supplier::placeholder_phone": "请输入联系电话",
  "supplier::placeholder_reSupplier": "供应商名称重复",
  "supplier::placeholder_staff": "请输入联系人",
  "supplier::placeholder_supplier": "请输入供应商名称",
  "supplier::status": "状态",
  "supplier::status_all": "全部",
  "supplier::status_off": "停用",
  "supplier::status_on": "启用",
  "supplier::table_createTime": "创建时间",
  "supplier::table_detail": "详情",
  "supplier::table_edit": "编辑",
  "supplier::table_handle": "操作",
  "supplier::table_name": "供应商名称",
  "supplier::table_no": "供应商编号",
  "supplier::table_phone": "联系电话",
  "supplier::table_staff": "联系人",
  "supplier::table_status": "状态",
  "supplier::turn_off::tip": "停用后将无法选择供应商",
  "supplier::turn_off::title": "确定需要停用供应商吗",
  "supplier::wrong": "服务器问题,请稍后再试",
  "SYSTEM_AUTH_GRANT": "账号已被冻结",
  "SYSTEM_AUTH_PENDING": "账号已被冻结",
  "system::aftermarket::source::客服部门": "客服部门",
  "system::aftermarket::source::消费者": "消费者",
  "system::aftermarket::type::已发货仅退款": "已发货仅退款",
  "system::aftermarket::type::未发货退款": "未发货退款",
  "system::aftermarket::type::补偿退款": "补偿退款",
  "system::common::404": "页面失联了，攻城狮紧急搜寻中…",
  "system::common::btn::auth_shop": "授权店铺",
  "system::common::btn::back": "返回",
  "system::common::btn::cancel": "取消",
  "system::common::btn::change_language": "切换语言系统",
  "system::common::btn::change_system_language": "切换系统语言",
  "system::common::btn::close": "关闭",
  "system::common::btn::confirm": "确定",
  "system::common::btn::doc": "操作手册",
  "system::common::btn::example": "查看示例",
  "system::common::btn::logout": "退出登录",
  "system::common::btn::no_data": "暂无数据",
  "system::common::btn::refresh": "刷新",
  "system::common::btn::reset": "重置",
  "system::common::btn::save": "保存",
  "system::common::btn::save_as": "另存为",
  "system::common::btn::search": "搜索",
  "system::common::btn::select_change_language_holder": "请选择系统语言",
  "system::common::chinese": "中文",
  "system::common::clear_all": "清空",
  "system::common::end_date": "结束日期",
  "system::common::english": "英文",
  "system::common::input_holder": "请输入",
  "system::common::input_search": "查询",
  "system::common::NO": "序号",
  "system::common::no_authority": "你暂无权限访问，请联系管理员",
  "system::common::no_authority_tooltip": "您暂未授权任何店铺",
  "system::common::select_all": "全部",
  "system::common::select_placeholder": "请选择",
  "system::common::start_date": "开始日期",
  "system::email_type::imap": "imap",
  "system::email_type::smtp": "smtp",
  "system::email::category::分类1": "分类1",
  "system::email::category::分类2": "分类2",
  "system::error::serve": "服务错误，请稍后重试",
  "system::error::upload_custom_img_tip": "上传图片失败，请稍后重试或联系管理员。",
  "system::error::upload_tip": "上传失败，请稍后重试～",
  "system::exchange-manager::cancel": "取消",
  "system::exchange-manager::change_confirm": "确认修改",
  "system::exchange-manager::confirm": "确定",
  "system::exchange-manager::confitm_title": "提示",
  "system::exchange-manager::confitm_title_tips": "确定修改当前汇率吗？",
  "system::exchange-manager::dollar": "美元",
  "system::exchange-manager::exchange_input": "请输入汇率值",
  "system::exchange-manager::rmb": "人民币",
  "system::exchange-manager::setting": "汇率设置",
  "system::exchange-manager::title": "该汇率将用于商品成本自动换算，对报表统计成本、利润存在影响",
  "system::fulfilmentstatus::已上网": "已上网",
  "system::fulfilmentstatus::已发货": "已发货",
  "system::fulfilmentstatus::已签收": "已签收",
  "system::fulfilmentstatus::待发货": "待发货",
  "system::fulfilmentstatus::待处理": "待处理",
  "system::fulfilmentstatus::退货中": "退货中",
  "system::fulfilmentstatus::部分发货": "部分发货",
  "system::fulfilmentstatus::部分签收": "部分签收",
  "system::function::delete": "删除",
  "system::function::download": "下载",
  "system::function::edit": "编辑",
  "system::inStock::type::其他入库": "其他入库",
  "system::inStock::type::备货入库": "备货入库",
  "system::inStock::type::期初入库": "期初入库",
  "system::inStock::type::采购入库": "采购入库",
  "system::order_status::售后中": "售后中",
  "system::order_status::已取消": "已取消",
  "system::order_status::已妥投": "已妥投",
  "system::order_status::已完成": "已完成",
  "system::order_status::待支付": "待支付",
  "system::order_status::待签收": "待签收",
  "system::order_status::进行中": "进行中",
  "system::order_status::部分发货": "部分发货",
  "system::outStock::type::补发出库": "补发出库",
  "system::outStock::type::销售出库": "销售出库",
  "system::pay_status::已取消": "已取消",
  "system::pay_status::已支付": "已支付",
  "system::pay_status::已退款": "已退款",
  "system::pay_status::待支付": "待支付",
  "system::pay_status::待退款": "待退款",
  "system::pay_status::支付失败": "支付失败",
  "system::pay_status::退款失败": "退款失败",
  "system::pay_status::部分退款": "部分退款",
  "system::pay_type::AsiaBill": "AsiaBill",
  "system::pay_type::bogus": "bogus",
  "system::pay_type::manual": "manual",
  "system::pay_type::OceanPayment": "OceanPayment",
  "system::pay_type::PacyPay": "PacyPay",
  "system::pay_type::PayPal": "PayPal",
  "system::pay_type::PingPongPay": "PingPongPay",
  "system::pay_type::Stripe": "Stripe",
  "system::pay_type::UseePay": "UseePay",
  "system::pay_type::WorldPay": "WorldPay",
  "system::pay_type::其他": "其他",
  "system::pay_type::未支付": "未支付",
  "system::platform::Shopify": "Shopify",
  "system::platform::Shopline": "Shopline",
  "system::platform::Shoplus": "Shoplus",
  "system::platform::Shopbase": "Shopbase",
  "system::platform::店匠": "店匠",
  "system::protocol::default": "default",
  "system::protocol::ssl": "SSL",
  "system::purchase::status::全部发货": "全部到货",
  "system::purchase::status::已关闭": "已关闭",
  "system::purchase::status::已复核": "已复核",
  "system::purchase::status::已完成": "已完成",
  "system::purchase::status::已审核": "已审核",
  "system::purchase::status::待审核": "待审核",
  "system::purchase::status::部分发货": "部分发货",
  "system::rbac": "授权管理",
  "system::rbac::add": "新增授权",
  "system::rbac::add_auth": "新增授权",
  "system::rbac::auth_block": "菜单功能权限",
  "system::rbac::auth_edit": "编辑授权",
  "system::rbac::auth_shop_input": "请输入授权店铺",
  "system::rbac::auth_tips": "提示",
  "system::rbac::check_info": "勾选即代表授权该用户查看这些店铺的数据，不勾选即无法查看",
  "system::rbac::delete": "删除",
  "system::rbac::edit": "编辑",
  "system::rbac::name": "姓名",
  "system::rbac::name_input": "请输入姓名",
  "system::rbac::name_tips": "姓名长度小于12位",
  "system::rbac::opt": "操作",
  "system::rbac::phone": "手机号码或邮箱",
  "system::rbac::phone_input": "请输入手机号",
  "system::rbac::phone_input_error": "手机号格式不正确",
  "system::rbac::phone_num": "手机号或邮箱",
  "system::rbac::phone_tips": "请输入手机号或邮箱",
  "system::rbac::search_num": "搜索姓名或手机号码或邮箱",
  "system::rbac::shop": "店铺",
  "system::rbac::shop_auth": "授权店铺",
  "system::rbac::user_cancel": "取消",
  "system::rbac::user_confirm": "确定",
  "system::rbac::user_delete_tips": "确认删除该用户吗？",
  "system::rbac::user_delete_warn": "删除后将不可撤回，请谨慎操作",
  "system::rbac::user_name": "用户姓名",
  "system::refund::type::主动退款": "主动退款",
  "system::refund::type::拒付": "拒付",
  "system::report_option::data_all": "全部",
  "system::report_option::data_area": "区间",
  "system::report_option::data_equal": "等于",
  "system::report_option::data_large": "大于",
  "system::report_option::data_large_equal": "大于等于",
  "system::report_option::data_less": "小于",
  "system::report_option::data_less_equal": "小于等于",
  "system::report_option::data_not_equal": "不等于",
  "system::responsible::供应商": "供应商",
  "system::responsible::平台": "平台",
  "system::responsible::物流商": "物流商",
  "system::sale_status::售后处理中": "售后处理中",
  "system::sale_status::售后已取消": "售后已取消",
  "system::sale_status::售后已完成": "售后已完成",
  "system::sale_status::售后异常": "售后异常",
  "system::sale_status::无售后": "无售后",
  "system::status_option::全部状态": "全部状态",
  "system::status_option::已删除": "已删除",
  "system::status_option::已禁用": "已禁用",
  "system::status_option::已结束": "已结束",
  "system::status_option::待开始": "待开始",
  "system::status_option::进行中": "进行中",
  "system::time::category::data_all": "全部",
  "system::time::category::data_in": "包含",
  "system::time::category::data_not_in": "不包含",
  "system::time::text::data_all": "全部时间",
  "system::time::text::data_auto": "自定义时间区间",
  "system::time::text::data_ecentday_notoday": "过去N天",
  "system::time::text::data_frontday": "往前N天(某一天)",
  "system::time::text::data_monthDate_today": "当月至今天",
  "system::time::text::data_monthDate_yestoday": "当月至昨天",
  "system::time::text::data_recentday": "最近N天",
  "system::time::text::include": "至",
  "system::time::text::last_month": "上月",
  "system::time::text::latest_30": "最近30天",
  "system::time::text::latest_7": "最近7天",
  "system::time::text::month": "本月至今",
  "system::time::text::today": "今天",
  "system::time::text::year": "今年",
  "system::time::text::yestoday": "昨天",
  "system::tip::active_success": "激活成功",
  "system::tip::add_success": "添加成功",
  "system::tip::audit_success": "审核成功",
  "system::tip::bind_success": "成功绑定",
  "system::tip::cancel_success": "取消成功",
  "system::tip::change_success": "修改成功",
  "system::tip::close_success": "关闭成功",
  "system::tip::control_error": "操作失败",
  "system::tip::control_success": "操作成功",
  "system::tip::copy_success": "复制成功",
  "system::tip::create_success": "新建成功",
  "system::tip::delete_success": "删除成功",
  "system::tip::edit_success": "编辑成功",
  "system::tip::in_success": "导入成功",
  "system::tip::open_success": "开启成功",
  "system::tip::pub_success": "发布成功",
  "system::tip::reject_success": "驳回成功",
  "system::tip::save_success": "保存成功",
  "system::tip::save_error": "保存失败",
  "system::tip::send_success": "发送成功",
  "system::tip::update_success": "更新成功",
  "system::tip::upload_attachment": "上传附件",
  "system::tip::upload_click": "添加附件",
  "system::tip::upload_drag_tip": "或拖放上传",
  "system::tip::upload_limit_tip": "支持最多{{ limit }}个附件，支持{{ accept }}",
  "system::tip::upload_limit_tip_new": "支持最多{ limit }个附件，支持{ accept }",
  "system::tip::upload_success": "上传成功",
  "system::trend::CPC": "CPC",
  "system::trend::CPM": "CPM",
  "system::trend::下单量": "下单量",
  "system::trend::加购率": "加购率",
  "system::trend::加购量": "加购量",
  "system::trend::发起结算率": "发起结算率",
  "system::trend::发起结账量": "发起结账量",
  "system::trend::展示量": "展示量",
  "system::trend::广告转化率": "广告转化率",
  "system::trend::浏览率": "浏览率",
  "system::trend::点击率": "点击率",
  "system::trend::点击量": "点击量",
  "TAG_NOT_FOUND": "标签（%s）不存在",
  "token_error": "token异常",
  "trackingmore_numbers_is_null": "查询到物流单数据为空",
  "UNKNOWN_SYSTEM_FAIL": "网络异常,请稍候重试",
  "update_shipping_companyid_fail": "更改物流商失败",
  "UPDATE_VOCABULARY_ERROR": "更新词汇同步商家失败",
  "UPDAYE_ERROR": "对应前端词汇已存在",
  "USER_BINDED_WECHANT": "用户手机号已经绑定微信",
  "USER_DC_DENY_AUTH": "行业saas洞察权限审核失败，请重新发起",
  "USER_DC_GRANT_AUTH": "SaaS行业洞察账号已存在，请前往登录",
  "USER_DC_PENDING_AUTH": "行业saas洞察权限审核中，请耐心等候",
  "USER_DENY_AUTH": "Saas建站权限审核失败，请重新发起",
  "USER_EXPIRE": "套餐已过期！请前往续期",
  "USER_GRANT_AUTH": "Saas建站账号已存在，请前往登录",
  "USER_NOT_AUTH": "未有Saas建站权限,请发起申请",
  "USER_NOT_BIND_COMBO": "账号未开通任何套餐",
  "USER_NOT_DC_AUTH": "未有行业saas洞察权限,请发起申请",
  "USER_NOT_DIFF": "两次密码输入不一致",
  "USER_NOT_EXIT": "该用户不存在，请优先注册",
  "USER_NOT_LEGAL_SIGN": "签名不合法",
  "USER_NOT_SIGN": "签名不能为空",
  "USER_NOTIFICATION_NOT_FOUNT": "用户消息不存在！",
  "USER_OR_PASSWORD_ERROR": "用户名或密码错误！",
  "USER_PENDING_AUTH": "Saas建站权限审核中，请耐心等候",
  "USER_TOKEN_EXPIRED": "用户令牌过期",
  "USER_TOKEN_INVALID": "用户令牌失效",
  "USER_TOKEN_UNMATCHED": "用户令牌失效（不匹配）",
  "user-guidance::data::action_bindShop": "绑定店铺",
  "user-guidance::data::action_email": "收件箱",
  "user-guidance::data::action_newGoods": "新建商品",
  "user-guidance::data::action_newOrder": "新建售后订单",
  "user-guidance::data::action_orderList": "订单列表",
  "user-guidance::data::action_sync": "一键同步",
  "user-guidance::data::ad_cost": "广告花费",
  "user-guidance::data::ad_ROI": "广告ROI",
  "user-guidance::data::ad_sales": "广告销售额",
  "user-guidance::data::ad_title": "今日广告数据",
  "user-guidance::data::analysis_bar": "成交额",
  "user-guidance::data::analysis_line": "客单价",
  "user-guidance::data::analysis_orderDate": "订单支付日期",
  "user-guidance::data::analysis_shopName": "店铺名称",
  "user-guidance::data::analysis_title": "销售分析",
  "user-guidance::data::close_tip": "是否确认关闭引导功能，关闭后不能再次打开，请谨慎操作",
  "user-guidance::data::order_button": "发货",
  "user-guidance::data::order_more": "查看更多",
  "user-guidance::data::order_operation": "操作",
  "user-guidance::data::order_orderNo": "平台订单编号",
  "user-guidance::data::order_payTime": "下单时间",
  "user-guidance::data::order_payTotalAmount": "订单金额",
  "user-guidance::data::order_quantity": "商品",
  "user-guidance::data::order_sourceNo": "店铺订单编号",
  "user-guidance::data::order_title": "待发货订单",
  "user-guidance::data::sales_title": "今日经营日报",
  "user-guidance::data::sales::sales_order_title": "订单量",
  "user-guidance::data::sales::sales_sale_title": "销售额",
  "user-guidance::data::sales::sales_saleOrder_title": "待处理售后订单",
  "user-guidance::data::sales::sales_sendOrder_title": "待发货订单",
  "user-guidance::dialog_button_auth": "立即授权",
  "user-guidance::dialog_button_noShow": "不再显示",
  "user-guidance::guide::adAccount_button": "设置Facebook账号",
  "user-guidance::guide::adAccount_text": "设置广告账号",
  "user-guidance::guide::adAccount_tip": "我们将为您拉取广告数据，提供Facebook、Google广告数据分析\r\n    ",
  "user-guidance::guide::adAccount_title": "广告账号设置",
  "user-guidance::guide::bindShop_button": "绑定店铺",
  "user-guidance::guide::bindShop_text": "绑定一家您正在运营的店铺",
  "user-guidance::guide::bindShop_tip": "店铺绑定后，系统将自动完成数据同步，实现多店铺（商品、订单、售后）统一管理，多维度的经营数据分析",
  "user-guidance::guide::bindShop_title": "店铺绑定",
  "user-guidance::guide::close": "关闭引导",
  "user-guidance::guide::email_button": "设置邮箱",
  "user-guidance::guide::email_text": "设置售后客服邮箱",
  "user-guidance::guide::email_tip": "设置邮箱后，系统可为您搭建售后服务系统，自动识别邮件所属订单，高效服务。",
  "user-guidance::guide::email_title": "售后邮箱设置",
  "user-guidance::guide::logistics_button": "绑定物流商",
  "user-guidance::guide::logistics_text": "绑定一家跨境物流商",
  "user-guidance::guide::logistics_tip": "绑定物流商，系统可为您智能推荐运输方案，并为您连接物流商系统快速发货",
  "user-guidance::guide::logistics_title": "物流商绑定",
  "user-guidance::guide::paySetting_button": "设置支付渠道",
  "user-guidance::guide::paySetting_text": "设置支付账号",
  "user-guidance::guide::paySetting_tip": "当店铺订单产生售后退款需求，您可直接进行退款操作",
  "user-guidance::guide::paySetting_title": "支付设置",
  "user-guidance::guide::title": "您好，超店BI之旅还差{step}步即可启程！",
  "user-guidance::text": "超级电商全链路数字化平台",
  "user-guidance::title": "您好！欢迎来到超店BI!",
  "VALID_REQUEST_ERROR": "非法权限请求",
  "VALIDATE_CODE_WRONG": "验证码错误",
  "VERIFY_JWT_ERROR": "token解析失败",
  "VOCABULARY_EXIST": "对应前端词汇已存在",
  "WECHAR_ALREADY_REGISTERED": "此微信已注册,不需要重复注册",
  "WECHAT_UNIONID_GET_FAIL": "请先关注Algobuy公众号",
  "work-order::auth_tooltip": "设置售后客服邮箱即可呈现【工单概览】",
  "work-order::emailType_title": "邮件类型占比",
  "work-order::notRecieve_title": "未回复率",
  "work-order::notRecieve_tooltip": "计算公式：未回复数/收到邮件数",
  "work-order::notReply_title": "未回复数",
  "work-order::notReply_tooltip": "收到邮件截至当前未回复数量",
  "work-order::recieve_title": "收到邮件数",
  "work-order::recieve_tooltip": "收到的总邮件数量",
  "work-order::recieveDate": "收到邮件时间",
  "work-order::recieveEmail_title": "收到邮件数",
  "work-order::replier::table": "回复人",
  "work-order::replier::table_12reply": "12小时内回复数",
  "work-order::replier::table_24reply": "12-24小时回复数",
  "work-order::replier::table_48reply": "24-48小时回复数",
  "work-order::replier::table_email": "收到邮件数",
  "work-order::replier::table_name": "回复人名称",
  "work-order::replier::table_notReply": "未回复数",
  "work-order::replier::table_out48reply": "超48小时回复数",
  "work-order::replier::table_reply": "回复数",
  "work-order::shopName": "店铺名称",
  "work-order::station": "站点",
  "work-order::station::table_name": "店铺名称",
  "work-order::user_title": "沟通用户数",
  "work-order::user_tooltip": "收到邮件的所属去重用户数",
  "system::document::title": "更专业高效的跨境电商经营全链路数据平台",
  "after-sales::in-box::hand_reply": "手动已回复",
  "after-sales::in-box::more": "更多",
  "after-sales::in-box::set_email_status": "设置后邮件状态将变为 已回复",
  "after-sales::in-box::set_email_status_confirm": "确定手动把邮件设置为已回复?",
  "dashboard-bi::person-board::click_top_right": "点击右上角【新建自定义报表】创建一个吧",
  "dashboard-bi::person-board::empty_board": "暂无图表",
  "dashboard-bi::person-board:add": "添加看版",
  "dashboard-bi::person-board:create": "新建自定义报表",
  "dashboard-bi::person-board:delete_tip": "确定删除看板吗？",
  "dashboard-bi::person-board:edit": "编辑看版",
  "dashboard-bi::person-board:select_holder": "请选择看板",
  "ocean-bi:供应链分析": "供应链分析",
  "ocean-bi:商户ID": "商户id",
  "ocean-bi:工单分析报表": "工单分析报表",
  "ocean-bi:广告分析": "广告分析",
  "ocean-bi:店铺ID": "店铺ID",
  "ocean-bi:营销分析报表": "营销分析报表",
  "ocean-bi:退货分析报表": "退货分析报表",
  "ocean-bi:邮件ID": "邮件ID",
  "ocean-bi:销售分析报表": "销售分析报表",
  "stores::products-info::copy_sku": "复制SKU",
  "system::rbac::phone_invited": "被邀请用户的手机号或邮箱",
  "system::rbac::phone_tips_wrong": "手机号或邮箱格式错误",
  "system::rbac::phone_tooltip": "被邀请用户需为已注册用户，如未注册请优先完成注册步骤",
  "system::tip::accept_file": "只支持【{accept}】的文件",
  "system::tip::fileSize_limit": "只支持{fileSize}M大小的文件",
  "system::tip::limit": "最多上传{limit}个文件",
  " dashboard-bi::edit-report::click_or_drop_dimension": "双击或拖拽维度字段到这里",
  "after-sales::after-sales-set::after_sales_reason_init": "引入系统售后原因",
  "after-sales::email-setting::email_sort_init": "引入系统邮件分类",
  "after-sales::email-setting::email_tag_init": "引入系统邮件标签",
  "customer::customer-manager::level_init": "引入系统顾客等级",
  "customer::customer-manager::tag_init": "引入系统顾客标签",
  "dashboard-bi::person-board::dimension_holder\r\n": "请选择联动的维度",
  "dashboard-bi::person-board::select_dimension\r\n": "选择联动的维度：",
  "ocean-bi:浏览网站": "浏览网站",
  "order-export:主订单物流状态": "主订单物流状态",
  "order-export:创建时间": "创建时间",
  "order-export:售后状态": "售后状态",
  "order-export:商品SKU": "商品SKU",
  "order-export:商品SPU": "商品SPU",
  "order-export:商品单价": "商品单价",
  "order-export:商品名称": "商品名称",
  "order-export:商品属性": "商品属性",
  "order-export:商品数量": "商品数量",
  "order-export:国家": "国家",
  "order-export:地址1": "地址1",
  "order-export:地址2": "地址2",
  "order-export:城市": "城市",
  "order-export:子订单物流状态": "子订单物流状态",
  "order-export:子订单金额": "子订单金额",
  "order-export:客户": "客户",
  "order-export:平台": "平台",
  "order-export:平台订单编号": "平台订单编号",
  "order-export:店铺": "店铺",
  "order-export:店铺订单编号": "店铺订单编号",
  "order-export:支付方式": "支付方式",
  "order-export:支付时间": "支付时间",
  "order-export:支付状态": "支付状态",
  "order-export:物流单号": "物流单号",
  "order-export:物流商": "物流商",
  "order-export:省": "省",
  "order-export:联系电话": "联系电话",
  "order-export:联系邮箱": "联系邮箱",
  "order-export:订单优惠金额": "订单优惠金额",
  "order-export:订单状态": "订单状态",
  "order-export:订单税费": "订单税费",
  "order-export:订单邮费": "订单邮费",
  "order-export:订单金额(USD)": "订单金额(USD)",
  "order-export:运费方案": "运费方案",
  "order-export:邮编": "邮编",
  "product-export:SKU": "SKU",
  "product-export:SPU": "SPU",
  "product-export:供应商": "供应商",
  "product-export:原价": "原价",
  "product-export:售价": "售价",
  "product-export:商品名称": "商品名称",
  "product-export:商品库存": "商品库存",
  "product-export:商品类目": "商品类目",
  "product-export:状态": "状态",
  "product-manager::init_cate": "引入系统商品类目",
  "stockInOut-export:SKU": "SKU",
  "stockInOut-export:sku属性": "sku属性",
  "stockInOut-export:业务类型": "业务类型",
  "stockInOut-export:仓库类型": "仓库类型",
  "stockInOut-export:创建人": "创建人",
  "stockInOut-export:创建时间": "创建时间",
  "stockInOut-export:单号": "单号",
  "stockInOut-export:商品名称": "商品名称",
  "stockInOut-export:商品类目": "商品类目",
  "stockInOut-export:审核人": "审核人",
  "stockInOut-export:审核时间": "审核时间",
  "stockInOut-export:总价": "总价",
  "stockInOut-export:数量": "数量",
  "system::common::btn::selecAll": "全选",
  "system::common::editorHeader-table::btn": "编辑表头",
  "system::common::editorHeader-table::errorTip": "请至少选择5个表头字段",
  "system::common::editorHeader-table::tip": "请选择需要显示的表格字段，拖动可更换顺序",
  "system::common::editorHeader-table::title": "表头设置",
  "system::common::tips::quick_setting": "使用系统默认数据可快速完成设置",
  "system::rbac::menu_select": "请勾选菜单功能",
  "after-sales::after-sale-list::detail_apply_refund_tips": "确定申请退款？",
  "after-sales::after-sale-list::detail_empty_refuntAmount": "退款总金额不能为0",
  "after-sales::after-sale-list::detail_refund_tips": "确定退款？",
  "after-sales::after-sale-list::detail_reject_tips": "确定驳回？",
  "dashboard-bi::edit-report::calcul_type_add": "加",
  "dashboard-bi::edit-report::calcul_type_cut": "减",
  "dashboard-bi::edit-report::calcul_type_del": "删除",
  "dashboard-bi::edit-report::calcul_type_except": "除",
  "dashboard-bi::edit-report::calcul_type_ride": "乘",
  "dashboard-bi::edit-report::cancel_input": "取消输入",
  "dashboard-bi::edit-report::count": "统计",
  "dashboard-bi::edit-report::drilling": "下钻",
  "dashboard-bi::edit-report::link": "联动",
  "dashboard-bi::edit-report::set_linkage": "设置联动",
  "dashboard-bi::edit-report::total": "合计",
  "dashboard-bi::person-board::board_download_long": "报表下载耗费时间较长，请稍后查看邮箱或重新点击下载",
  "dashboard-bi::person-board::board_filter": "报表筛选",
  "dashboard-bi::person-board::board_sended": "已发送，请查看您的邮箱",
  "dashboard-bi::person-board::board_send_tip_title": "报表发送提示",
  "dashboard-bi::person-board::board_send_wait": "正在发送明细报表到您邮件，请稍等",
  "dashboard-bi::person-board::click_to_default": "点击恢复联动初始状态",
  "dashboard-bi::person-board::detail_report_download": "明细报表下载",
  "dashboard-bi::person-board::holder_number": "请输入数字",
  "dashboard-bi::person-board::last_time": "上次更新时间",
  "dashboard-bi::person-board::report_delete": "报表删除",
  "dashboard-bi::person-board::report_download": "报表下载",
  "dashboard-bi::person-board::report_edit": "报表编辑",
  "dashboard-bi::person-board::un_link": "未进行联动选择",
  "dashboard-bi::person-board::_number_verify": "数字格式不正确",
  "ocean-bi:shoplusBI-供应链分析": "shoplusBI-供应链分析",
  "ocean-bi:shoplusBI-工单分析": "shoplusBI-工单分析",
  "ocean-bi:shoplusBI-广告分析": "shoplusBI-广告分析",
  "ocean-bi:shoplusBI-营销分析": "shoplusBI-营销分析",
  "ocean-bi:shoplusBI-退款分析": "shoplusBI-退款分析",
  "ocean-bi:shoplusBI-销售分析": "shoplusBI-销售分析",
  "ocean-query:创建订单": "创建订单",
  "ocean-query:加购": "加购",
  "ocean-query:支付成功": "支付成功",
  "ocean-query:浏览网站": "浏览网站",
  "ocean-query:进入结算页": "进入结算页",
  "stores::products-info::edit_safe_sku": "设置安全库存",
  "stores::products-info::edit_sku_title": "批量设置安全库存",
  "stores::products-info::edit_supplier_title": "批量设置供应商",
  "system::common::text::explain_tip": "说明",
  "dashboard-bi::edit-report::Illegal_computation_operation": "非法计算操作",
  "dashboard-bi::edit-report::pleace_count_select": "请选择计算方式",
  "dashboard-bi::edit-report::select_input": "请选择字段",
  "dashboard-bi::edit-report::chart_bar_report": "柱形图",
  "dashboard-bi::edit-report::chart_bar_report_tip": "1维度多数值或二维度一数值",
  "dashboard-bi::edit-report::chart_funnel_report": "漏斗图",
  "dashboard-bi::edit-report::chart_funnel_report_tip": "1维度1数值或0维度多数值",
  "dashboard-bi::edit-report::chart_index_report": "指标卡",
  "dashboard-bi::edit-report::chart_index_report_tip": "0维度1数值",
  "dashboard-bi::edit-report::chart_lineAndBar_report": "折线柱状图",
  "dashboard-bi::edit-report::chart_lineAndBar_report_tip": "1维度2数值",
  "dashboard-bi::edit-report::chart_line_report": "折线图",
  "dashboard-bi::edit-report::chart_line_report_tip": "1维度多数值或二维度一数值",
  "dashboard-bi::edit-report::chart_pie_report": "饼图",
  "dashboard-bi::edit-report::chart_pie_report_tip": "1维度1数值",
  "dashboard-bi::edit-report::chart_table": "表格",
  "dashboard-bi::edit-report::chart_table_tip": "不限维度和数值",
  "dashboard-bi::edit-report::please_select_dim_or_value": "请选择维度或数值",
  "after-sales::in-box::tabs_button": "预警规则设置",
  "after-sales::in-box::dialog_title": "邮件超时规则设置",
  "after-sales::in-box::dialog_checkbox": "消息推送提醒",
  "after-sales::in-box::当前时间": "当前时间",
  "after-sales::in-box::收件时间": "收件时间",
  "after-sales::in-box::则为超时为回复": "，则为超时为回复。",
  "after-sales::in-box::小时": "小时",
  "after-sales::in-box::请选择店铺": "请选择店铺",
  "after-sales::in-box::status_超时未回复": "超时未回复",
  "after-sales::in-box::status_未回复": "未回复",
  "after-sales::in-box::status_回复": "回复",
  "user-guidance::data::table_热销榜": "热销榜",
  "user-guidance::data::table_退款榜": "退款榜",
  "user-guidance::data::table_商品图片": "商品图片",
  "user-guidance::data::table_销量": "销量",
  "user-guidance::data::table_销量金额": "销售金额",
  "user-guidance::data::table_退款量": "退款量",
  "user-guidance::data::table_可用库存量": "可用库存量",
  "user-guidance::data::table_退款金额": "退款金额",
  "user-guidance::data::table_退款率": "退款率",
  "ad-analysis::echarts_广告营销趋势": "广告营销趋势",
  "ad-analysis::echarts_FB成交额": "FB成交额",
  "ad-analysis::echarts_谷歌成交额": "谷歌成交额",
  "ad-analysis::echarts_谷歌-ROI": "谷歌-ROI",
  "board::title_商品销售概况": "商品销售概况",
  "board::title_地区销售金额占比": "地区销售金额占比",
  "board::title_顾客消费概况": "顾客消费概况",
  "board::title_复购率月度趋势": "复购率月度趋势",
  "board::table_商品图片": "商品图片",
  "board::table_销量": "销量",
  "board::table_销售金额": "销售金额",
  "board::table_退款金额": "退款金额",
  "board::table_可用库存数量": "可用库存数量",
  "board::table_客单价": "客单价",
  "board::table_顾客名称": "顾客名称",
  "board::table_下单次数": "下单次数",
  "board::table_消费总额": "消费总额",
  "board::table_加入日期": "加入日期",
  "board::table_最近下单日期": "最近下单日期",
  "board::echarts_下单顾客数": "下单顾客数",
  "board::echarts_复购率": "复购率",
  "after-sales::after-sale-list::max_refound_money": "最大可退款金额",
  "after-sales::after-sale-list::max_refound_email": "最大可退款邮费",
  "dashboard-bi::default-board::edit_tips": "拖拽维度字段或数值字段到这里可进行数据筛选",
  "ocean-bi:加购量": "加购量",
  "ocean-bi:广告账户名称": "广告账户名称",
  "ocean-bi:邮件数": "邮件数",
  "ocean-query:总计": "总计",
  "order:fulfillmentStatus:0": "待处理",
  "order:fulfillmentStatus:1": "待发货",
  "order:fulfillmentStatus:2": "部分发货",
  "order:fulfillmentStatus:3": "已发货",
  "order:fulfillmentStatus:4": "已上网",
  "order:fulfillmentStatus:5": "部分签收",
  "order:fulfillmentStatus:6": "已签收",
  "order:fulfillmentStatus:7": "退货中",
  "order:orderStatus:0": "待支付",
  "order:orderStatus:1": "进行中",
  "order:orderStatus:4": "已完成",
  "order:orderStatus:7": "已取消",
  "order:payStatus:0": "待支付",
  "order:payStatus:1": "已支付",
  "order:payStatus:2": "支付失败",
  "order:payStatus:3": "已取消",
  "order:payStatus:4": "待退款",
  "order:payStatus:5": "部分退款",
  "order:payStatus:6": "已退款",
  "order:payStatus:7": "退款失败",
  "order:payStatus:8": "部分付款",
  "order:payType:0": "未支付",
  "order:payType:1": "PayPal",
  "order:payType:10": "manual",
  "order:payType:2": "Stripe",
  "order:payType:3": "WorldPay",
  "order:payType:4": "AsiaBill",
  "order:payType:5": "OceanPayment",
  "order:payType:6": "PacyPay",
  "order:payType:7": "PingPongPay",
  "order:payType:8": "UseePay",
  "order:payType:9": "bogus",
  "order:payType:98": "COD",
  "order:payType:99": "未知",
  "order:salesStatusName:0": "无售后",
  "order:salesStatusName:1": "售后处理中",
  "order:salesStatusName:2": "售后已完成",
  "order:salesStatusName:3": "售后异常",
  "order:salesStatusName:4": "售后已取消",
  "ORDER_PAY_STATUS_ERROR": "订单支付状态异常%s",
  "ORDER_STATUS_CANNOT_REFUND": "订单状态不支持售后",
  "product-export:商品导出表": "商品导出表",
  "product:skuStatus:0": "下架",
  "product:skuStatus:1": "上架",
  "REFUND_ORDER_AMOUNT_ZERO_ERROR": "售后金额不能为零",
  "REFUND_ORDER_CANNOT_EDIT": "当前售后单不支持编辑",
  "REFUND_ORDER_STATUS_CANNOT_EDIT": "售后单状态编辑非法",
  "REFUND_SHIP_AMOUNT_IS_TOO_LARGE": "退款邮费大于可退款邮费",
  "stockInOut-export:仓库单导出表": "仓库单导出表",
  "stockInOut-export:入库": "入库",
  "stockInOut-export:其他入库": "其他入库",
  "stockInOut-export:出库": "出库",
  "stockInOut-export:备货入库": "备货入库",
  "stockInOut-export:期初入库": "期初入库",
  "stockInOut-export:补发出库": "补发出库",
  "stockInOut-export:采购入库": "采购入库",
  "stockInOut-export:销售出库": "销售出库",
  "storage::in-stock::add_stock_no": "仓库单号",
  "storage::out-stock::add_stock_no": "仓库单号",
  "stores::order::all_goods_number": "共{number}件商品",
  "stores::order::delivery_info": "发货信息",
  "stores::order::deliver_message": "请选择发货商品",
  "stores::order::total_weight": "重量合计",
  "stores::order::确定发货": "确定发货",
  "stores::order::选择商品": "选择商品",
  "stores::order::选择选择运输方案": "选择选择运输方案",
  "system::common::btn::help": "帮助",
  "system::common::btn::pick_up": "收起",
  "system::common::btn::unfold": "展开",
  "system::common::input_number": "请输入非负数",
  "system::common::modal_title_add": "新增",
  "system::common::text::add": "新增",
  "system::common::btn::check_report": "查看报表",
  "after-sales::in-box::邮件信息": "邮件信息",
  "after-sales::in-box::订单信息": "订单信息",
  "customer::customer-list::是否订阅": "是否订阅",
  "system::exchange-manager::change_rate": "修改汇率",
  "after-sales::after-sale-list::all_refund_amount": "可退款金额",
  "after-sales::after-sale-list::new_select_order_tips": "请选择要退款的订单",
  "after-sales::after-sale-list::order_amount": "订单金额",
  "after-sales::after-sale-list::select_order": "选择订单",
  "menu::storage::stocks-analysis": "库存概览",
  "refundOrder-export:afterSalesSource:供应商": "供应商",
  "refundOrder-export:afterSalesSource:消费者": "消费者",
  "refundOrder-export:afterSalesSource:物流商": "物流商",
  "refundOrder-export:afterSalesType:已发货仅退款": "已发货仅退款",
  "refundOrder-export:afterSalesType:未发货退款": "未发货退款",
  "refundOrder-export:afterSalesType:补偿退款": "补偿退款",
  "refundOrder-export:fulfillmentStatusText:已上网": "已上网",
  "refundOrder-export:fulfillmentStatusText:已发货": "已发货",
  "refundOrder-export:fulfillmentStatusText:已签收": "已签收",
  "refundOrder-export:fulfillmentStatusText:待发货": "待发货",
  "refundOrder-export:fulfillmentStatusText:待处理": "待处理",
  "refundOrder-export:fulfillmentStatusText:退货中": "退货中",
  "refundOrder-export:fulfillmentStatusText:部分发货": "部分发货",
  "refundOrder-export:fulfillmentStatusText:部分签收": "部分签收",
  "refundOrder-export:SKU": "SKU",
  "refundOrder-export:statusText:无售后": "无售后",
  "refundOrder-export:statusText:有售后": "有售后",
  "refundOrder-export:优惠": "优惠",
  "refundOrder-export:单价": "单价",
  "refundOrder-export:发货状态": "发货状态",
  "refundOrder-export:售后单导出表": "售后单导出表",
  "refundOrder-export:售后数量": "售后数量",
  "refundOrder-export:售后来源": "售后来源",
  "refundOrder-export:售后类型": "售后类型",
  "refundOrder-export:子订单号": "子订单号",
  "refundOrder-export:小计": "小计",
  "refundOrder-export:店铺": "店铺",
  "refundOrder-export:店铺订单号": "店铺订单号",
  "refundOrder-export:状态": "状态",
  "refundOrder-export:申请人": "申请人",
  "refundOrder-export:申请时间": "申请时间",
  "refundOrder-export:购买数量": "购买数量",
  "refundOrder-export:退款": "退款",
  "refundOrder-export:退款邮费": "退款邮费",
  "refundOrder-export:邮费": "邮费",
  "shop-site::empty::authorize_status_tips": "ApiKey或ApiSecret错误",
  "shop-site::empty::已授权": "已授权",
  "shop-site::empty::授权失败": "授权失败",
  "shop-site::empty::未授权": "未授权",
  "shop-site::logistics::table_status": "状态",
  "shop-site::logistics::云途物流": "云途物流",
  "shop-site::logistics::递四方": "递四方",
  "storage::in-stock::order_num": "单号",
  "storage::stock-analysis::customer_price": "客单价",
  "storage::stock-analysis::fifteen_day": "近15天",
  "storage::stock-analysis::final_price": "销售金额",
  "storage::stock-analysis::full_days": "满足天数",
  "storage::stock-analysis::full_days_tips": "可用库存 / 近{day}天日均销量",
  "storage::stock-analysis::order": "单",
  "storage::stock-analysis::prod_name": "商品名称",
  "storage::stock-analysis::purchase_click": "点击查看建议采购的SPU",
  "storage::stock-analysis::purchase_suggest": "建议采购",
  "storage::stock-analysis::purchase_tips": "当满足天数少于{day}天，则建议采购",
  "storage::stock-analysis::purchase_unfinished": "未完成采购单",
  "storage::stock-analysis::purchase_unfinished_click": "点击查看未完成采购的SPU",
  "storage::stock-analysis::purchase_unfinished_tips": "已复审未完成的采购单",
  "storage::stock-analysis::rule_setting": "规则设置",
  "storage::stock-analysis::rule_set_tips": "设置天数不可大于30天",
  "storage::stock-analysis::sales_down": "销量下降",
  "storage::stock-analysis::sales_down_click": "点击查看销量下降的SPU",
  "storage::stock-analysis::sales_down_tips": "本周期{day}天环比上一周期，销量下降{percentage}%",
  "storage::stock-analysis::sales_rise": "销量上涨",
  "storage::stock-analysis::sales_rise_click": "点击查看销量上涨的SPU",
  "storage::stock-analysis::sales_rise_tips": "本周期{day}天环比上一周期，销量上涨{percentage}%",
  "storage::stock-analysis::sales_trend": "销售趋势",
  "storage::stock-analysis::seven_day": "近7天",
  "storage::stock-analysis::stock_in_amount": "已下采购单（已审核）为到货的数量",
  "storage::stock-analysis::stock_in_comming": "在途库存",
  "storage::stock-analysis::suggest_purchase": "建议采购",
  "storage::stock-analysis::three_day": "近3天",
  "storage::stock-analysis::un_move": "不动销商品",
  "storage::stock-analysis::un_move_click": "点击查看滞销SPU",
  "storage::stock-analysis::un_move_tips": "近{day}天销量为零",
  "storage::stock-analysis::供应商": "供应商",
  "storage::stock-analysis::可用库存": "可用库存",
  "storage::stock-analysis::可用库存 / 近": "可用库存 / 近",
  "storage::stock-analysis::商品信息": "商品信息",
  "storage::stock-analysis::商品库存": "商品库存",
  "storage::stock-analysis::天日均销量": "天日均销量",
  "storage::stock-analysis::天时该SPU为建议采购": "天时，该SPU为建议采购",
  "storage::stock-analysis::天环比上一周期销量上涨": "天环比上一周期，销量上涨",
  "storage::stock-analysis::天环比上一周期销量下降": "天环比上一周期销量下降",
  "storage::stock-analysis::天销量为零该SPU为不动销商品": "天销量为零，该SPU为不动销商品",
  "storage::stock-analysis::当满足天数少于": "当满足天数少于",
  "storage::stock-analysis::待发货": "待发货",
  "storage::stock-analysis::成本价": "成本价",
  "storage::stock-analysis::本周期": "本周期",
  "storage::stock-analysis::该SPU为销量上涨": "该SPU为销量上涨",
  "storage::stock-analysis::该SPU为销量下降": "该SPU为销量下降",
  "storage::stock-analysis::近": "近",
  "storage::stock-analysis::销量": "销量",
  "stores::order::d4px": "递四方",
  "stores::order::tax_amount": "税费",
  "system::purchase::status::全部到货": "全部到货",
  "system::purchase::status::部分到货": "部分到货",
  "ORDER_ITEMS_AMOUNT_DISCORD": "订单支付金额和子订单支付金额对不上(公式:payAmount:[[%s]] - taxAmount:[[%s]] = SUM(itemPayAmount)):[[%s]]",
  "stores::products-info::add_attr": "添加属性",
  "stores::products-info::height": "高",
  "stores::products-info::long": "长",
  "stores::products-info::width": "宽",
  "system::common::merchant-tip": "系统检测到您已经切换到商家{merchantName}，将为您更新同步页面。",
  "system::common::ok": "好的",
  "shop-site::empty::ad_bind_google": " 绑定Google账号 ",
  "shop-site::empty::ad_google_tips": "绑定后您可实时了解Google广告效益",
  "shop-site::empty::pay_tips": "绑定支付账号，售后退款一步到位",
  "shop-site::empty::pay_title": "您尚未绑定支付账号",
  "shop-site::logistics::auth": "授权",
  "stores::order::apartment": "寓所",
  "stores::order::check": "查看",
  "stores::order::street": "街道",
  "system::common::dialog::change_merchant_tooltip": "提示",
  "user-guidance::data::rank": "排名",
  "user-guidance::guide::adAccount_button_google": "设置Google账号",
  "menu::stores::album": "商品专辑",
  "system::tip::refresh_success": "刷新成功",
  "store::album::list_同步日志": "同步日志",
  "store::album::list_已删除": "已删除",
  "store::album::list_未删除": "未删除",
  "store::album::list_新增专辑": "新增专辑",
  "store::album::list_批量删除": "批量删除",
  "store::album::list_同步专辑": "同步专辑",
  "store::album::list_请选择状态": "请选择状态",
  "store::album::list_请选择店铺": "请选择店铺",
  "store::album::list_请输入专辑标题": "请输入专辑标题",
  "store::album::list_自动": "自动",
  "store::album::list_手动": "手动",
  "store::album::list_接口调用失败": "接口调用失败",
  "store::album::list_确认要删除专辑？": "确认要删除专辑？",
  "store::album::list_专辑删除后将无法恢复，请谨慎操作！": "专辑删除后将无法恢复，请谨慎操作！",
  "store::album::list_序号": "序号",
  "store::album::list_店铺": "店铺",
  "store::album::list_专辑": "专辑",
  "store::album::list_专辑类型": "专辑类型",
  "store::album::list_专辑商品": "专辑商品",
  "store::album::list_创建人": "创建人",
  "store::album::list_更新日期": "更新日期",
  "store::album::list_状态": "状态",
  "store::album::list_操作": "操作",
  "store::album::list_发布": "发布",
  "store::album::list_更多": "更多",
  "store::album::list_复制": "复制",
  "store::album::list_刷新商品": "刷新商品",
  "store::album::list_新建未发布": "新建未发布",
  "store::album::list_编辑待发布": "编辑待发布",
  "store::album::list_删除待发布": "删除待发布",
  "store::album::list_已发布": "已发布",
  "store::album::list_发布失败": "发布失败",
  "store::album::edit_基本信息": "基本信息",
  "store::album::edit_自动tip": "符合所设置的条件的现有产品和将来的产品会自动被添加到此商品专辑中。",
  "store::album::edit_手动tip": "手动将商品添加到此专辑中,只会包括现在添加到商品。",
  "store::album::edit_专辑图片": "专辑图片",
  "store::album::edit_图片描述": "图片描述",
  "store::album::edit_推荐尺寸": "推荐尺寸",
  "store::album::edit_图片tip": "图片无法加载时显示的文字",
  "store::album::edit_标题": "标题",
  "store::album::edit_专辑描述": "专辑描述",
  "store::album::edit_图片描述tip": "如：新春上新",
  "store::album::edit_商品列表": "商品列表",
  "store::album::edit_已选商品": "已选商品",
  "store::album::edit_刷新列表": "刷新列表",
  "store::album::edit_设置商品条件": "设置商品条件",
  "store::album::edit_添加商品": "添加商品",
  "store::album::edit_请输入商品名称或SPU搜索": "请输入商品名称或SPU搜索",
  "store::album::edit_商品专辑角标": "商品专辑角标",
  "store::album::edit_请选择店铺": "请选择店铺",
  "store::album::edit_请填写标题": "请填写标题",
  "store::album::edit_确认要切换店铺吗？": "确认要切换店铺吗？",
  "store::album::edit_确认要切换专辑模式吗？": "确认要切换专辑模式吗？",
  "store::album::edit_切换后已有商品列表将被清空！": "切换后已有商品列表将被清空！",
  "store::album::edit_请添加商品": "请添加商品",
  "store::album::edit_商品名称": "商品名称",
  "store::album::edit_条件": "条件",
  "store::album::edit_所有条件": "所有条件",
  "store::album::edit_所有条件tip": "满足全部条件添加到商品专辑",
  "store::album::edit_任一条件": "任一条件",
  "store::album::edit_任一条件tip": "满足任一条件添加到商品专辑",
  "store::album::edit_特殊过滤规则": "特殊过滤规则",
  "store::album::edit_特殊过滤规则tip": "输入的spu将会过滤掉，不在规则下商品专辑展示",
  "store::album::edit_包含": "包含",
  "store::album::edit_tip": "如：2223641，2225481，4455111",
  "store::album::edit_商品类目": "商品类目",
  "store::album::edit_商品库存": "商品库存",
  "store::album::edit_商品标签": "商品标签",
  "store::album::edit_商品售价": "商品售价",
  "store::album::edit_大于": "大于",
  "store::album::edit_等于": "等于",
  "store::album::edit_小于": "小于",
  "store::album::edit_不包含": "不包含",
  "store::album::edit_不等于": "不等于",
  "store::album::edit_开头为": "开头为",
  "store::album::edit_结尾为": "结尾为",
  "store::album::edit_请按规则输入SPU": "请按规则输入SPU",
  "store::album::edit_请填写完整条件": "请填写完整条件",
  "store::album::log_同步日志": "同步日志",
  "store::album::log_店铺": "店铺",
  "store::album::log_发生同步记录": "发生同步记录",
  "store::album::log_同步数量": "同步数量",
  "store::album::log_成功数量": "成功数量",
  "store::album::log_失败数量": "失败数量",
  "store::album::log_同步商品专辑": "同步商品专辑",
  "store::album::log_选择店铺": "选择店铺",
  "store::album::log_请选择店铺": "请选择店铺",
  "store::album::log_同步tip": "ShoplusBI与Shoplus店铺商品专辑存在差异，Shoplus店铺新建商品专辑为可同步专辑。",
  "store::album::log_请选择需要同步的专辑": "请选择需要同步的专辑",
  "store::album::log_同步title": "同步将以「店铺端」数据为准，请检查后再点击确定",
  "store::album::log_请选择专辑": "请选择专辑",
  "store::album::log_序号": "序号",
  "store::album::log_专辑标题": "专辑标题",
  "store::album::log_变更": "变更",
  "system::common::dialog::change_merchant_tooltip_message": "是否确认切换至【{userName}】?",
  "system::common::dialog::message_manage": "消息中心",
  "system::common::dialog::message_more": "查看更多",
  "customer::customers-notice::预计": "预计",
  "customer::customers-notice::预计\"": "预计",
  "system::common::dtalog::change_merchant_tooltip": "提示",
  "user-guidance::data::count": "{data}个",
  "user-guidance::data::my_company": "我的企业",
  "shop-site::taskCenter::tips": "仅保留近1个月任务历史",
  "shop-site::taskCenter::任务对象": "任务对象",
  "shop-site::taskCenter::任务时间": "任务时间",
  "shop-site::taskCenter::任务类型": "任务类型",
  "shop-site::taskCenter::任务结果": "任务结果",
  "shop-site::taskCenter::任务进度": "任务进度",
  "shop-site::taskCenter::商品专辑同步": "商品专辑同步",
  "shop-site::taskCenter::失败": "失败",
  "shop-site::taskCenter::已完成": "已完成",
  "shop-site::taskCenter::店铺数据同步": "店铺数据同步",
  "shop-site::taskCenter::操作": "操作",
  "shop-site::taskCenter::结束": "结束",
  "shop-site::taskCenter::详情": "详情",
  "shop-site::taskCenter::请选择任务类型": "请选择任务类型",
  "shop-site::taskCenter::请选择任务进度": "请选择任务进度",
  "shop-site::taskCenter::进行中": "进行中",
  "shop-site::taskCenter::商品": "商品",
  "shop-site::taskCenter::商品专辑": "商品专辑",
  "shop-site::taskCenter::已取消": "已取消",
  "shop-site::taskCenter::店铺": "店铺",
  "shop-site::taskCenter::待处理": "待处理",
  "shop-site::taskCenter::订单": "订单",
  "shop-site::taskCenter::顾客": "顾客",
  "menu::stores::task-center": "任务中心",
  "stores::sync-log::empty": "暂无同步历史",
  "stores::sync-log::interrupt": "同步中断，存量数据暂未同步，请再次进行全量同步",
  "stores::sync-log::SKU数量": "SKU数量",
  "stores::sync-log::sync-complete": "{title}同步已完成",
  "stores::sync-log::sync-fail": "{title}同步失败",
  "stores::sync-log::sync-fail-data": "同步失败数据",
  "stores::sync-log::tips": "仅保留近1个月的历史数据",
  "stores::sync-log::title": "店铺同步日志",
  "stores::sync-log::全部": "全部",
  "stores::sync-log::原因": "原因",
  "stores::sync-log::原因及措施": "原因及措施",
  "stores::sync-log::同步": "同步",
  "stores::sync-log::同步历史": "同步历史",
  "stores::sync-log::商品": "商品",
  "stores::sync-log::商品名称": "商品名称",
  "stores::sync-log::失败": "失败",
  "stores::sync-log::客户": "客户",
  "stores::sync-log::店铺信息": "店铺信息",
  "stores::sync-log::成功": "成功",
  "stores::sync-log::结果": "结果",
  "stores::sync-log::订单": "订单",
  "stores::sync-log::订单编号": "订单编号",
  "stores::sync-log::订单金额": "订单金额",
  "stores::sync-log::邮箱": "邮箱",
  "stores::sync-log::顾客": "顾客",
  "stores::sync-log::变更": "变更",
  "stores::sync-log::同步中": "同步中",
  "stores::sync-log::商品专辑": "商品专辑",
  "查看更多>>": "stores::store::check-more",
  "stores::store::check-more": "查看更多>>",
  "stores::store::api-invalid": "该店铺认证信息（ApiKey等）已失效，无法同步！",
  "stores::store::edit-again": "请重新编辑店铺认证信息",
  "stores::store::goto-edit": "前往编辑",
  "stores::store::offline": "网络异常，同步失效，请稍后重试!",
  "stores::sync-log::album-title": "商品专辑同步日志",
  "stores::store::sync_log": "同步日志",
  "stores::sync-log::删除": "删除",
  "stores::sync-log::新增": "新增",
  "stores::sync-log::编辑": "编辑",
  "stores::store::syncing2": "同步中",
  "stores::sync-log::sync-cancel": "{title}同步已取消",
  "stores::sync-log::sync-loading": "{title}正在同步中",
  "stores::sync-log::结束同步": "结束同步",
  "stores::sync-log::sync-wait": "任务等待处理中",
  "stores::sync-log::sync-album-success": "商品专辑同步完成",
  "stores::sync-log::sync-shop-success": "店铺数据同步完成",
  "stores::order::ship_auth": "物流授权失败，点击",
  "stores::order::剩余可退款金额": "剩余可退款金额",
  "stores::order::售后信息": "售后信息",
  "stores::order::重新授权": "重新授权",
  "stores::products-info::商品图片": "商品图片",
  "stores::products-info::图片": "图片",
  "purchase::purchase-list::计划到货日期": "计划到货日期",
  "stores::sync-log::number-tips": "发现同步数量与店铺端数量不一致？多半因为服务中断，您可再次进行同步",
  "stores::task-center::end-all-task-tips": "订单、顾客强关联商品，取消商品同步将同时取消订单、顾客的同步进程，是否确认结束商品同步？",
  "stores::task-center::end-task-tips": "确认结束该任务吗？",
  "stores::task-center::提示": "提示",
  "product-manager::products-info::delete_tip": "此操作将会删除该项，是否继续？",
  "stores::store::shopbase_one": "登录您的shopbase账户",
  "stores::store::shopbase_two": "点击菜单【应用】,下拉到最底下，点击【管理私人应用】",
  "stores::store::shopbase_three": "进入后，点击【创建一个新的私人应用程序】",
  "stores::store::shopbase_four": "请将所有Api权限全部设置为“阅读与写作”，填写完其余信息后提交保存",
  "stores::store::shopbase_five": "创建应用成功后，请将相关密钥依次复制黏贴至右侧认证信息输入框中",
  "stores::store::shopbase_one_text": "链接：https://accounts.shopbase.com/sign-in",
  "stores::store::label::shopbase_api_key": "API密钥",
  "stores::store::label::shopify_api_secret": "API密码",
  "stores::store::label::shopbase_api_secret": "API密码",
  "stores::store::label::shopbase_webhook": "共享机密",
  "stores::store::holder::shopbase_api_key": "请输入API密钥",
  "stores::store::holder::shopbase_api_secret": "请输入API密码",
  "stores::store::holder::shopbase_webhook": "请输入共享机密",
  "user-guidance::data::ad_tip": "您尚未设置广告账户",
  "ad-analysis::auth_fb": "设置FB账号",
  "ad-analysis::auth_google": "设置谷歌账号",
  "product-manager::products-info::delete_goods_tip": "商品删除后无法恢复，请谨慎操作！",
  "product-manager::products-info::delete_goods_title": "确认要删除商品？",
  "system::rbac::新增角色": "新增角色",
  "system::rbac::搜索角色名称": "搜索角色名称",
  "system::rbac::员工角色分配": "员工角色分配",
  "system::rbac::角色权限设置": "角色权限设置",
  "system::rbac::role_waring": "当前角色下仍有员工，不可删除",
  "system::rbac::role_delete_title": "确认删除该角色吗？",
  "system::rbac::role_delete_tip": "删除后将不可撤回，请谨慎操作",
  "system::rbac::删除角色": "删除角色",
  "system::rbac::搜索姓名或手机号码": "搜索姓名或手机号码",
  "system::rbac::添加员工": "添加员工",
  "system::rbac::账号姓名": "账号姓名",
  "system::rbac::账号": "账号",
  "system::rbac::staff_title": "确认删除该用户吗？",
  "system::rbac::staff_tip": "删除后将不可撤回，请谨慎操作",
  "system::rbac::删除用户": "删除用户",
  "system::rbac::菜单功能权限": "菜单功能权限",
  "system::rbac::数据权限": "数据权限",
  "system::rbac::看板权限": "看板权限",
  "system::rbac::模型权限": "模型权限",
  "system::rbac::请输入账号": "请输入账号",
  "system::rbac::角色姓名": "角色姓名",
  "system::rbac::角色描述": "角色描述",
  "system::rbac::请输入角色姓名": "请输入角色姓名",
  "system::rbac::请输入角色描述": "请输入角色描述",
  "system::rbac::全部店铺": "全部店铺",
  "system::rbac::auth_data_tip": "勾选”全部店铺“即代表全部店铺数据可见，新增店铺时也将自动授予该角色",
  "system::rbac::auth_board_tip": "勾选即代表授权该角色用户查看该看板，不勾选则无法查看",
  "system::rbac::auth_model_tip": "模型权限控制可下钻到模型的维度以及维度的值，勾选模型默认全选全部维度及其值，可编辑变更",
  "system::rbac::staff_palceholder": "请输入注册手机号或邮箱或授权码",
  "storage::in-stock::入库单信息": "入库单信息",
  "storage::in-stock::入库商品信息": "入库商品信息",
  "storage::out-stock::出库单信息": "出库单信息",
  "storage::out-stock::出库商品信息": "出库商品信息",
  "system::rbac::搜索模型名称": "搜索模型名称",
  "system::rbac::valueAuth_title": "角色模型-维度-值权限",
  "system::rbac::字段值列表": "字段值列表",
  "system::rbac::已选字段值": "已选字段值",
  "system::rbac::请输入内容": "请输入内容",
  "system::rbac::设置": "设置",
  "system::rbac::未授权": "未授权",
  "system::rbac::已授权": "已授权",
  " dashboard-bi::edit-report::drill": "钻取",
  "AUTHORIZE_ERROR": "权限异常",
  "dashboard-bi::board-management::add": "新增看板",
  "dashboard-bi::board-management::belong-holder": "请选择所属文件夹",
  "dashboard-bi::board-management::delete-tips": "该看板删除后将无法恢复，是否删除？",
  "dashboard-bi::board-management::input-holder": "请输入看板名称",
  "dashboard-bi::board-management::select-folder-holder": "请输入文件夹",
  "dashboard-bi::board-management::select-holder": "搜索看板名称",
  "dashboard-bi::board-management::删除确认": "删除确认",
  "dashboard-bi::board-management::可见人": "可见人",
  "dashboard-bi::board-management::备注": "备注",
  "dashboard-bi::board-management::已选角色": "已选角色",
  "dashboard-bi::board-management::所属文件夹": "所属文件夹",
  "dashboard-bi::board-management::操作": "操作",
  "dashboard-bi::board-management::新建看板": "新建看板",
  "dashboard-bi::board-management::更新时间": "更新时间",
  "dashboard-bi::board-management::看板名称": "看板名称",
  "dashboard-bi::board-management::编辑看板名称": "编辑看板名称",
  "dashboard-bi::board-management::角色列表": "角色列表",
  "dashboard-bi::board-management::角色选择": "角色选择",
  "dashboard-bi::board-management::设置权限": "设置权限",
  "menu::data-board-customer::big-screen": "MW数据看板",
  "menu::data-board-customer": "报表中心",
  "menu::board-center-setting": "公共看板管理",
  "menu::personal-board-setting": "个人看板管理",
  "menu::data-board-customer::board-management": "看板管理",
  "menu::data-board-customer::day-board": "pearlgo经营日报",
  "menu::data-board-customer::market-board": "营销分析",
  "purchase::purchase-list::dialog-tips": "删除确认",
  "purchase::purchase-list::operate": "操作",
  "purchase::purchase-list::purchase-goods-title": "采购商品信息",
  "purchase::purchase-list::purchase-order-title": "采购订单信息",
  "SHOP_DOMAIN_BIND": "该C端店铺已绑定，请联系该商家进行授权",
  "stores::order::open": "展开",
  "stores::order::put_awary": "收起",
  "stores::products-info::upload-size-tips": "上传头像图片大小不能超过 2MB!",
  "stores::products-info::upload-type-tips": "上传头像图片只能是 JPG 或者PNG 格式!",
  "system::common::compare_result": "环比结果",
  "system::common::current_num": "本期值",
  "system::common::dtalog::change_merchant_tooltip_message": "是否确认切换至【{userName}】?",
  "system::common::dtalog::message_manage": "消息中心",
  "system::common::dtalog::message_more": "查看更多",
  "system::common::last_num": "上期值",
  "system::common::statistics_days": "统计天数",
  "system::common::text::explain": "说明",
  "提示": "purchase::purchase-list::dialog-tips",
  "此操作将会删除该项，是否继续？": "product-manager::products-info::delete_tip",
  "menu::data-board-customer::pearlgo-screen": "Pearlgo数据看板",
  "login::register::button": "注册并登录",
  "login::rule::check_email": "邮箱已注册，请更换邮箱或",
  "login::rule::check_phone": "手机号已注册，请重新输入或",
  "login::tips::login": "前往登录",
  "login::valid::button": "认证失败",
  "login::valid::error": "认证失败",
  "login::valid::tips": "您的认证信息错误或连接超时，请登录账号后重新认证",
  "menu::dashboard-bi::big-screen": "大屏看板",
  "menu::dashboard-bi::board-management": "看板管理",
  "menu::dashboard-bi::day-board": "经营日报",
  "menu::dashboard-bi::market-board": "营销分析",
  "menu::dashboard-bi::pearlgo-screen": "Pearlgo数据看板",
  "menu::dashboard-bi::person-board": "个人文件夹",
  "menu::admin-config": "后台管理",
  "personal::contract::agree_tips": "签约即代表您同意",
  "personal::contract::choose_pay_type": "选择付费方式",
  "personal::contract::GVM抽佣": "GVM抽佣",
  "personal::contract::stripe账号": "stripe账号",
  "personal::contract::write_pay_info": "填写支付信息",
  "personal::contract::套餐包含": "套餐包含",
  "personal::contract::套餐选择": "套餐选择",
  "personal::contract::有效期": "有效期",
  "personal::contract::服务协议": "服务协议",
  "personal::contract::确认签约": "确认签约",
  "personal::contract::购买账户": "购买账户",
  "menu::personal::contract-manager": "合约管理",
  "menu::personal::my-contract": "我的合约",
  "menu::personal::open-contract": "开通合约",
  "menu::contract-manager": "套餐管理",
  "menu::contract-manager::my-contract": "我的套餐",
  "menu::contract-manager::open-contract": "开通套餐",
  "menu::rl-day-board": "RL经营日报",
  "rl-screen": "RL数据看板",
  "personal::my-contract::GMV抽佣": "GMV抽佣",
  "personal::my-contract::付款方式": "付款方式",
  "personal::my-contract::合约信息": "合约信息",
  "personal::my-contract::合约状态": "合约状态",
  "personal::my-contract::套餐价格": "套餐价格",
  "personal::my-contract::套餐有效期": "套餐有效期",
  "personal::my-contract::账户信息": "账户信息",
  "personal::my-contract::购买套餐": "购买套餐",
  "personal::contract::pay_error_tips": "绑卡异常 请换卡绑定",
  "personal::contract::确定签约": "确定签约",
  "personal::contract::签约成功": "签约成功",
  "personal::my-contract::GMV抽佣比例": "GMV抽佣比例",
  "personal::contract::GMV抽佣": "GMV抽佣",
  "personal::my-contract::冻结": "冻结",
  "personal::my-contract::初始化": "初始化",
  "personal::my-contract::天": "天",
  "personal::my-contract::套餐资费": "套餐扣费金额",
  "personal::my-contract::完成": "完成",
  "personal::my-contract::年": "年",
  "personal::my-contract::年付": "年付",
  "personal::my-contract::抽佣比例": "抽佣比例",
  "personal::my-contract::日付": "日付",
  "personal::my-contract::月": "月",
  "personal::my-contract::月付": "月付",
  "personal::my-contract::正常": "正常",
  "personal::my-contract::结算日期": "结算日期",
  "personal::my-contract::订单编号": "订单编号",
  "personal::my-contract::购买账户": "购买账户",
  "menu::data-board-customer::rl-day-board": "经营日报",
  "menu::data-board-customer::rl-screen": "RL数据看板",
  "menu::person-board": "个人文件夹",
  "menu::person-board-customer": "个人文件夹",
  "menu::system::board-management": "看版管理",
  "personal::my-contract::orderstatus0": "到达结算日后计算周期扣费",
  "personal::my-contract::orderstatus1": "成功",
  "personal::my-contract::orderstatus2": "第一次扣款待支付",
  "personal::my-contract::orderstatus3": "第二次扣款待支付",
  "personal::my-contract::orderstatus4": "第三次扣款待支付",
  "personal::my-contract::orderstatus5": "冻结",
  "personal::my-contract::取消": "取消",
  "personal::my-contract::订单状态": "订单状态",
  "menu::data-board-customer::mw-day-board": "MW经营日报",
  "menu::data-board-customer::gl-day-board": "GL经营日报",
  "menu::data-board-customer::gl-screen": "GL数据看板",
  "dashboard-bi::default-board::新窗口打开": "新窗口打开",
  "menu::account-manager": "账号管理",
  "menu::account-manager::my-account": "我的账号",
  "menu::personal-message": "消息中心",
  "menu::personal-message::my-message": "我的消息",
  "personal::account-manager::my-account_账号绑定": "账号绑定",
  "personal::account-manager::my-account_手机号": "手机号",
  "personal::account-manager::my-account_未绑定": "未绑定",
  "personal::account-manager::my-account_绑定": "绑定",
  "personal::account-manager::my-account_已绑定": "已绑定",
  "personal::account-manager::my-account_邮箱": "邮箱",
  "personal::account-manager::my-account_尚未认证": "尚未认证",
  "personal::account-manager::my-account_立即认证": "立即认证",
  "personal::account-manager::my-account_已认证": "已认证",
  "personal::account-manager::my-account_绑定手机号": "绑定手机号",
  "personal::account-manager::my-account_邮箱认证": "邮箱认证",
  "personal::account-manager::my-account_手机号码": "手机号码",
  "personal::account-manager::my-account_邮箱账号": "邮箱账号",
  "personal::account-manager::my-account_验证信息": "验证信息",
  "personal::account-manager::my-account_发送验证码": "发送验证码",
  "personal::account-manager::my-account_请输入邮箱账号": "请输入邮箱账号",
  "personal::account-manager::my-account_请输入手机号码": "请输入手机号码",
  "personal::account-manager::my-account_请输入验证码": "请输入验证码",
  "system::tip::send_fail": "发送失败",
  "system::tip::valid_success": "验证成功",
  "system::common::select_all_shop": "全部店铺",
  "menu::system::team-manager": "团队管理",
  "menu::config-manager": "配置管理",
  "menu::config-manager::operate-config": "经营配置",
  "menu::operate-analysis": "经营分析",
  "config-manager::operate-config::title-header": "相关成本预估占比（单位：%）",
  "config-manager::operate-config::title-sub": "相关成本指除商品成本、营销成本以外的成本，例物流成本、供应链成本、渠道成本等，用于计算预估毛利",
  "config-manager::operate-config::save": "保存",
  "config-manager::operate-config::title-tip": "部分经营数据由于线下操作或时效问题，系统无法实时获取，故通过规律性设置，可为您初步计算相关指标；后期可通过【导入】把真实数据导进数据库，系统将结合实际数据完成指标计算；",
  "config-manager::operate-config::placehodler": "请输入",
  "config-manager::operate-config::placehodler-number": "请输入数值",
  "system::team::新增一级团队": "新增一级团队",
  "system::team::搜索团队": "搜索团队",
  "system::team::有下级数据，无法删除": "有下级数据，无法删除",
  "system::team::add_staff": "添加员工",
  "system::team::user_name": "账号姓名",
  "system::team::account": "账号",
  "system::team::team": "所属团队",
  "system::team::shop": "团队店铺",
  "system::team::staff": "团队成员",
  "system::team::role": "角色",
  "system::team::ctl": "操作",
  "system::team::delete": "删除",
  "system::team::add": "新增一级团队",
  "system::team::search": "搜索团队",
  "system::team::user_delete": "是否删除该员工？",
  "system::team::all_select": "全部成员",
  "system::team::添加员工": "添加员工",
  "system::team::placeholdere_info": "请输入注册手机号或邮箱或授权码",
  "system::team::placeholdere_role": "请选择角色",
  "system::team::placeholdere_team": "请选择所属团队",
  "system::team::placeholdere_role_to": "暂无角色，请前往",
  "system::team::placeholdere_role_to_link": "【角色权限管理】",
  "system::team::auth_data_tip": "勾选即代表该店铺属于当前团队，用于店铺产生效益时计算团队绩效",
  "system::team::all_shop": "全部店铺",
  "system::team::search_name": "搜索账号姓名或账号",
  "personal::my-contract::订单生成日期": "订单生成日期",
  "ceshi::ceshi": "测试",
  "personal::contract::填写卡号": "填写卡号",
  "system::rbac::所属团队": "所属团队",
  "system::rbac::移除": "移除",
  "menu::screen-board": "数据大屏",
  "screen-board::当天累计": "当天累计",
  "screen-board::当月累计": "当月累计",
  "screen-board::当月订单渠道来源": "当月订单渠道来源",
  "screen-board::数据更新": "数据更新",
  "screen-board::日成交额": "日成交额",
  "screen-board::日订单量": "日订单量",
  "screen-board::月度热销商品": "月度热销商品",
  "screen-board::毛利率": "毛利率",
  "screen-board::订单量": "订单量",
  "screen-board::销售量": "销售量",
  "screen-board::销售额": "成交额",
  "screen-board::销售额日环比": "成交额日环比",
  "screen-board::付费": "付费",
  "screen-board::月成交": "月成交",
  "screen-board::月成交量": "月成交量",
  "screen-board::非付费": "非付费",
  "menu::operate-analysis::day-report": "经营日报",
  "menu::operate-analysis::month-report": "经营月报",
  "operate-analysis::day-report::shop_name": "店铺名称",
  "operate-analysis::day-report::time": "日期",
  "operate-analysis::day-report::screen": "全屏浏览",
  "operate-analysis::day-report::refresh": "刷新",
  "operate-analysis::day-report::today_report": "今日经营日报",
  "operate-analysis::day-report::shop_detail_report": "站点销售概括",
  "operate-analysis::day-report::shop_detail_report_sup": "店铺销售概括备注",
  "operate-analysis::day-report::sale": "成交额",
  "operate-analysis::day-report::profit": "预估毛利率",
  "operate-analysis::day-report::profit_tip": "预估成本占比为{pixed}%，可前往经营配置调整",
  "operate-analysis::day-report::order": "订单量",
  "operate-analysis::day-report::custom_order": "客单价",
  "operate-analysis::day-report::profit_tip_info": "系统默认成本占比{pixed}%来计算毛利，您可前往",
  "operate-analysis::day-report::profit_tip_info_config": "调整",
  "operate-analysis::day-report::order_deal": "成交额",
  "operate-analysis::day-report::wait_order": "待发货订单量",
  "operate-analysis::day-report::wait_deal_order": "待处理售后订单",
  "operate-analysis::day-report::ad_detail_data": "今日广告数据",
  "operate-analysis::day-report::ad_order_sale": "广告成交额",
  "operate-analysis::day-report::ad_spend": "广告花费",
  "operate-analysis::day-report::ad_roi": "广告ROI",
  "operate-analysis::day-report::put_report": "投放效果监控",
  "operate-analysis::day-report::time_report": "分时监控",
  "operate-analysis::day-report::time_report_sup": "分时监控备注",
  "operate-analysis::month-report::shop_name": "店铺名称",
  "operate-analysis::month-report::month": "月份",
  "operate-analysis::month-report::order_deal_total": "月累计成交额",
  "operate-analysis::month-report::spend": "月营销花费",
  "operate-analysis::month-report::profit": "月预估毛利率",
  "operate-analysis::month-report::profit_tip_info": "系统默认成本占比{pixed}%来计算毛利，您可前往",
  "operate-analysis::month-report::profit_tip_info_config": "调整",
  "operate-analysis::month-report::profit_tip": "预估成本占比为{pixed}%，可前往经营配置调整",
  "operate-analysis::month-report::order": "月订单量",
  "operate-analysis::month-report::custom_order": "客单价",
  "operate-analysis::month-report::all_trend": "总体成交趋势",
  "operate-analysis::month-report::goods_sale_top": "商品销售排行",
  "operate-analysis::month-report::put_report": "投放效果监控",
  "operate-analysis::month-report::site_info": "站点运营概况",
  "system::common::btn::all_screen": "全屏浏览",
  "system::common::btn::no_all_screen": "退出全屏",
  "system::common::btn::copy": "复制",
  "dashboard-bi::default-board::refresh": "刷新",
  "menu::message-center": "消息中心",
  "menu::system-setting": "系统配置",
  "menu::system-setting::param-setting": "参数配置",
  "menu::system-setting::param-setting::operate-config": "经营配置",
  "menu::system-setting::param-setting::shop-site": "广告配置",
  "menu::system-setting::system-set": "系统配置",
  "menu::system-setting::system-set::rbac-manager": "角色管理",
  "menu::system-setting::system-set::team-manager": "员工管理",
  "menu::work-data": "业务数据",
  "menu::work-data::shop-data": "店铺数据",
  "menu::work-data::shop-data::order": "订单列表",
  "menu::work-data::shop-data::products-info": "商品列表",
  "menu::work-data::shop-data::store": "店铺列表",
  "menu::work-data::shop-data::task-center": "任务中心",
  "ocean-bi::order-link::card1": "平均支付-妥投时效(本月)",
  "ocean-bi::order-link::card2": "未配货子订单",
  "ocean-bi::order-link::card3": "待发货配货单",
  "ocean-bi::order-link::card4": "在途配货单",
  "ocean-bi::order-link::card5": "妥投配货单(本月)",
  "ocean-bi::order-link::delivered": "结合在途配货单&妥投配货单，分析每日妥投情况",
  "ocean-bi::order-link::distributing": "结合订单数&在途配货单数，分析每日发货情况",
  "ocean-bi::order-link::not-distribution": "通过对比不同时间未配货子订单数，分析供应商健康程度",
  "ocean-bi::order-link::wait-distribution": "通过对比不同时间未配货子订单数，分析供应商-物流商衔接情况",
  "ocean-bi::order-link::图表类型": "图表类型",
  "ocean-bi::order-link::在途配货单": "在途配货单",
  "ocean-bi::order-link::在途配货单数": "在途配货单数",
  "ocean-bi::order-link::妥投配货单": "妥投配货单",
  "ocean-bi::order-link::妥投配货单数": "妥投配货单数",
  "ocean-bi::order-link::待发货配货单": "待发货配货单",
  "ocean-bi::order-link::折线图": "折线图",
  "ocean-bi::order-link::时间范围": "时间范围",
  "ocean-bi::order-link::未配货子订单": "未配货子订单",
  "ocean-bi::order-link::柱形图": "柱形图",
  "ocean-bi::order-link::订单数": "订单数",
  "ocean-bi::order-link::设置": "设置",
  "ocean-bi::sc-analysis::card-day": "当日数据一览",
  "personal::account-manager::code_tips": "用于跨企业授权",
  "personal::account-manager::my-account_复制": "复制",
  "personal::account-manager::my-account_授权码": "授权码",
  "personal::account-manager::my-account_账号": "账号",
  "personal::account-manager::my-account_账号ID": "账号ID",
  "personal::my-contract::buy": "选购套餐",
  "personal::my-contract::empty_title": "您还未选购套餐",
  "ocean-bi::sc-analysis::day-30-subOrder": "30天子订单数(T-5)",
  "ocean-bi::sc-analysis::day-5-dispatcherNum": "5天配货子单数(T-5)",
  "ocean-bi::sc-analysis::day30OrderNum30diff": "30天子订单数(T-30)",
  "ocean-bi::sc-analysis::day30Received30diff": "30天妥投订单数",
  "ocean-bi::sc-analysis::edit-returnRate": "设置退货率",
  "ocean-bi::sc-analysis::five-day-distRate": "5天配货率",
  "ocean-bi::sc-analysis::internetRate": "上网率(当月)",
  "ocean-bi::sc-analysis::internetRate-tips": "【更新时间：每10分钟更新1次】【统计口径：当月支付已上网子订单数/月子订单数；剔除已退款，已取消，有售后三种状态】",
  "ocean-bi::sc-analysis::monthNetworkNum": "当月支付已上网子订单数",
  "ocean-bi::sc-analysis::receiveRate": "30天妥投率",
  "ocean-bi::sc-analysis::returnRate-holder": "请输入退货率",
  "ocean-bi::sc-analysis::returnRate-tips": "退货率将影响【总成本占比】计算，点击确认后生效",
  "ocean-bi::sc-analysis::shipmentRate": "发货率(当月)",
  "ocean-bi::sc-analysis::shipmentRate-tips": "【更新时间：每10分钟更新1次】【统计口径：当月已发货配货单数/单月创建配货单数】",
  "ocean-bi::sc-analysis::stockoutRate": "缺货率(当月)",
  "ocean-bi::sc-analysis::stockoutRate-tips": "【更新时间：每10分钟更新1次】【统计口径：月缺货子订单数/月子订单数；剔除已退款、已取消、有售后、暂停订单四种状态】",
  "ocean-bi::sc-analysis::totalCostRate": "成本占比(当月)",
  "ocean-bi::sc-analysis::totalCostRate-tips": "【更新时间：每10分钟更新1次】【统计口径：（商品成本+物流成本）/(成交额*(1-退款率)）】",
  "ocean-bi::sc-analysis::上网情况": "上网情况",
  "ocean-bi::sc-analysis::上网率": "上网率",
  "ocean-bi::sc-analysis::妥投情况": "妥投情况",
  "ocean-bi::sc-analysis::月子订单数": "月子订单数",
  "ocean-bi::sc-analysis::退货率": "退货率",
  "ocean-bi::sc-analysis::配货情况": "配货情况",
  "ocean-bi::sc-analysis:chart-tooltip": "剔除已退款、已取消、有售后三种状态的订单",
  "menu::ocean-bi::order-link": "订单全链路",
  "menu::ocean-bi::sale-analysis": "销售分析",
  "menu::ocean-bi::sc-analysis": "供应链分析",
  "menu::ocean-bi::scm-analysis": "供应链分析",
  "menu::sale-analysis": "销售分析",
  "menu::order-link": "订单全链路",
  "menu::sc-analysis": "供应链分析",
  "menu::scm-analysis": "供应链分析",
  "menu::sale-analysis::order-link": "订单全链路",
  "menu::scm-analysis::sc-analysis": "供应链分析",
  "system::common::btn::个人中心": "个人中心",
  "system::common::expired-code": "套餐已过期",
  "system::common::expired-desc": "您的套餐已过期，目前服务已停止，请前往个人中心重新购买套餐",
  "system::common::expired-btn": "立即购买",
  "system::common::index-code": "您好！欢迎使用ShoplusBI!",
  "system::common::index-desc": "—— 专注DTC品牌出海，数据赋能精细化运营",
  "dashboard-bi::board-management::新增菜单": "新增菜单",
  "dashboard-bi::board-management::编辑菜单": "编辑菜单",
  "dashboard-bi::board-management::菜单": "菜单",
  "dashboard-bi::board-management::目录": "目录",
  "dashboard-bi::board-management::页签": "页签",
  "dashboard-bi::board-management::新窗口": "新窗口",
  "dashboard-bi::board-management::第三方链接": "第三方链接",
  "dashboard-bi::board-management::平台看板": "平台看板",
  "dashboard-bi::board-management::空白看板": "空白看板",
  "dashboard-bi::board-management::菜单名称": "菜单名称",
  "dashboard-bi::board-management::排序": "排序",
  "dashboard-bi::board-management::类型": "类型",
  "dashboard-bi::board-management::菜单类型": "菜单类型",
  "dashboard-bi::board-management::打开方式": "打开方式",
  "dashboard-bi::board-management::可见": "可见",
  "dashboard-bi::board-management::目录名称": "目录名称",
  "dashboard-bi::board-management::显示排序": "显示排序",
  "dashboard-bi::board-management::选择图标": "选择图标",
  "dashboard-bi::board-management::请选择目录": "请选择目录",
  "dashboard-bi::board-management::请输入菜单名称": "请输入菜单名称",
  "dashboard-bi::board-management::请选择菜单类型": "请选择菜单类型",
  "dashboard-bi::board-management::请输入URL": "请输入URL",
  "dashboard-bi::board-management::请选择平台看板": "请选择平台看板",
  "dashboard-bi::board-management::请选择打开方式": "请选择打开方式",
  "dashboard-bi::board-management::请填写排序": "请填写排序",
  "dashboard-bi::board-management::请输入目录名称": "请输入目录名称",
  "dashboard-bi::board-management::请选择图标": "请选择图标",
  "dashboard-bi::board-management::报表中心": "报表中心",
  "dashboard-bi::board-management::公共看板": "公共看板",
  "dashboard-bi::board-management::个人看板": "个人看板",
  "dashboard-bi::board-management::个人报表": "个人报表",
  "ocean-bi::sc-analysis::chart-tooltip": "剔除已退款、已取消、有售后三种状态的订单",
  "personal::common::trial": "本套餐试用将于{day}天后（{date}）到期，现在升级",
  "personal::common::个人中心": "个人中心",
  "personal::common::今天到期": "今天到期",
  "personal::common::天": "天",
  "personal::common::新增菜单": "新增菜单",
  "personal::common::立享优惠": "立享优惠",
  "personal::common::立即购买": "立即购买",
  "personal::common::试用版": "试用版",
  "personal::contract::accept-tips": "我了解并接受",
  "personal::contract::agreement-tips": "请勾选服务协议",
  "personal::contract::pay-tips": "为确保套餐可以成功付费请填写卡片支付信息完成支付，后续抽佣及月租/年费扣除将自动进行",
  "personal::contract::信用卡支付": "信用卡支付",
  "personal::contract::到期日期": "到期日期",
  "personal::contract::卡号": "卡号",
  "personal::contract::安全码": "安全码",
  "personal::open-contract::卡安全码": "卡安全码",
  "personal::open-contract::有效期(MM/YY)": "有效期(MM/YY)",
  "personal::open-contract::请输入卡号": "请输入卡号",
  "screen-board::popver-tip": "系统默认成本占比38%来计算毛利，您可前往",
  "screen-board::tooltip": "预估成本占比为{pixed}%，可前往经营配置调整",
  "screen-board::经营配置": "经营配置",
  "screen-board::调整": "调整",
  "shop-site::campaign": "配置优化师",
  "shop-site::campaign::add": "新增优化师",
  "shop-site::campaign::delete-tips": "删除提醒",
  "shop-site::campaign::delete-tips2": "删除优化师后，新产生的订单数据将无法追踪所属优化师，但不影响历史数据",
  "shop-site::campaign::delete-tips3": "为避免影响数据统计，建议将该优化师的campagin标识转交后再删除",
  "shop-site::campaign::deleteCampaign": "确认转交并删除",
  "shop-site::campaign::dielete-confirm": "直接删除确认",
  "shop-site::campaign::directDelete": "直接删除",
  "shop-site::campaign::directDelete-tips": "直接删除，新产生的订单数据将无法追踪优化师",
  "shop-site::campaign::directDelete-tips2": "此操作不可恢复！",
  "shop-site::campaign::move-to": "转交至",
  "shop-site::campaign::placeholder": "搜索优化师或campaign标识",
  "shop-site::campaign::select-tips": "请选择要转交的优化师",
  "shop-site::facebook_campaign::edit_staff": "编辑优化师",
  "stores::shop-site::campaignSign": "campaign标识",
  "stores::shop-site::优化师": "优化师",
  "stores::shop-site::操作": "操作",
  "system::common::btn::立即新增": "立即新增",
  "system::common::text::board_empty": "您暂时还没创建过菜单哦～",
  "menu::system-setting::system-set::watermark-manager": "水印管理",
  "personal::contract::payFail": "当前信用卡暂不支持，请更换信用卡",
  "personal::contract::paySuccess": "恭喜您！顺利完成此次支付流程",
  "personal::contract::支付失败": "支付失败",
  "personal::contract::支付成功": "支付成功",
  "personal::contract::绑卡成功": "绑卡成功",
  "personal::open-contract::addOtherCard": "添加其他信用卡",
  "personal::open-contract::bindCard": "绑定信用卡",
  "personal::open-contract::cardManager": "卡片管理",
  "personal::open-contract::comboInfo": "套餐信息",
  "personal::open-contract::comboList": "套餐列表",
  "personal::open-contract::commissionOrder": "交易佣金订单",
  "personal::open-contract::giveDay": "天赠送",
  "personal::open-contract::GMVFirstYear": "GMV首年免佣",
  "personal::open-contract::my-card": "我的信用卡",
  "personal::open-contract::notClose": "请勿关闭此页面",
  "personal::open-contract::nowCombo": "当前套餐",
  "personal::open-contract::orderDetail": "订单详情",
  "personal::open-contract::payAgain": "重新支付",
  "personal::open-contract::payCard": "信用卡支付",
  "personal::open-contract::paying": "支付中...",
  "personal::open-contract::payNow": "立即支付",
  "personal::open-contract::pleaseAdd": "请添加信用卡",
  "personal::open-contract::selectPayCard": "请选择支付信用卡",
  "personal::open-contract::serviceOrder": "服务费订单",
  "personal::open-contract::当前账号": "当前账号",
  "personal::contract::卡片类型": "卡片类型",
  "personal::contract::合约编号": "合约编号",
  "personal::contract::套餐名称": "套餐名称",
  "personal::contract::操作": "操作",
  "personal::contract::支付卡": "支付卡",
  "personal::contract::状态": "状态",
  "personal::contract::站点数量": "站点数量",
  "personal::contract::绑定": "绑定",
  "ocean-bi::sale-area::SPU销售概况": "SPU销售概况",
  "ocean-bi::sale-area::全品类": "全品类",
  "ocean-bi::sale-area::全球": "全球",
  "ocean-bi::sale-area::分析维度": "分析维度",
  "ocean-bi::sale-area::品类销售概况": "品类销售概况",
  "ocean-bi::sale-area::品类销售趋势": "品类销售趋势",
  "ocean-bi::sale-area::商品SPU": "商品SPU",
  "ocean-bi::sale-area::商品品类": "商品品类",
  "ocean-bi::sale-area::图片": "图片",
  "ocean-bi::sale-area::成交额": "成交额",
  "ocean-bi::sale-area::按成交额排序": "按成交额排序",
  "ocean-bi::sale-area::按退款量排序": "按退款量排序",
  "ocean-bi::sale-area::按退款金额排序": "按退款金额排序",
  "ocean-bi::sale-area::按销量排序": "按销量排序",
  "ocean-bi::sale-area::排序": "排序",
  "ocean-bi::sale-area::统计时间": "统计时间",
  "ocean-bi::sale-area::请搜索商品SPU": "请搜索商品SPU",
  "ocean-bi::sale-area::请选择商品品类": "请选择商品品类",
  "ocean-bi::sale-area::退款量": "退款量",
  "ocean-bi::sale-area::退款金额": "退款金额",
  "ocean-bi::sale-area::销售额": "销售额",
  "ocean-bi::sale-area::销量": "销量",
  "ocean-bi::sale-area::销量前十城市概况": "销量前十城市概况",
  "ocean-bi::sale-area::销量占比": "销量占比",
  "personal::contract::setPayCard": "设为支付卡",
  "personal::contract::setPayCard-success": "设置支付卡成功",
  "personal::contract::setPayCard-tips": "确定设置该卡为支付卡?",
  "personal::contract::unbind-add-tips": "是否确认解绑该卡，支付卡解绑后将默认按照绑定时间，自动将最早绑定的卡设置为支付卡",
  "personal::contract::unbind-card-tips": "您当前仅剩一张信用卡，为确保服务质量请绑定其他信用卡后再进行解绑",
  "personal::contract::提示": "提示",
  "personal::contract::解绑": "解绑",
  "personal::contract::解绑成功": "解绑成功",
  "personal::contract::addCard": "添加信用卡",
  "ocean-bi::sale-area::grandTotalUsd": "成交额",
  "ocean-bi::sale-area::refundSale": "退款量",
  "ocean-bi::sale-area::refundUsd": "退款金额",
  "ocean-bi::sale-area::sale": "销量",
  "ocean-bi::sale-area::前十城市概况": "前十城市概况",
  "watermark::use-userName": "使用用户名作为水印名称",
  "watermark::保存": "保存",
  "watermark::字号": "字号",
  "watermark::水印名称": "水印名称",
  "watermark::水印设计": "水印设计",
  "watermark::水印预览": "水印预览",
  "watermark::透明度": "透明度",
  "watermark::页面水印": "页面水印",
  "watermark::颜色": "颜色",
  "personal::contract::useCoupon": "使用优惠码",
  "personal::contract::inputCouponCode": "请输入优惠码（选填）",
  "personal::contract::couponCanUse": "优惠码可用，下单时将为您自动抵扣优惠金额",
  "personal::contract::couponNotUse": "该优惠码仅限于“{name}”使用是否",
  "personal::contract::buyNow": "立即购买",
  "personal::contract::payInfo": "结算信息",
  "personal::contract::comboName": "套餐名称",
  "personal::contract::comboPrice": "套餐价格",
  "personal::contract::discount": "优惠金额",
  "personal::contract::amount": "合计",
  "personal::contract::firstPayAmount": "首{type}{type}租",
  "personal::contract::nextPayAmount": "次{type}后",
  "personal::contract::yearPay": "年付立减",
  "personal::contract::everyMonth": "每{type}立减",
  "personal::contract::firstMonth": "首{type}立减",
  "menu::system-setting::param-setting::reptile": "爬虫可视化",
  "ocean-bi::sale-area::价格带": "价格带",
  "ocean-bi::sale-area::最低价格": "最低价格",
  "ocean-bi::sale-area::最高价格": "最高价格",
  "ocean-bi::sale-area::售价": "售价",
  "storage::stock-analysis::近7天": "近7天",
  "storage::stock-analysis::近30天": "近30天",
  "storage::stock-analysis::近3个月": "近3个月",
  "storage::stock-analysis::近6个月": "近6个月",
  "storage::stock-analysis::自创建以来": "自创建以来",
  "storage::stock-analysis::salesDay_placeholder": "请选择销量合集时长",
  "dashboard-bi::board-management::hide_tips": "设置为不可见后，将针对全部存量用户隐藏此看板，请谨慎操作！",
  "dashboard-bi::board-management::确认不可见": "确认不可见",
  "menu::system-setting::param-setting::admin-config": "后台管理",
  "dashboard-bi::board-management::请先创建目录": "请先创建目录",
  "dashboard-bi::board-management::创建目录": "创建目录",
  "dashboard-bi::board-management::请先": "请先",
  "dashboard-bi::board-management::pc": "PC端URL",
  "dashboard-bi::board-management::mobile": "移动端URL",
  "dashboard-bi::board-management::mobile_input_tip": "配置后手机端将打开此链接",
  "personal::my-contract::subscribePlan": "套餐订阅计划",
  "personal::my-contract::subscribeTips": "在你购买的套餐有效期结束后，系统自动为你续期下面的套餐版本",
  "personal::my-contract::changeSubscribe": "变更订阅",
  "personal::my-contract::offSubscribe": "取消订阅",
  "personal::my-contract::subActiveTime": "预计生效时间",
  "personal::my-contract::subCommissionRatio": "平台抽佣",
  "personal::my-contract::subShopQuantity": "站点数量",
  "personal::my-contract::openSubscribe": "开启订阅",
  "personal::my-contract::returnMyContract": "返回我的套餐",
  "personal::my-contract::selectSubContract": "选择预定套餐",
  "personal::my-contract::localAccount": "当前账号",
  "personal::my-contract::hadSub": "已订阅",
  "personal::my-contract::subNow": "立即预定",
  "personal::my-contract::changeNow": "确认变更",
  "personal::my-contract::subSuccess": "预定成功",
  "personal::my-contract::subSuccess-tips": "恭喜您！已成功预定套餐，于当前套餐后结束后执行！",
  "personal::my-contract::return-myContract": "回到我的套餐",
  "personal::my-contract::offSuccess": "取消订阅成功",
  "personal::my-contract::offSuccess-tips": "恭喜您！已成功取消订阅套餐！",
  "personal::my-contract::know": "我知道了",
  "system::common::startTime": "开始时间",
  "system::common::endTime": "结束时间",
  "operate-analysis::order-analysis::订单详情": "订单详情",
  "operate-analysis::order-analysis::发货时效分布设置": "发货时效分布设置",
  "operate-analysis::order-analysis::履约时效分布设置": "履约时效分布设置",
  "operate-analysis::order-analysis::超时待发货设置": "超时待发货设置",
  "operate-analysis::order-analysis::独立站": "独立站",
  "operate-analysis::order-analysis::店铺订单编号": "店铺订单编号",
  "operate-analysis::order-analysis::商品": "商品",
  "operate-analysis::order-analysis::成交额": "成交额",
  "operate-analysis::order-analysis::顾客": "顾客",
  "operate-analysis::order-analysis::国家": "国家",
  "operate-analysis::order-analysis::渠道": "渠道",
  "operate-analysis::order-analysis::订单状态": "订单状态",
  "operate-analysis::order-analysis::订单支付时间": "订单支付时间",
  "operate-analysis::order-analysis::今日新增订单": "今日新增订单",
  "operate-analysis::order-analysis::今日客单价": "今日客单价",
  "operate-analysis::order-analysis::待发货订单": "待发货订单",
  "operate-analysis::order-analysis::超时待发货": "超时待发货",
  "operate-analysis::order-analysis::点击页面管理icon即可设置企业相关指标": "点击页面管理icon即可设置企业相关指标",
  "operate-analysis::order-analysis::待确认收货": "待确认收货",
  "operate-analysis::order-analysis::平均发货时长(天)": "平均发货时长(天)",
  "operate-analysis::order-analysis::平均配送时长(天)": "平均配送时长(天)",
  "operate-analysis::order-analysis::超时后平均发货时长": "超时后平均发货时长",
  "operate-analysis::order-analysis::发货时效分布": "发货时效分布",
  "operate-analysis::order-analysis::履约时效分布": "履约时效分布",
  "operate-analysis::order-analysis::订单": "订单",
  "operate-analysis::order-analysis::deliver_tooltip": "订单支付时间为所选时间的已发货订单从支付到发货所需的平均时长",
  "operate-analysis::order-analysis::send_tooltip": "订单支付时间为所选时间的已确认收货订单从发货到确认发货所需平均时长",
  "operate-analysis::order-analysis::outTime_tooltip": "订单支付时间为所选时间的已超时且已发货订单从超时到发货所需平均时长",
  "operate-analysis::order-analysis::超过": "超过",
  "operate-analysis::order-analysis::outTime_title": "天未发货标记为超时待发货",
  "operate-analysis::order-analysis::time_title": "天为单位间隔时间",
  "operate-analysis::order-analysis::以": "以",
  "operate-analysis::order-analysis::begin_title": "开始计算到确认收货的时长并以",
  "operate-analysis::order-analysis::订单发货时间": "订单发货时间",
  "performance-board::data::来源": "来源",
  "performance-board::data::用户数": "用户数",
  "performance-board::data::占比": "占比",
  "performance-board::data::国家": "国家",
  "performance-board::data::设备": "设备",
  "performance-board::data::访客数量": "访客数量",
  "performance-board::data::转化率": "转化率",
  "performance-board::data::deviceTable": "访问设备占比",
  "performance-board::data::clientCountryCharts": "访客地区转化率",
  "performance-board::data::utmTransCharts": "访客UTM转化率",
  "performance-board::data::utmTransChartsTIps": "默认统计UTM标识为utmSource的订单转化率",
  "personal::my-contract::cancleContractTips": "取消自动订阅后，店铺有效期结束将进入过期状态影响站点交易 请谨慎处理！",
  "login::accept::and": "以及我们的",
  "login::accept::text": "创建账号意味着您接受",
  "login::mobile::demoShow": "产品演示",
  "login::mobile::emailNumber": "邮箱号码",
  "login::mobile::hadTips": "已经有账户？",
  "login::mobile::network-error": "网络错误",
  "login::mobile::noTips": "没有账号？",
  "login::mobile::password": "密码",
  "login::mobile::phoneNumber": "手机号码",
  "login::mobile::register": "注册",
  "login::mobile::validCode": "验证码",
  "login::registerAccount": "创建账号",
  "menu::customer::customer-list::customer-detail": "顾客详情",
  "menu::stores::store::store-detail": "店铺详情",
  "menu::work-data::shop-data::customer-list": "顾客列表",
  "storage::stock-analysis::销量合计": "销量合计",
  "customer::customer-list::exceed": "超过",
  "customer::customer-list::exceedDays": "天后未再次购买则界定顾客为流失顾客",
  "customer::customer-list::lastOrderTime": "最近下单时间",
  "customer::customer-list::ltv": "累计LTV",
  "customer::customer-list::messageTips": "定义流失客户不得少于30天",
  "customer::customer-list::qty": "购买商品",
  "customer::customer-list::tagAttr": "顾客属性标签",
  "customer::customer-list::tagRule": "顾客标签规则",
  "customer::customer-list::tagTips": "根据顾客消费次数、渠道来源为顾客匹配属性标签；新规则仅对前3个月数据和往后数据生效",
  "customer::customer-list::件": "件",
  "customer::customer-list::标签规则": "标签规则",
  "customer::customer-list::顾客来源": "顾客来源",
  "customer::profits::arpu": "月ARPU",
  "customer::profits::attributeEchart": "顾客属性占比",
  "customer::profits::average": "平均顾客概况",
  "customer::profits::avgLtv": "平均LTV",
  "customer::profits::avgOrderNum": "平均下单次数",
  "customer::profits::avgReOrderDay": "平均复购时长(天)",
  "customer::profits::avgReOrderNum": "平均复购次数",
  "customer::profits::checkCustomer": "查看顾客",
  "customer::profits::customerNum": "当月成交客数",
  "customer::profits::lostCustomer": "现有{lossCustomerNum}名顾客在10天后即将流失，快快挽留吧~",
  "customer::profits::newTrend": "近半年新客趋势",
  "customer::profits::reorder": "顾客复购漏斗",
  "customer::profits::totalCustomerNum": "总顾客数",
  "customer::profits::新客数": "新客数",
  "customer::profits::复购客数": "复购客数",
  "personal::common::套餐调价提醒": "套餐调价提醒",
  "personal::common::立即续订": "立即续订",
  "personal::common::立即订购": "立即订购",
  "personal::common::订购其他套餐": "订购其他套餐",
  "personal::common::套餐下架提醒": "套餐下架提醒",
  "stores::products-info::buyer": "买手",
  "stores::products-info::importTips": "注：系统目前不支持新增商品数据",
  "stores::products-info::pleaseFirst": "请先",
  "stores::products-info::exportGoods": "导出商品",
  "stores::products-info::editing": "进行修改",
  "stores::products-info::importFile": "再上传文件",
  "stores::products-info::importDesc": "支持xls、xlsx、csv格式的表格，上传的文件不超过10M",
  "stores::products-info::importFirst": "请先上传表格",
  "config-manager::operate-config::成本配置": "成本配置",
  "config-manager::operate-config::目标配置": "目标配置",
  "config-manager::operate-config::选择年月": "选择年月",
  "config-manager::operate-config::新增目标": "新增目标",
  "config-manager::operate-config::编辑": "编辑",
  "config-manager::operate-config::删除确认": "删除确认",
  "config-manager::operate-config::删除": "删除",
  "config-manager::operate-config::deleteTips": "删除目标后无法恢复，是否确认删除？",
  "config-manager::operate-config::团队": "团队",
  "config-manager::operate-config::销售额目标": "销售额目标",
  "config-manager::operate-config::操作": "操作",
  "config-manager::operate-config::编辑目标": "编辑目标",
  "config-manager::operate-config::选择团队": "选择团队",
  "config-manager::operate-config::请选择团队": "请选择团队",
  "config-manager::operate-config::团队目标金额": "团队目标金额",
  "config-manager::operate-config::targetTips": "货币单位为绑定店铺所使用的货币",
  "config-manager::operate-config::targetholder": "请输入团队目标金额",
  "config-manager::operate-config::员工目标成交额": "员工目标成交额",
  "config-manager::operate-config::userTarget": "默认将团队销售目标均摊到每个优化师上，您也可以单独修改",
  "config-manager::operate-config::员工姓名": "员工姓名",
  "config-manager::operate-config::teamTarget": "请输入团队目标金额",
  "config-manager::operate-config::新增成功": "新增成功",
  "config-manager::operate-config::编辑成功": "编辑成功",
  "ad-analysis::成交额": "成交额",
  "ad-analysis::广告系列名称": "广告系列名称",
  "ad-analysis::广告花费Top5": "广告花费Top5",
  "ad-analysis::广告成交额Top5": "广告成交额Top5",
  "ad-analysis::广告ROI Top5": "广告ROI Top5",
  "ad-analysis::广告系列不同维度Top5": "广告系列不同维度Top5",
  "ad-analysis::广告ROI": "广告ROI",
  "ad-analysis::广告费用": "广告费用",
  "ad-analysis::广告费用tooltip": "广告所花费用",
  "ad-analysis::成交金额": "成交金额",
  "ad-analysis::成交金额tooltip": "广告产生转化价值",
  "ad-analysis::销售金额": "销售金额",
  "ad-analysis::销售金额tooltip": "广告产生订单金额，含未支付订单金额",
  "ad-analysis::roitooltip": "转化ROI,成交金额÷广告费用",
  "ad-analysis::展示量": "展示量",
  "ad-analysis::展示量tooltip": "广告展示总次数",
  "ad-analysis::点击量": "点击量",
  "ad-analysis::点击量tooltip": "广告被点击总次数",
  "ad-analysis::平均转化费用": "平均转化费用",
  "ad-analysis::平均转化费用tooltip": "成交客户所花广告费用，广告费用÷成交量",
  "ad-analysis::下单量": "下单量",
  "ad-analysis::下单量tooltip": "含待支付的订单量",
  "ad-analysis::客单价": "客单价",
  "ad-analysis::客单价tooltip": "下单客户平均成交额，成交金额÷成交量",
  "ad-analysis::点击率": "点击率",
  "ad-analysis::点击率tooltip": "点击率CTR，点击量÷展示量",
  "ad-analysis::cpmtooltip": "千次展示费用，广告费用/展示量*1000",
  "ad-analysis::cpctooltip": "每次点击的平均费用，广告费用÷点击量",
  "ad-analysis::支付转化率": "支付转化率",
  "ad-analysis::支付转化率tooltip": "支付转化率CVR，成交量÷点击量",
  "ad-analysis::成交量": "成交量",
  "ad-analysis::成交量tooltip": "已支付的订单量",
  "ad-analysis::加购量": "加购量",
  "ad-analysis::加购量tooltip": "添加购物车用户数量",
  "ad-analysis::加购金额": "加购金额",
  "ad-analysis::加购金额tooltip": "添加购物车总金额",
  "ad-analysis::发起结账率": "发起结账率",
  "ad-analysis::发起结账率tooltip": "发起结账量÷点击量",
  "ad-analysis::广告成交额": "广告成交额",
  "ad-analysis::广告花费": "广告花费",
  "ad-analysis::点击率(CTR)": "点击率(CTR)",
  "ad-analysis::支付转化率(CVR)": "支付转化率(CVR)",
  "ad-analysis::管理指标": "管理指标",
  "ad-analysis::拖动可调整位置": "拖动可调整位置",
  "ad-analysis::首页指标": "首页指标",
  "ad-analysis::最多展示6个": "最多展示6个",
  "ad-analysis::未显示指标": "未显示指标",
  "personal::contract::确认支付信息": "确认支付信息",
  "personal::contract::选择升级套餐": "选择升级套餐",
  "personal::contract::upgrade_tip": "升级套餐后，店铺剩余可用天数将免费叠加到新套餐中，并按照升级后套餐计算抽佣比例",
  "personal::contract::pay_tip": "套餐升级有原有订阅将会取消，您可在升级后再次订阅",
  "personal::contract::暂无可升级套餐": "暂无可升级套餐",
  "personal::contract::站点数": "站点数",
  "personal::contract::首年免佣额度": "首年免佣额度",
  "personal::contract::付款方式": "付款方式",
  "personal::contract::套餐价格": "套餐价格",
  "personal::contract::优惠详情": "优惠详情",
  "personal::contract::content_title": "以下是您选择订阅的套餐",
  "personal::contract::优惠详情content": "赠送{name}套餐{day}/天",
  "personal::contract::请选择支付信用卡": "请选择支付信用卡",
  "personal::contract::上一步": "上一步",
  "personal::contract::下一步": "下一步",
  "personal::contract::送店铺": "含超店建站所有功能",
  "personal::contract::送BI": "含超店BI所有功能",
  "personal::contract::送店铺和BI": "含超店建站所有功能+赠送超店BI",
  "personal::contract::请选择升级套餐": "请选择升级套餐",
  "personal::contract::loading": "支付中请稍后",
  "personal::contract::loadingTip": "套餐支付预计10秒内完成,正在为您支付并开通账号....",
  "personal::contract::success": "支付成功",
  "personal::contract::successTip": "恭喜您！顺利完成此次支付流程",
  "personal::contract::error": "支付失败",
  "personal::contract::errorTip": "请查询卡片额度及外币支付授权是否可用或换卡支付",
  "personal::contract::前往建站": "前往建站",
  "personal::contract::订单详情": "订单详情",
  "personal::contract::重新支付": "重新支付",
  "personal::contract::请选择套餐": "请选择套餐",
  "personal::contract::升级套餐": "升级套餐",
  "merits-board::detail::成交额(USD)": "成交额(USD)",
  "merits-board::detail::营销费用(USD)": "营销费用(USD)",
  "merits-board::detail::目标达成率": "目标达成率",
  "merits-board::detail::团队详情": "团队详情",
  "merits-board::detail::优化师详情": "优化师详情",
  "merits-board::detail::店铺详情": "店铺详情",
  "merits-board::teamGmv": "您当前团队成交额",
  "merits-board::teamTarget": "月目标成交额",
  "merits-board::toTarget": "您还没有设置目标，请先去进行",
  "merits-board::gmv": "您当前个人成交额",
  "merits-board::target": "月目标成交额",
  "merits-board::排名": "排名",
  "merits-board::名称": "名称",
  "merits-board::成交额": "成交额",
  "merits-board::目标达成": "目标达成",
  "merits-board::typeHolder": "请选择分日趋势",
  "merits-board::分时趋势": "分时趋势",
  "merits-board::分日趋势": "分日趋势",
  "merits-board::分月趋势": "分月趋势",
  "merits-board::请选择标签": "请选择标签",
  "merits-board::订单量": "订单量",
  "merits-board::营销费用": "营销费用",
  "merits-board::ROI": "ROI",
  "merits-board::销量": "销量",
  "merits-board::团队排行榜": "团队排行榜",
  "merits-board::优化师排行榜": "优化师排行榜",
  "merits-board::店铺成交额排行榜": "店铺成交额排行榜",
  "merits-board::绩效趋势": "绩效趋势",
  "merits-board::查看详情": "查看详情",
  "merits-board::选择团队": "选择团队",
  "merits-board::选择年月": "选择年月",
  "merits-board::暂未设置目标": "暂未设置目标",
  "operate-analysis::month-report::优化师投放排行榜": "优化师投放排行榜",
  "operate-analysis::day-report::优化师投放排行榜": "优化师投放排行榜",
  "operate-analysis::day-report::对比日期成交额": "对比日期成交额",
  "operate-analysis::day-report::对比日期订单数": "对比日期订单数",
  "operate-analysis::day-report::成交额": "成交额",
  "operate-analysis::day-report::订单数": "订单数",
  "operate-analysis::day-report::对比日期": "对比日期",
  "shop-site::campaign::暂无其余优化师": '暂无其余优化师',
  "storage::stock-analysis::商品类目": '商品类目',
  "operate-analysis::order-analysis::天": '天',
  "enterprise::manager::是否显示": "是否显示",
  "enterprise::manager::showTips": "关闭显示则不会在我的企业中展示，进入企业管理可以重新开启显示",
  "enterprise::manager::我的": "我的",
  "enterprise::manager::开": "开",
  "enterprise::manager::关": "关",
  "enterprise::manager::编辑企业": "编辑企业",
  "enterprise::manager::退出企业": "退出企业",
  "enterprise::manager::企业名称": "企业名称",
  "enterprise::manager::操作": "操作",
  "enterprise::manager::quit1": "退出企业后您将无法看到该企业数据",
  "enterprise::manager::quit2": "此操作不可撤销",
  "enterprise::manager::quit3": "确定要退出企业吗",
  "enterprise::manager::提示": "提示",
  "enterprise::manager::退出成功": "退出成功",
  "enterprise::manager::设置成功": "设置成功",
  "enterprise::manager::editName": "修改企业名称",
  "enterprise::manager::inputName": "请输入企业名称",
  "enterprise::manager::编辑成功": "编辑成功",
  "operate-analysis::day-report::saleTooltip": "已支付订单的支付总金额",
  "operate-analysis::day-report::orderTooltip": "已支付订单数量，不包含待支付、支付失败的订单",
  "operate-analysis::day-report::ad_order_saleTooltip": "带有utm参数的已支付订单的支付总金额",
  "operate-analysis::day-report::ad_spendTooltip": "所绑定的广告账号的真实花费",
  "operate-analysis::day-report::ad_roiTooltip": "广告成交额÷广告花费",
  "ad-analysis::广告转化价值": "广告转化价值",
  "ad-analysis::广告转化价值tooltip": "广告产生转化价值，数据来源：Fb与谷歌广告后台",
  "system::common::店铺服务": "店铺服务",
  "system::common::经营分析": "经营分析",
  "system::common::ERP系统": "ERP系统",
  "system::error::authrized": "请联系管理员开通权限",
  "system::common::帮助文档": "帮助文档",
  "system::common::正在为您切换主体": "正在为您切换主体",
  "stores::order::customer_email": "客户邮箱",
  "operate-analysis::day-report::time_report_tip": "指标在不同日期中每小时的趋势",
  "operate-analysis::day-report::custom_order_tooltip": '每一位客户平均交易金额，客单价=成交额÷订单量',
  "system::common::changePwd_title": "修改登录密码",
  "system::common::changePwd::oldPassword": "原始密码",
  "system::common::changePwd::newPassword": "新密码",
  "system::common::changePwd::comfirmPassword": "密码确认",
  "system::common::changePwd::oldPassword_placeholder": "请输入原密码",
  "system::common::changePwd::newPassword_placeholder": "请输入新密码",
  "system::common::changePwd::comfirmPassword_placeholder": "请再次输入密码",
  "system::common::changePwd::16位数字加字母组合": "16位数字加字母组合",
  "system::common::changePwd::与新密码不一致": "与新密码不一致",
  "operate-analysis::day-report::今日成交额": "今日成交额",
  "operate-analysis::day-report::今日订单数": "今日订单数",
  "system::common::btn::菜单管理": "菜单管理",
  "system::common::btn::新增目录/菜单": "新增目录/菜单",
  "system::common::b1": "多平台多店铺聚合分析",
  "system::common::b1_desc": "多平台多店铺多站点聚合分析，轻松掌控整体经营状况",
  "system::common::b2": "随时随地掌控业务状况",
  "system::common::b2_desc": "支持绑定微信一键查看，多终端随时查看即时销售情况",
  "system::common::b3": "全链路业务精细化运营分析",
  "system::common::b3_desc": "数据层层分解无限下钻，洞见运营各环节问题扭亏为盈",
  "system::common::b4": "数据实时监控及时发现异常",
  "system::common::b4_desc": "订单销售数据的实时统计，全面监控运营异常数据指标",
  "system::common::dtc": "· DTC品牌出海，用超店BI ·",
  "system::common::bind_shop_tip": "使用系统第一步就是绑定店铺哦~",
  "menu::system-setting::system-set::board-center-setting": "菜单管理",

  "screen-board::shop_empty": "尚未绑定店铺",
  "screen-board::shop_empty_tip": "绑定店铺",
  "screen-board::noshop_empty_tip": "暂无店铺商品数据",
  "screen-board::noshop_empty_tip_1": "无数据原因：1.未绑定店铺;",
  "screen-board::noshop_empty_tip_2": "2.店铺无商品数据；",
  "screen-board::noshop_empty_tip_3": "3.店铺未产生订单；",
  "screen-board::月环比": "月环比",
  "screen-board::月目标达成率": "月目标达成率",
  "screen-board::月累计成交额": "月累计成交额",
  "screen-board::客单价": "客单价",
  "screen-board::日环比": "日环比",
  "screen-board::连带率": "连带率",
  "screen-board::店铺日成交排行榜": "店铺日成交排行榜",
  "screen-board::SPU日销量排行榜": "SPU日销量排行榜",
  "screen-board::mouth_tooltip": "环比上月同一区间段，如10月1-3日与9月1-3日环比",
  "screen-board::mouth_target_tooltip": "月累计成交额÷企业月目标；可前往目标配置",
  "screen-board::mouth_target_tooltip_end": "设置企业月度目标",
  "screen-board::目标配置": "目标配置",
  "screen-board::custom_price_tip": "客单价=当日成交额÷当日支付成功订单数",
  "screen-board::more_rate_tip": "平均每单商品数，连带率=当日销售商品总数÷当日支付成功订单数",
  "screen-board::more": "更多",
  "screen-board::roi_tooltip": "日成交额÷日营销花费，",
  "screen-board::roi_tooltip_erp": "成交额÷营销花费",
  "screen-board::rate_tooltip_erp": "（成交额-营销花费-商品成本-其他预估成本）÷成交额，其他预估成本可前往",
  "screen-board::绑定广告账号": "绑定广告账号",
  "screen-board::roi_tooltip_end": "实时获取营销花费",
  "screen-board::rate_tooltip": "（成交额-营销花费-商品成本-其他预估成本）÷成交额，",
  "screen-board::导入商品信息": "导入商品信息",
  "screen-board::rate_tooltip_center_fee": "获取营销花费，",
  "screen-board::rate_tooltip_center": "获取商品成本，其他预估成本可前往",
  "screen-board::rate_tooltip_end": "修改",
  "screen-board::店铺": "店铺",
  "screen-board::月成交额": "月成交额",
  "operate-analysis::day-report::订单量": "订单量",
  "operate-analysis::day-report::客单价": "客单价",
  "operate-analysis::day-report::连带率": "连带率",
  "operate-analysis::day-report::营销花费": "营销花费",
  "operate-analysis::day-report::预估毛利率": "预估毛利率",
  "operate-analysis::day-report::成交额tooltip": "已支付订单的支付总金额",
  "operate-analysis::day-report::订单量tooltip": "已支付订单量，不包含待支付、支付失败的订单",
  "operate-analysis::day-report::客单价tooltip": "每位客户平均交易金额，客单价=成交额÷订单量",
  "operate-analysis::day-report::连带率tooltip": "平均每单商品数，连带率=当日销售商品总数÷订单量",
  "operate-analysis::day-report::营销花费tooltip": "所绑广告账号的当日花费",
  "operate-analysis::day-report::roitooltip": "成交额÷营销花费，绑定广告账号实时获取营销花费",
  "operate-analysis::day-report::预估毛利率tooltip": "（成交额-营销花费-商品成本-其他预估成本）÷成交额，绑定广告账号获取营销花费，导入商品信息获取商品成本，其他预估成本可前往经营配置修改",
  "operate-analysis::day-report::成交额分时监控": "成交额分时监控",
  "operate-analysis::day-report::订单量分时监控": "订单量分时监控",
  "operate-analysis::day-report::订单量分时监控tooltip": "指标在不同日期中每小时的趋势",
  "operate-analysis::day-report::店铺TopTitle": "店铺成交额排行Top10",
  "operate-analysis::day-report::spuTopTitle": "SPU销量排行Top10",
  "operate-analysis::day-report::优化师TopTitle": "优化师成交额排行Top10",
  "operate-analysis::day-report::店铺TableTitle": "店铺销售明细",
  "operate-analysis::day-report::spuTableTitle": "SPU销售明细",
  "operate-analysis::day-report::优化师TableTitle": "优化师投放明细",
  "operate-analysis::day-report::优化师TopTooltip": "根据订单中utm广告参数，解析出归属优化师，将订单金额视为该优化师成交额",
  "operate-analysis::day-report::店铺名称-tableTooltip": "当日产生成交记录的店铺",
  "operate-analysis::day-report::成交额-tableTooltip": "已支付订单的支付总金额",
  "operate-analysis::day-report::成交额环比-tableTooltip": "环比昨日同一时刻成交额",
  "operate-analysis::day-report::成交额占比-tableTooltip": "该店铺成交额占全部店铺成交额的占比",
  "operate-analysis::day-report::营销费用-tableTooltip": "该店铺广告账号所花费营销总额",
  "operate-analysis::day-report::ROI-tableTooltip": "成交额÷营销花费",
  "operate-analysis::day-report::订单量-tableTooltip": "已支付订单量，不包含待支付、支付失败的订单",
  "operate-analysis::day-report::客单价-tableTooltip": "客单价=成交额÷订单量",
  "operate-analysis::day-report::CPA-tableTooltip": "每单广告转化成本，CPA=营销花费÷订单量",
  "operate-analysis::day-report::连带率-tableTooltip": "平均每单商品数，连带率=当日销售商品数÷订单量",
  "operate-analysis::day-report::转化率-tableTooltip": "成交客户数÷店铺独立访客数，仅支持shoplus店铺计算此值",
  "operate-analysis::day-report::预估毛利润-tableTooltip": "预估毛利润=成交额-营销花费-商品成本-其他成本预估占比*成交额",
  "operate-analysis::day-report::预估毛利率-tableTooltip": "（成交额-营销花费-商品成本-其他预估成本）÷成交额",
  "operate-analysis::day-report::平台SPU_ID-spuTableTooltip": "当日产生成交的SPU",
  "operate-analysis::day-report::销量-spuTableTooltip": "当日销量",
  "operate-analysis::day-report::销量环比-spuTableTooltip": "环比昨日同一时刻销量",
  "operate-analysis::day-report::成交额-spuTableTooltip": "成交额=销量×商品售价",
  "operate-analysis::day-report::成交额环比-spuTableTooltip": "环比昨日同一时刻成交额",
  "operate-analysis::day-report::成交额占比-spuTableTooltip": "该SPU成交额占总成交额的占比",
  "operate-analysis::day-report::优化师姓名-OptimizerTableTooltip": "当日产生成交记录的优化师",
  "operate-analysis::day-report::一级部门-OptimizerTableTooltip": "优化师所属一级部门",
  "operate-analysis::day-report::成交额-OptimizerTableTooltip": "优化师成单总金额（订单utm参数中含该优化师英文名）",
  "operate-analysis::day-report::成交额占比-OptimizerTableTooltip": "该优化师成交额占总成交额的占比",
  "operate-analysis::day-report::营销花费-OptimizerTableTooltip": "该优化师所投广告系列的花费",
  "operate-analysis::day-report::ROI-OptimizerTableTooltip": "成交额÷营销花费",
  "operate-analysis::day-report::月目标-OptimizerTableTooltip": "优化师月度绩效目标",
  "operate-analysis::day-report::月目标达成进度-OptimizerTableTooltip": "月累计成交额÷月目标",
  "system::common::editorHeader::errorTip": "至少勾选{limit}个字段",
  "operate-analysis::day-report::成交额环比-OptimizerTableTooltip": "环比昨日同一时刻成交额",

  "paypal::setting::绑定账户": "绑定账户",
  "paypal::setting::编辑账户": "编辑账户",
  "paypal::setting::Paypal账户": "Paypal账户",
  "paypal::setting::Paypal账户_placeholder": "请输入PayPal账户",
  "paypal::setting::店铺": "店铺",
  "paypal::setting::店铺_placeholder": "请选择店铺",
  "paypal::setting::状态": "状态",
  "paypal::setting::状态_placeholder": "请选择状态",
  "paypal::setting::clientId_placeholder": "请输入Client_id",
  "paypal::setting::secret_placeholder": "请输入Secret",
  "paypal::setting::客户经理_placeholder": "请输入客户经理",
  "paypal::setting::企业名称": "企业名称",
  "paypal::setting::客户经理": "客户经理",
  "paypal::setting::操作": "操作",
  "paypal::setting::empty_title": "您尚未绑定支付账号",
  "paypal::setting::empty_tip": "绑定支付账户，关键信息秒知道",
  "paypal::setting::reAuth": "获取Paypal账户状态权限失效，点击",
  "paypal::setting::reAuth_btn": "重新授权",
  "paypal::setting::reEdit": "获取Paypal账户信息的client-id与Secret失效，点击",
  "paypal::setting::reEdit_btn": "重新修改",
  "paypal::setting::正常": "正常",
  "paypal::setting::不可提现": "不可提现",
  "paypal::setting::冻结": "冻结",
  "paypal::setting::不可收款": "不可收款",
  "paypal::setting::delete_title": "确认删除该paypal账户？",
  "paypal::setting::delete_tip": "删除后将不再拉取该paypal账户信息",
  "paypal::setting::查无数据": "查无数据",
  "paypal::setting::去绑定": "去绑定",
  "paypal::setting::client_error": "Client_id失效，请重新获取后填入",
  "paypal::setting::secret_error": "Secret失效，请重新获取后填入",
  "paypal::setting::handle_tip": "如何获取Paypal相关密钥？",
  "paypal::menu::支付账户设置": "支付账户设置",
  "paypal::monitor::总余额": "总余额",
  "paypal::monitor::总余额tip": "所有支付账号余额总和，含冻结+可提现金额",
  "paypal::monitor::可提现余额": "可提现余额",
  "paypal::monitor::可提现余额tip": "所有支付账号可提现金额总和",
  "paypal::monitor::冻结余额": "冻结余额",
  "paypal::monitor::冻结余额tip": "所有支付账号冻结金额总和",
  "paypal::monitor::正常账户": "正常账户",
  "paypal::monitor::正常账户tip": "状态正常的支付账号",
  "paypal::monitor::不可收款账户": "不可收款账户",
  "paypal::monitor::不可收款账户tip": "收款权限被官方禁止的账号",
  "paypal::monitor::个": "个",
  "paypal::monitor::Paypal账户": "Paypal账户",
  "paypal::monitor::店铺名称": "店铺名称",
  "paypal::monitor::日期": "日期",
  "paypal::monitor::tip": "更新频率：每10min更新一次",
  "paypal::monitor::header_tip": "*根据您的paypal账户收款货币按当日汇率自动统一换算为USD，余额未扣除paypal官方手续费，为真实账户余额",
  "paypal::monitor::总余额明细": "总余额明细",
  "paypal::monitor::冻结余额明细": "冻结余额明细",
  "paypal::monitor::可提现余额明细": "可提现余额明细",
  "paypal::monitor::全部账户": "全部账户",
  "paypal::monitor::店铺": "店铺",
  "paypal::monitor::企业名称": "企业名称",
  "paypal::monitor::状态": "状态",
  "paypal::monitor::客户经理": "客户经理",
  "paypal::monitor::download_tip": "暂无数据可导出",
  "menu::system-setting::param-setting::report-to-push": "报表推送",

}
